module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "044b":
/***/ (function(module, exports) {

module.exports = require("velocity-animate");

/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "0580":
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var regularTabbables = [];
  var orderedTabbables = [];

  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node) {
  if (
    !isNodeMatchingSelectorFocusable(node)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node);
}

function isNodeMatchingSelectorFocusable(node) {
  if (
    node.disabled
    || isHiddenInput(node)
    || isHidden(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

function isHidden(node) {
  // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
  // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
  return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "06f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToast_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f2f5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToast_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToast_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToast_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0728":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCheckbox_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f6cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCheckbox_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCheckbox_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCheckbox_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "129f":
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "14ad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1516":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var sloppyArrayMethod = __webpack_require__("b301");

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "18c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1960":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRadio_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("70b1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRadio_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRadio_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRadio_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1ed8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "243b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b712");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2fc0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3071":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "30bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaButton_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9719");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaButton_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaButton_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaButton_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "37ed":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3dfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDatepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18c2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDatepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDatepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDatepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var createNonEnumerableProperty = __webpack_require__("9112");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4713":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTabs_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("14ad");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTabs_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTabs_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTabs_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("e070");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined ? pattern
      : inheritIfRequired(CORRECT_NEW
        ? new NativeRegExp(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp((patternIsRegExp = pattern instanceof RegExpWrapper)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? getFlags.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var fails = __webpack_require__("d039");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].filter.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("f8c2");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "512a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "5395":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "53a8":
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ "55d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.8',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5793":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPagination_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df91");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPagination_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPagination_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPagination_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5b04":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5b53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDropdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f09");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDropdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDropdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaDropdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5bba":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5c87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaNotification_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7bc1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaNotification_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaNotification_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaNotification_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "60ae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("b39a");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "64b4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6728":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3071");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6b9f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6c89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaMinibar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("96eb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaMinibar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaMinibar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaMinibar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6c92":
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__("0580");
var xtend = __webpack_require__("53a8");

var activeFocusDelay;

var activeFocusTraps = (function() {
  var trapQueue = [];
  return {
    activateTrap: function(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },

    deactivateTrap: function(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
})();

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    clearTimeout(activeFocusDelay);

    removeListeners();
    state.active = false;
    state.paused = false;

    activeFocusTraps.deactivateTrap(trap);

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    updateTabbableNodes();
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    activeFocusDelay = delay(function() {
      tryFocus(getInitialFocusNode());
    });

    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });

    return trap;
  }

  function removeListeners() {
    if (!state.active) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        'Your focus-trap needs to have at least one focusable element'
      );
    }

    return node;
  }

  function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus');
    return node ? node : previousActiveElement;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
      return;
    }
    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (config.allowOutsideClick && config.allowOutsideClick(e)) {
      return;
    }
    e.preventDefault();
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    if (config.allowOutsideClick && config.allowOutsideClick(e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }
    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f09":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6fe2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLoading_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9172");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLoading_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLoading_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLoading_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "70b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("c032");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7704":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaProgressTracker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae53");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaProgressTracker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaProgressTracker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaProgressTracker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "773a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8c63");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "777d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaFilePicker_vue_vue_type_style_index_0_id_e6af6a5e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2fc0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaFilePicker_vue_vue_type_style_index_0_id_e6af6a5e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaFilePicker_vue_vue_type_style_index_0_id_e6af6a5e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaFilePicker_vue_vue_type_style_index_0_id_e6af6a5e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAppConfig_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d471");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAppConfig_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAppConfig_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAppConfig_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7bc1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "818b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAlert_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5b04");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAlert_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAlert_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAlert_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "841c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var sameValue = __webpack_require__("129f");
var regExpExec = __webpack_require__("14c3");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "8423":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaModal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a6ea");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaModal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaModal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaModal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "854e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "85ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSidebar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("64b4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSidebar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSidebar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaSidebar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8a79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8c63":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8cfc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9172":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "9268":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTimepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8cfc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTimepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTimepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTimepicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "93aa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRange_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad13");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRange_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRange_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRange_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "93ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTopbar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6728");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTopbar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTopbar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTopbar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "952c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5bba");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "96eb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9719":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("eae9");

// `String.prototype.link` method
// https://tc39.github.io/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9ace":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaColorPicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e03c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaColorPicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaColorPicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaColorPicker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c43":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9fbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBadge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a59f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBadge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBadge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBadge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a00e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTextarea_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("512a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTextarea_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTextarea_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTextarea_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a0d0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var sloppyArrayMethod = __webpack_require__("b301");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var SLOPPY_METHOD = sloppyArrayMethod('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || SLOPPY_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('splice') }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("c032");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = NATIVE_SYMBOL && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

if (!USE_SYMBOL_AS_UID) {
  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a59f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a6ea":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAffix_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("854e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAffix_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAffix_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAffix_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ad13":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ad9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5395");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ae53":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b14a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f2dd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b301":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "b357":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCollapse_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f9c9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCollapse_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCollapse_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaCollapse_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b712":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("f8c2");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "baa5":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var lastIndexOf = __webpack_require__("e58c");

// `Array.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "be2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBreadcrumb_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1ed8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBreadcrumb_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBreadcrumb_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaBreadcrumb_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c032":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c32d":
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "c3ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPageHeader_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c955");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPageHeader_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPageHeader_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPageHeader_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c531":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTooltip_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b9f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTooltip_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTooltip_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaTooltip_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c955":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var sloppyArrayMethod = __webpack_require__("b301");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || SLOPPY_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAside_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("55d6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAside_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAside_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaAside_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "cb99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggleIcon_vue_vue_type_style_index_0_id_f23f3648_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f350");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggleIcon_vue_vue_type_style_index_0_id_f23f3648_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggleIcon_vue_vue_type_style_index_0_id_f23f3648_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggleIcon_vue_vue_type_style_index_0_id_f23f3648_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc71":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("eae9");

// `String.prototype.bold` method
// https://tc39.github.io/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d471":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var fails = __webpack_require__("d039");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].map.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df91":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e03c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e070":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "e0eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLozenge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c43");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLozenge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLozenge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaLozenge_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e25e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var parseIntImplementation = __webpack_require__("e583");

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e583":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var trim = __webpack_require__("58a8").trim;
var whitespaces = __webpack_require__("5899");

var nativeParseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return nativeParseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : nativeParseInt;


/***/ }),

/***/ "e58c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var sloppyArrayMethod = __webpack_require__("b301");

var min = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('lastIndexOf');

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
module.exports = (NEGATIVE_ZERO || SLOPPY_METHOD) ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "eae9":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "eaec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggle_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("37ed");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggle_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggle_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaToggle_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ecb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRow_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1516");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRow_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRow_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaRow_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f2dd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f2f5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPlaceholder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a0d0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPlaceholder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPlaceholder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VaPlaceholder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f350":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f6cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8c2":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "f9c9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./src/relocate.js





var getWindowSize = function getWindowSize() {
  var ww = window.innerWidth;
  var wh = window.innerHeight;
  return {
    width: ww,
    height: wh
  };
};

var getPosition = function getPosition(el) {
  var rect = el.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    x: rect.x,
    y: rect.y
  };
};

var removeClassByPrefix = function removeClassByPrefix(el, prefix) {
  var regx = new RegExp('\\b' + prefix + '(.*)?\\b', 'g');
  el.className = el.className.replace(regx, '');
  return el;
};

var relocate = function relocate(el) {
  var pos = getPosition(el);
  var win = getWindowSize();
  var pos1 = 'right';
  var pos2 = 'bottom';

  if (pos.width + pos.left > win.width - 20) {
    pos1 = 'left';
  }

  if (pos.height + pos.top > win.height) {
    pos2 = 'top';
  }

  el.classList.add('position-' + pos1 + '-' + pos2);
};

/* harmony default export */ var src_relocate = ({
  componentUpdated: function componentUpdated(el, binding) {
    if (!binding.value) {
      setTimeout(function () {
        removeClassByPrefix(el, 'position-');
      }, 400);
      return;
    }

    if (binding.value !== binding.oldValue) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick(function () {
        relocate(el);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App/VaApp.vue?vue&type=template&id=1132c4c6&
var VaAppvue_type_template_id_1132c4c6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleObj)},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/App/VaApp.vue?vue&type=template&id=1132c4c6&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__("e25e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// CONCATENATED MODULE: ./src/utils/events.js



function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.name;

    if (name === componentName) {
      child.$emit(eventName, params);
    } else {
      _broadcast.call(child, componentName, eventName, params);
    }
  });
}

/* harmony default export */ var events = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }

      if (parent) {
        parent.$emit(eventName, params);
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App/VaApp.vue?vue&type=script&lang=js&



//
//
//
//
//
//

/* harmony default export */ var VaAppvue_type_script_lang_js_ = ({
  name: 'VaApp',
  mixins: [events],
  props: {
    desktopSidebarWidth: {
      type: [Number, String],
      default: 0,
      required: false
    },
    desktopMinibarWidth: {
      type: [Number, String],
      default: 0,
      required: false
    },
    desktopTopbarHeight: {
      type: [Number, String],
      default: 0,
      required: false
    },
    mobileBreakpoint: {
      type: Number,
      default: 768,
      required: false
    },
    mobileSidebarWidth: {
      type: [Number, String],
      default: 0,
      required: false
    },
    mobileMinibarWidth: {
      type: [Number, String],
      default: 0,
      required: false
    },
    mobileTopbarHeight: {
      type: [Number, String],
      default: 0,
      required: false
    },
    rtl: {
      type: Boolean,
      default: false
    },
    sidebarPriority: {
      type: Boolean,
      default: false,
      required: false
    },
    minibarPriority: {
      type: Boolean,
      default: false,
      required: false
    },
    topbarPriority: {
      type: Boolean,
      default: false,
      required: false
    },
    topbarPadded: {
      type: Boolean,
      default: false,
      required: false
    },
    split: {
      type: Boolean,
      default: false,
      required: false
    },
    reverse: {
      type: Boolean,
      default: false,
      required: false
    },
    desktopMargin: {
      type: [Number, String],
      default: 0,
      required: false
    },
    desktopMinimumWidth: {
      type: [Number, String],
      default: 0,
      required: false
    },
    bgColor: {
      type: String,
      default: '#F4F5F7',
      required: false
    },
    pageBgColor: {
      type: String,
      default: '#FFFFFF',
      required: false
    },
    showToggle: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    var dDesktopMinimumWidth = this.desktopMinimumWidth;
    var dDesktopTopbarHeight = this.desktopTopbarHeight;
    var dDesktopMinibarWidth = this.desktopMinibarWidth;
    var dDesktopSidebarWidth = this.desktopSidebarWidth;
    var dMobileSidebarWidth = this.mobileSidebarWidth;
    var dMobileMinibarWidth = this.mobileMinibarWidth;
    var dMobileTopbarHeight = this.mobileTopbarHeight;
    var dSidebarPriority = this.sidebarPriority;
    var dMinibarPriority = this.minibarPriority;
    var currDesktopMargin = this.desktopMargin;
    var dTopbarPriority = this.topbarPriority;
    var dDesktopMargin = this.desktopMargin;
    var dTopbarPadded = this.topbarPadded;
    var dPageBgColor = this.pageBgColor;
    var dShowToggle = this.showToggle;
    var dReverse = this.reverse;
    var dBgColor = this.bgColor;
    var dSplit = this.split;
    var dRtl = this.rtl;
    return {
      mDesktopTopbarHeight: dDesktopTopbarHeight,
      mDesktopMinimumWidth: dDesktopMinimumWidth,
      mDesktopSidebarWidth: dDesktopSidebarWidth,
      mDesktopMinibarWidth: dDesktopMinibarWidth,
      mMobileSidebarWidth: dMobileSidebarWidth,
      mMobileMinibarWidth: dMobileMinibarWidth,
      mMobileTopbarHeight: dMobileTopbarHeight,
      currentDesktopMargin: currDesktopMargin,
      mMinibarPriority: dMinibarPriority,
      mSidebarPriority: dSidebarPriority,
      mTopbarPriority: dTopbarPriority,
      mDesktopMargin: dDesktopMargin,
      mTopbarPadded: dTopbarPadded,
      pastMobileBreakpoint: false,
      mPageBgColor: dPageBgColor,
      mShowToggle: dShowToggle,
      allowMarginUpdates: true,
      currentTopbarHeight: 0,
      currentSidebarWidth: 0,
      currentMinibarWidth: 0,
      mSidebarTheme: 'blue',
      mMinibarTheme: 'blue',
      mTopbarTheme: 'blue',
      mReverse: dReverse,
      mBgColor: dBgColor,
      haveSidebar: false,
      haveMinibar: false,
      mTextLinks: false,
      haveTopbar: false,
      mCompact: false,
      isMobile: false,
      havePage: false,
      contentWidth: 0,
      mPageSize: 'md',
      mSplit: dSplit,
      windowWidth: 0,
      mRtl: dRtl
    };
  },
  watch: {
    pastMobileBreakpoint: function pastMobileBreakpoint(val) {
      this.broadcastIsMobile(val);
      this.setAndBroadcastDimensions();
    },
    desktopSidebarWidth: function desktopSidebarWidth(val) {
      this.mDesktopSidebarWidth = val;
    },
    mDesktopSidebarWidth: function mDesktopSidebarWidth() {
      this.setAndBroadcastDimensions();
    },
    desktopMinibarWidth: function desktopMinibarWidth(val) {
      this.mDesktopMinibarWidth = val;
    },
    mDesktopMinibarWidth: function mDesktopMinibarWidth() {
      this.setAndBroadcastDimensions();
    },
    desktopTopbarHeight: function desktopTopbarHeight(val) {
      this.mDesktopTopbarHeight = val;
    },
    mDesktopTopbarHeight: function mDesktopTopbarHeight() {
      this.setAndBroadcastDimensions();
    },
    mobileSidebarWidth: function mobileSidebarWidth(val) {
      this.mMobileSidebarWidth = val;
    },
    mMobileSidebarWidth: function mMobileSidebarWidth() {
      this.setAndBroadcastDimensions();
    },
    mobileMinibarWidth: function mobileMinibarWidth(val) {
      this.mMobileMinibarWidth = val;
    },
    mMobileMinibarWidth: function mMobileMinibarWidth() {
      this.setAndBroadcastDimensions();
    },
    mobileTopbarHeight: function mobileTopbarHeight(val) {
      this.mMobileTopbarHeight = val;
    },
    mMobileTopbarHeight: function mMobileTopbarHeight() {
      this.setAndBroadcastDimensions();
    },
    rtl: function rtl(val) {
      this.mRtl = val;
    },
    mRtl: function mRtl(val) {
      this.broadcastIsRTL(val);
    },
    sidebarPriority: function sidebarPriority(val) {
      this.mSidebarPriority = val;
    },
    mSidebarPriority: function mSidebarPriority(val) {
      this.broadcastSidebarPriority(val);
    },
    minibarPriority: function minibarPriority(val) {
      this.mMinibarPriority = val;
    },
    mMinibarPriority: function mMinibarPriority(val) {
      this.broadcastMinibarPriority(val);
    },
    topbarPriority: function topbarPriority(val) {
      this.mTopbarPriority = val;
    },
    mTopbarPriority: function mTopbarPriority(val) {
      this.broadcastTopbarPriority(val);
    },
    topbarPadded: function topbarPadded(val) {
      this.mTopbarPadded = val;
    },
    mTopbarPadded: function mTopbarPadded(val) {
      this.broadcastTopbarPadded(val);
    },
    bgColor: function bgColor(val) {
      this.mBgColor = val;
    },
    mBgColor: function mBgColor(val) {
      this.broadcastBgColor(val);
    },
    pageBgColor: function pageBgColor(val) {
      this.mPageBgColor = val;
    },
    mPageBgColor: function mPageBgColor(val) {
      this.broadcastPageBgColor(val);
    },
    split: function split(val) {
      this.mSplit = val;
    },
    mSplit: function mSplit(val) {
      this.broadcastIsSplit(val);
    },
    reverse: function reverse(val) {
      this.mReverse = val;
    },
    mReverse: function mReverse(val) {
      this.broadcastIsReverse(val);
    },
    mCompact: function mCompact(val) {
      this.broadcastCompact(val);
    },
    mTextLinks: function mTextLinks(val) {
      this.broadcastTextLinks(val);
    },
    showToggle: function showToggle(val) {
      this.mShowToggle = val;
    },
    mShowToggle: function mShowToggle(val) {
      this.broadcastShowToggle(val);
    },
    desktopMargin: function desktopMargin(val) {
      this.mDesktopMargin = val;
    },
    mDesktopMargin: function mDesktopMargin(val) {
      /**
       * Calling _handleResize here. Why? So a new contentWidth
       * is calculated and broadcasted.
       */
      this._handleResize();

      this.broadcastDesktopMargin(val);
    },
    desktopMinimumWidth: function desktopMinimumWidth(val) {
      this.mDesktopMinimumWidth = val;
    },
    mDesktopMinimumWidth: function mDesktopMinimumWidth(val) {
      this.broadcastDesktopMinimumWidth(val);
    },
    windowWidth: function windowWidth(val) {
      this.broadcastWindowWidth(val);
    },
    contentWidth: function contentWidth(val) {
      this.broadcastContentWidth(val);
    },
    allowMarginUpdates: function allowMarginUpdates(val) {
      this.broadcastAllowMarginUpdates(val);
    },
    mPageSize: function mPageSize(val) {
      this.broadcastPageSize(val);
    },
    topbarTheme: function topbarTheme(val) {
      this.mTopbarTheme = val;
    },
    mTopbarTheme: function mTopbarTheme(val) {
      this.broadcastTopbarTheme(val);
    },
    minibarTheme: function minibarTheme(val) {
      this.mMinibarTheme = val;
    },
    mMinibarTheme: function mMinibarTheme(val) {
      this.broadcastMinibarTheme(val);
    },
    sidebarTheme: function sidebarTheme(val) {
      this.mSidebarTheme = val;
    },
    mSidebarTheme: function mSidebarTheme(val) {
      this.broadcastSidebarTheme(val);
    }
  },
  methods: {
    _handleResize: function _handleResize() {
      var ww = window.innerWidth || document.body.clientWidth;

      if (parseInt(ww) < this.mobileBreakpoint) {
        this.pastMobileBreakpoint = true;
      } else {
        this.pastMobileBreakpoint ? this.pastMobileBreakpoint = false : true;
      }

      this.windowWidth = parseInt(ww);
      this.contentWidth = this.windowWidth - this.mDesktopMargin * 2;
    },
    broadcastSidebarWidth: function broadcastSidebarWidth(val) {
      this.broadcast('VaSidebar', 'Va@sidebarWidthChange', val);
      this.broadcast('VaMinibar', 'Va@sidebarWidthChange', val);
      this.broadcast('VaTopbar', 'Va@sidebarWidthChange', val);
      this.broadcast('VaPage', 'Va@sidebarWidthChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastMinibarWidth: function broadcastMinibarWidth(val) {
      this.broadcast('VaSidebar', 'Va@minibarWidthChange', val);
      this.broadcast('VaMinibar', 'Va@minibarWidthChange', val);
      this.broadcast('VaTopbar', 'Va@minibarWidthChange', val);
      this.broadcast('VaPage', 'Va@minibarWidthChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastTopbarHeight: function broadcastTopbarHeight(val) {
      this.broadcast('VaSidebar', 'Va@topbarHeightChange', val);
      this.broadcast('VaMinibar', 'Va@topbarHeightChange', val);
      this.broadcast('VaTopbar', 'Va@topbarHeightChange', val);
      this.broadcast('VaPage', 'Va@topbarHeightChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastIsMobile: function broadcastIsMobile(val) {
      this.broadcast('VaSidebar', 'Va@sidebarIsMobile', val);
      this.broadcast('VaMinibar', 'Va@minibarIsMobile', val);
      this.broadcast('VaTopbar', 'Va@topbarIsMobile', val);
      this.broadcast('VaPage', 'Va@pageIsMobile', val);
      this.broadcast('VaRange', 'Va@rangeIsMobile', val);
      this.broadcast('VaMobile', 'Va@mobileIsMobile', val);
      this.broadcast('VaDesktop', 'Va@desktopIsMobile', val);
      this.broadcast('VaDatepicker', 'Va@datepickerIsMobile', val);
      this.broadcast('VaTimepicker', 'Va@timepickerIsMobile', val);
    },
    broadcastIsRTL: function broadcastIsRTL(val) {
      this.broadcast('VaSidebar', 'Va@rtlChange', val);
      this.broadcast('VaMinibar', 'Va@rtlChange', val);
      this.broadcast('VaTopbar', 'Va@rtlChange', val);
      this.broadcast('VaPage', 'Va@rtlChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastIsSplit: function broadcastIsSplit(val) {
      this.broadcast('VaSidebar', 'Va@splitChange', val);
      this.broadcast('VaMinibar', 'Va@splitChange', val);
      this.broadcast('VaTopbar', 'Va@splitChange', val);
      this.broadcast('VaPage', 'Va@splitChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastCompact: function broadcastCompact(val) {
      this.broadcast('VaSidebar', 'Va@compactChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastTextLinks: function broadcastTextLinks(val) {
      this.broadcast('VaSidebar', 'Va@textLinksChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastShowToggle: function broadcastShowToggle(val) {
      this.broadcast('VaSidebar', 'Va@showToggleChange', val);
      this.broadcast('VaSidebarGroupItem', 'Va@showToggleChange', val);
      this.broadcast('VaSidebarGroupLevel', 'Va@showToggleChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastBgColor: function broadcastBgColor() {
      /**
       * Nobody needs to know about BgColor.
       * Only relevant to this component.
       */
      this.broadcastDefaultsToConfig(0);
    },
    broadcastPageBgColor: function broadcastPageBgColor(val) {
      this.broadcast('VaPage', 'Va@pageBgColorChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastIsReverse: function broadcastIsReverse(val) {
      this.broadcast('VaSidebar', 'Va@reverseChange', val);
      this.broadcast('VaMinibar', 'Va@reverseChange', val);
      this.broadcast('VaTopbar', 'Va@reverseChange', val);
      this.broadcast('VaPage', 'Va@reverseChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastSidebarPriority: function broadcastSidebarPriority(val) {
      this.broadcast('VaSidebar', 'Va@sidebarPriorityChange', val);
      this.broadcast('VaMinibar', 'Va@sidebarPriorityChange', val);
      this.broadcast('VaTopbar', 'Va@sidebarPriorityChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastMinibarPriority: function broadcastMinibarPriority(val) {
      this.broadcast('VaSidebar', 'Va@minibarPriorityChange', val);
      this.broadcast('VaMinibar', 'Va@minibarPriorityChange', val);
      this.broadcast('VaTopbar', 'Va@minibarPriorityChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastTopbarPriority: function broadcastTopbarPriority(val) {
      this.broadcast('VaSidebar', 'Va@topbarPriorityChange', val);
      this.broadcast('VaMinibar', 'Va@topbarPriorityChange', val);
      this.broadcast('VaTopbar', 'Va@topbarPriorityChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastTopbarPadded: function broadcastTopbarPadded(val) {
      this.broadcast('VaTopbar', 'Va@topbarPaddedChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastDesktopMargin: function broadcastDesktopMargin(val) {
      this.broadcast('VaSidebar', 'Va@desktopMarginChange', val);
      this.broadcast('VaMinibar', 'Va@desktopMarginChange', val);
      this.broadcast('VaTopbar', 'Va@desktopMarginChange', val);
      this.broadcast('VaPage', 'Va@desktopMarginChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastDesktopMinimumWidth: function broadcastDesktopMinimumWidth(val) {
      this.broadcast('VaSidebar', 'Va@desktopMinimumWidthChange', val);
      this.broadcast('VaMinibar', 'Va@desktopMinimumWidthChange', val);
      this.broadcast('VaTopbar', 'Va@desktopMinimumWidthChange', val);
      this.broadcast('VaPage', 'Va@desktopMinimumWidthChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastAllowMarginUpdates: function broadcastAllowMarginUpdates() {},
    broadcastWindowWidth: function broadcastWindowWidth(val) {
      this.broadcast('VaSidebar', 'Va@windowWidthChange', val);
      this.broadcast('VaMinibar', 'Va@windowWidthChange', val);
      this.broadcast('VaTopbar', 'Va@windowWidthChange', val);
      this.broadcast('VaPage', 'Va@windowWidthChange', val);
    },
    broadcastContentWidth: function broadcastContentWidth(val) {
      this.broadcast('VaSidebar', 'Va@contentWidthChange', val);
      this.broadcast('VaMinibar', 'Va@contentWidthChange', val);
      this.broadcast('VaTopbar', 'Va@contentWidthChange', val);
      this.broadcast('VaPage', 'Va@contentWidthChange', val);
    },
    broadcastPageSize: function broadcastPageSize(val) {
      this.broadcast('VaPage', 'Va@pageSizeChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastTopbarTheme: function broadcastTopbarTheme(val) {
      this.broadcast('VaTopbar', 'Va@topbarThemeChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastSidebarTheme: function broadcastSidebarTheme(val) {
      this.broadcast('VaSidebar', 'Va@sidebarThemeChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    broadcastMinibarTheme: function broadcastMinibarTheme(val) {
      this.broadcast('VaMinibar', 'Va@minibarThemeChange', val);
      this.broadcastDefaultsToConfig(0);
    },
    checkForPresenceOfTopbar: function checkForPresenceOfTopbar() {
      this.broadcast('VaTopbar', 'Va@topbarPresenceCheck', true);
    },
    checkForPresenceOfSidebar: function checkForPresenceOfSidebar() {
      this.broadcast('VaSidebar', 'Va@sidebarPresenceCheck', true);
    },
    checkForPresenceOfMinibar: function checkForPresenceOfMinibar() {
      this.broadcast('VaMinibar', 'Va@minibarPresenceCheck', true);
    },
    checkForPresenceOfPage: function checkForPresenceOfPage() {
      this.broadcast('VaPage', 'Va@pagePresenceCheck', true);
    },
    setAndBroadcastDimensions: function setAndBroadcastDimensions() {
      if (this.pastMobileBreakpoint) {
        this.currentTopbarHeight = this.mMobileTopbarHeight;
        this.currentMinibarWidth = this.mMobileMinibarWidth;
        this.currentSidebarWidth = this.mMobileSidebarWidth;
      } else {
        this.currentTopbarHeight = this.mDesktopTopbarHeight;
        this.currentMinibarWidth = this.mDesktopMinibarWidth;
        this.currentSidebarWidth = this.mDesktopSidebarWidth;
      }

      this.broadcastSidebarWidth(this.currentSidebarWidth);
      this.broadcastMinibarWidth(this.currentMinibarWidth);
      this.broadcastTopbarHeight(this.currentTopbarHeight);
    },
    enableReceivers: function enableReceivers() {
      var _this = this;

      /**
       * These exist for VaAppConfig.
       *
       * Setting these values should trigger the 'watch' on each of them,
       * which in turn calls the value's respective broadcast function,
       * broadcasting the new value to whatever has implemented an
       * App.
       */
      this.$on('Va@configDesktopTopbarHeightChange', function (val) {
        _this.mDesktopTopbarHeight = val;
      });
      this.$on('Va@configDesktopSidebarWidthChange', function (val) {
        _this.mDesktopSidebarWidth = val;
      });
      this.$on('Va@configDesktopMinimumWidthChange', function (val) {
        _this.mDesktopMinimumWidth = val;
      });
      this.$on('Va@configDesktopMinibarWidthChange', function (val) {
        _this.mDesktopMinibarWidth = val;
      });
      this.$on('Va@configMobileTopbarHeightChange', function (val) {
        _this.mMobileTopbarHeight = val;
      });
      this.$on('Va@configMobileSidebarWidthChange', function (val) {
        _this.mMobileSidebarWidth = val;
      });
      this.$on('Va@configMobileMinibarWidthChange', function (val) {
        _this.mMobileMinibarWidth = val;
      });
      this.$on('Va@configSidebarPriorityChange', function (val) {
        _this.mSidebarPriority = val;
      });
      this.$on('Va@configMinibarPriorityChange', function (val) {
        _this.mMinibarPriority = val;
      });
      this.$on('Va@configTopbarPriorityChange', function (val) {
        _this.mTopbarPriority = val;
      });
      this.$on('Va@configDesktopMarginChange', function (val) {
        _this.mDesktopMargin = val;
      });
      this.$on('Va@configTopbarPaddedChange', function (val) {
        _this.mTopbarPadded = val;
      });
      this.$on('Va@configMinibarThemeChange', function (val) {
        _this.mMinibarTheme = val;
      });
      this.$on('Va@configSidebarThemeChange', function (val) {
        _this.mSidebarTheme = val;
      });
      this.$on('Va@configTopbarThemeChange', function (val) {
        _this.mTopbarTheme = val;
      });
      this.$on('Va@configPageBgColorChange', function (val) {
        _this.mPageBgColor = val;
      });
      this.$on('Va@configShowToggleChange', function (val) {
        _this.mShowToggle = val;
      });
      this.$on('Va@configTextLinksChange', function (val) {
        _this.mTextLinks = val;
      });
      this.$on('Va@configPageSizeChange', function (val) {
        _this.mPageSize = val;
      });
      this.$on('Va@configCompactChange', function (val) {
        _this.mCompact = val;
      });
      this.$on('Va@configReverseChange', function (val) {
        _this.mReverse = val;
      });
      this.$on('Va@configBgColorChange', function (val) {
        _this.mBgColor = val;
      });
      this.$on('Va@configSplitChange', function (val) {
        _this.mSplit = val;
      });
      this.$on('Va@configRtlChange', function (val) {
        _this.mRtl = val;
      });
      /**
       * These receives are for when certain components are unmounted
       * and remounted at runtime (during HMR usually).
       */

      this.$on('Va@pageConnected', function () {
        _this.setAndBroadcastDimensions();
      });
      this.$on('Va@minibarConnected', function () {
        _this.setAndBroadcastDimensions();
      });
      this.$on('Va@sidebarConnected', function () {
        _this.setAndBroadcastDimensions();
      });
    },
    broadcastDefaultsToConfig: function broadcastDefaultsToConfig() {
      var _this2 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
      setTimeout(function () {
        _this2.broadcast('VaAppConfig', 'Va@configReceiveDesktopTopbarHeight', _this2.mDesktopTopbarHeight);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveDesktopMinibarWidth', _this2.mDesktopMinibarWidth);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveDesktopSidebarWidth', _this2.mDesktopSidebarWidth);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveDesktopMinimumWidth', _this2.mDesktopMinimumWidth);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveMobileMinibarWidth', _this2.mMobileMinibarWidth);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveMobileSidebarWidth', _this2.mMobileSidebarWidth);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveMobileTopbarHeight', _this2.mMobileTopbarHeight);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveSidebarPriority', _this2.mSidebarPriority);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveMinibarPriority', _this2.mMinibarPriority);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveTopbarPriority', _this2.mTopbarPriority);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveDesktopMargin', _this2.mDesktopMargin);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveTopbarPadded', _this2.mTopbarPadded);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveMinibarTheme', _this2.mMinibarTheme);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveSidebarTheme', _this2.mSidebarTheme);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveTopbarTheme', _this2.mTopbarTheme);

        _this2.broadcast('VaAppConfig', 'Va@configReceivePageBgColor', _this2.mPageBgColor);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveShowToggle', _this2.mShowToggle);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveTextLinks', _this2.mTextLinks);

        _this2.broadcast('VaAppConfig', 'Va@configReceivePageSize', _this2.mPageSize);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveCompact', _this2.mCompact);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveReverse', _this2.mReverse);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveBgColor', _this2.mBgColor);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveSplit', _this2.mSplit);

        _this2.broadcast('VaAppConfig', 'Va@configReceiveRtl', _this2.mRtl);
      }, delay);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this._handleResize, false);
    /**
     * Call the handler function directly instead of instantiating a resize
     * event like so: window.dispatchEvent(new Event('resize'))
     *
     * Benefit is.. ? Browser compatibility? I dunno.
     */

    this._handleResize();
    /**
     * Mobility check.
     */


    this.setAndBroadcastDimensions();
    /**
     * Presence checks. As of now, this is not really used for
     * anything. Maybe in the future?
     */

    this.checkForPresenceOfSidebar();
    this.checkForPresenceOfTopbar();
    this.checkForPresenceOfPage();
    /**
     * Broadcast props that were passed to the components
     * that need to do stuff based on their values.
     */

    this.broadcastDesktopMinimumWidth(this.mDesktopMinimumWidth);
    this.broadcastMinibarPriority(this.mMinibarPriority);
    this.broadcastSidebarPriority(this.mSidebarPriority);
    this.broadcastTopbarPriority(this.mTopbarPriority);
    this.broadcastDesktopMargin(this.mDesktopMargin);
    this.broadcastTopbarPadded(this.mTopbarPadded);
    this.broadcastContentWidth(this.contentWidth);
    this.broadcastPageBgColor(this.mPageBgColor);
    this.broadcastWindowWidth(this.windowWidth);
    this.broadcastShowToggle(this.mShowToggle);
    this.broadcastTextLinks(this.mTextLinks);
    this.broadcastIsReverse(this.mReverse);
    this.broadcastCompact(this.mCompact);
    this.broadcastIsSplit(this.mSplit);
    this.broadcastIsRTL(this.mRtl);
    /**
     * --------------------------------------------------
     * Methods related to VaAppConfig
     *
     * enableReceivers() exists so that VaAppConfig
     * can talk to VaApp.
     */

    this.enableReceivers();
    /**
     * broadcastDefaultsToConfig() sends default values to
     * VaAppConfig, in case some values weren't specified.
     */

    this.broadcastDefaultsToConfig();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this._handleResize, false);
  },
  created: function created() {
    var _this3 = this;

    // Presence replies
    this.$on('Va@minibarPresenceReply', function (val) {
      if (val === true) {
        _this3.haveMinibar = true;
      }
    });
    this.$on('Va@sidebarPresenceReply', function (val) {
      if (val === true) {
        _this3.haveSidebar = true;
      }
    });
    this.$on('Va@topbarPresenceReply', function (val) {
      if (val === true) {
        _this3.haveTopbar = true;
      }
    });
    this.$on('Va@pagePresenceReply', function (val) {
      if (val === true) {
        _this3.havePage = true;
      }
    }); // Listen for Sidebar width change - implemented when Sidebar's resizer was implemented
    // this.$on('Va@sidebarWidthChange', (val) => {
    //   this.broadcastSidebarWidth(val)
    // })
    // Some components might want to request the isMobile status, for example,
    // if they have been created a while after isMobile was broadcast.
    // See VaRange.

    this.$on('Va@requestIsMobile', function (val) {
      if (val === true) {
        _this3.broadcastIsMobile(_this3.pastMobileBreakpoint);
      }
    }); // Disconnections

    this.$on('Va@sidebarDisconnect', function (val) {
      if (val === true) {
        _this3.haveSidebar = false;
      }
    });
    this.$on('Va@minibarDisconnect', function (val) {
      if (val === true) {
        _this3.haveMinibar = false;
      }
    });
    this.$on('Va@topbarDisconnect', function (val) {
      if (val === true) {
        _this3.haveTopbar = false;
      }
    });
    this.$on('Va@pageDisconnect', function (val) {
      if (val === true) {
        _this3.havePage = false;
      }
    });
  },
  computed: {
    styleObj: function styleObj() {
      var bg = this.mBgColor;
      var style = {};
      style['background'] = bg;
      style['position'] = 'fixed';
      style['top'] = '0px';
      style['right'] = '0px';
      style['bottom'] = '0px';
      style['left'] = '0px';
      style['overflow'] = 'auto';
      return style;
    }
  }
});
// CONCATENATED MODULE: ./src/App/VaApp.vue?vue&type=script&lang=js&
 /* harmony default export */ var App_VaAppvue_type_script_lang_js_ = (VaAppvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/App/VaApp.vue





/* normalize component */

var component = normalizeComponent(
  App_VaAppvue_type_script_lang_js_,
  VaAppvue_type_template_id_1132c4c6_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaApp = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tabs/VaTab.vue?vue&type=template&id=a5bc56c8&
var VaTabvue_type_template_id_a5bc56c8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],attrs:{"id":_vm.hash}},[_vm._t("default")],2)}
var VaTabvue_type_template_id_a5bc56c8_staticRenderFns = []


// CONCATENATED MODULE: ./src/Tabs/VaTab.vue?vue&type=template&id=a5bc56c8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tabs/VaTab.vue?vue&type=script&lang=js&



//
//
//
//
//
//
/* harmony default export */ var VaTabvue_type_script_lang_js_ = ({
  name: 'VaTab',
  props: {
    id: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isActive: false,
      isVisible: true
    };
  },
  computed: {
    header: function header() {
      return this.name;
    },
    hash: function hash() {
      if (this.isDisabled) {
        return '#';
      }

      return this.id ? '#' + this.id : '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
  }
});
// CONCATENATED MODULE: ./src/Tabs/VaTab.vue?vue&type=script&lang=js&
 /* harmony default export */ var Tabs_VaTabvue_type_script_lang_js_ = (VaTabvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Tabs/VaTab.vue





/* normalize component */

var VaTab_component = normalizeComponent(
  Tabs_VaTabvue_type_script_lang_js_,
  VaTabvue_type_template_id_a5bc56c8_render,
  VaTabvue_type_template_id_a5bc56c8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTab = (VaTab_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaRow.vue?vue&type=template&id=43c8ad06&
var VaRowvue_type_template_id_43c8ad06_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-row",style:(_vm.styles)},[_vm._t("default")],2)}
var VaRowvue_type_template_id_43c8ad06_staticRenderFns = []


// CONCATENATED MODULE: ./src/Grid/VaRow.vue?vue&type=template&id=43c8ad06&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaRow.vue?vue&type=script&lang=js&


//
//
//
//
//
//
/* harmony default export */ var VaRowvue_type_script_lang_js_ = ({
  name: 'VaRow',
  props: {
    gutter: {
      type: Number,
      default: 0
    }
  },
  computed: {
    styles: function styles() {
      var _this = this;

      var ret = {};
      var half = Math.floor(this.gutter / 2);
      ret.marginLeft = ret.marginRight = "".concat(-half, "px");
      this.$nextTick(function () {
        _this.$children.forEach(function (children) {
          children.$el.style.paddingLeft = children.$el.style.paddingRight = "".concat(half, "px");
          children.$el.style.marginBottom = _this.gutter + 'px';
        });
      });
      return ret;
    }
  }
});
// CONCATENATED MODULE: ./src/Grid/VaRow.vue?vue&type=script&lang=js&
 /* harmony default export */ var Grid_VaRowvue_type_script_lang_js_ = (VaRowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Grid/VaRow.vue?vue&type=style&index=0&lang=scss&
var VaRowvue_type_style_index_0_lang_scss_ = __webpack_require__("ecb3");

// CONCATENATED MODULE: ./src/Grid/VaRow.vue






/* normalize component */

var VaRow_component = normalizeComponent(
  Grid_VaRowvue_type_script_lang_js_,
  VaRowvue_type_template_id_43c8ad06_render,
  VaRowvue_type_template_id_43c8ad06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaRow = (VaRow_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Page/VaPage.vue?vue&type=template&id=5264e07c&
var VaPagevue_type_template_id_5264e07c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-page-wrapper",style:(_vm.wrapperStyleObj),on:{"scroll":_vm.onScroll}},[_c('div',{class:"va-page-container",style:(_vm.containerStyleObj)},[_c('div',{class:_vm.classObj},[_vm._t("default"),_c('div',{staticStyle:{"height":"100px"}})],2)])])}
var VaPagevue_type_template_id_5264e07c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Page/VaPage.vue?vue&type=template&id=5264e07c&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Page/VaPage.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaPagevue_type_script_lang_js_ = ({
  name: 'VaPage',
  mixins: [events],
  props: {
    size: {
      type: String,
      default: 'lg',
      validator: function validator(v) {
        return ['lg', 'md', 'sm'].includes(v);
      }
    },
    article: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var s = this.size;
    return {
      currentDesktopMinimumWidth: 0,
      currentSidebarWidth: 0,
      currentMinibarWidth: 0,
      currentDesktopMargin: 0,
      currentTopbarHeight: 0,
      currentContentWidth: 0,
      currentWindowWidth: 0,
      isReverse: false,
      isMobile: false,
      isSplit: false,
      isRTL: false,
      bg: '#ffffff',
      sz: s
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.dispatch('VaApp', 'Va@pageConnected', true);
    setTimeout(function () {
      _this.dispatch('VaApp', 'Va@configPageSizeChange', _this.sz);
    }, 10);
  },
  created: function created() {
    var _this2 = this;

    this.$on('Va@pagePresenceCheck', function () {
      _this2.dispatch('VaApp', 'Va@pagePresenceReply', true);
    });
    this.$on('Va@desktopMinimumWidthChange', function (val) {
      _this2.currentDesktopMinimumWidth = val;
    });
    this.$on('Va@desktopMarginChange', function (val) {
      _this2.currentDesktopMargin = val;
    });
    this.$on('Va@sidebarWidthChange', function (val) {
      _this2.currentSidebarWidth = val;
    });
    this.$on('Va@topbarHeightChange', function (val) {
      _this2.currentTopbarHeight = val;
    });
    this.$on('Va@contentWidthChange', function (val) {
      _this2.currentContentWidth = val;
    });
    this.$on('Va@minibarWidthChange', function (val) {
      _this2.currentMinibarWidth = val;
    });
    this.$on('Va@windowWidthChange', function (val) {
      _this2.currentWindowWidth = val;
    });
    this.$on('Va@reverseChange', function (val) {
      _this2.isReverse = val;
    });
    this.$on('Va@pageIsMobile', function (val) {
      _this2.isMobile = val;
    });
    this.$on('Va@pageBgColorChange', function (val) {
      _this2.bg = val;
    });
    this.$on('Va@splitChange', function (val) {
      _this2.isSplit = val;
    });
    this.$on('Va@pageSizeChange', function (val) {
      _this2.sz = val;
    });
    this.$on('Va@rtlChange', function (val) {
      _this2.isRTL = val;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('VaApp', 'Va@pageDisconnect', true);
  },
  methods: {
    onScroll: function onScroll() {
      // this.broadcast('VaTextarea', 'Va@pageScroll', true)
      // this.broadcast('VaInput', 'Va@pageScroll', true)

      /**
       * This is probably faster than my broadcast method, and I'd
       * like for this to happen as fast as possible.
       *
       * We're dispatching this scroll event when this element
       * is scrolled so that the VaInputOps (and other fixed
       * position elements) know to reposition themselves.
       *
       * When a VaPage is not used, VaInput and VaTextarea
       * listen to window events, so they still work even when
       * used by themselves.
       */
      window.dispatchEvent(new Event('scroll'));
    }
  },
  computed: {
    classObj: function classObj() {
      var sz = this.sz,
          article = this.article,
          isMobile = this.isMobile;
      var classes = {};
      isMobile ? classes['va-page-container-lg'] = true : classes['va-page-container-' + sz] = true;
      classes['va-page-container-article'] = article;
      return classes;
    },
    containerStyleObj: function containerStyleObj() {
      var style = {};
      return style;
    },
    wrapperStyleObj: function wrapperStyleObj() {
      var split = this.isSplit;
      var rtl = this.isRTL;
      var reverse = this.isReverse;
      var bg = this.bg;
      var style = {};
      var sw = parseInt(this.currentSidebarWidth);
      var mw = parseInt(this.currentMinibarWidth);
      var th = parseInt(this.currentTopbarHeight);
      var dm = parseInt(this.currentDesktopMargin);
      var dmw = parseInt(this.currentDesktopMinimumWidth);
      var cw = parseInt(this.currentContentWidth);
      var mobile = this.isMobile;
      style['background'] = bg;
      style['position'] = 'fixed';
      style['top'] = th + 'px';
      style['height'] = 'calc(100% - ' + th + 'px)';
      style['overflow-y'] = 'scroll';
      style['overflow-x'] = 'auto';
      /**
       * Adjust the margins if content width is smaller than
       * desktop minimum width.
       */

      if (!mobile) {
        if (cw < dmw) {
          var x = dmw - cw;
          dm = dm - x / 2;
        }
      } else {
        dm = 0;
        dmw = 0;
      }
      /**
       * If a minimum desktop width is set...
       */


      if (dmw !== 0) {
        style['min-width'] = dmw - mw - sw + 'px';
      } else {
        style['min-width'] = '0px';
      }
      /**
       * If it's not a split layout, then Page is only
       * concerned with the total width of the bars.
       */


      if (!split) {
        if (rtl) {
          style['left'] = dm + 'px';
          style['right'] = sw + mw + dm + 'px';
        } else {
          style['left'] = sw + mw + dm + 'px';
          style['right'] = dm + 'px';
        }
      } else {
        if (reverse) {
          style['left'] = dm + sw + 'px';
          style['right'] = dm + mw + 'px';
        } else {
          style['left'] = dm + mw + 'px';
          style['right'] = dm + sw + 'px';
        }
      }

      return style;
    }
  }
});
// CONCATENATED MODULE: ./src/Page/VaPage.vue?vue&type=script&lang=js&
 /* harmony default export */ var Page_VaPagevue_type_script_lang_js_ = (VaPagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Page/VaPage.vue?vue&type=style&index=0&lang=scss&
var VaPagevue_type_style_index_0_lang_scss_ = __webpack_require__("b14a");

// CONCATENATED MODULE: ./src/Page/VaPage.vue






/* normalize component */

var VaPage_component = normalizeComponent(
  Page_VaPagevue_type_script_lang_js_,
  VaPagevue_type_template_id_5264e07c_render,
  VaPagevue_type_template_id_5264e07c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPage = (VaPage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Form/VaForm.vue?vue&type=template&id=6ae64bd3&
var VaFormvue_type_template_id_6ae64bd3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._b({class:_vm.classObj,attrs:{"id":_vm.id,"name":_vm.name},on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},'form',_vm.$attrs,false),[_vm._t("default")],2)}
var VaFormvue_type_template_id_6ae64bd3_staticRenderFns = []


// CONCATENATED MODULE: ./src/Form/VaForm.vue?vue&type=template&id=6ae64bd3&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js








function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}
// CONCATENATED MODULE: ./src/utils/type.js



// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
/* harmony default export */ var utils_type = ({
  isArray: function isArray(arg) {
    if (Array.isArray) {
      return Array.isArray(arg);
    }

    return this.objectToString(arg) === '[object Array]';
  },
  isBoolean: function isBoolean(arg) {
    return typeof arg === 'boolean';
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  },
  isNumber: function isNumber(arg) {
    return typeof arg === 'number';
  },
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isSymbol: function isSymbol(arg) {
    return _typeof(arg) === 'symbol';
  },
  isUndefined: function isUndefined(arg) {
    return arg === undefined;
  },
  isRegExp: function isRegExp(re) {
    return this.objectToString(re) === '[object RegExp]';
  },
  isObject: function isObject(arg) {
    return _typeof(arg) === 'object' && arg !== null;
  },
  isDate: function isDate(d) {
    return this.objectToString(d) === '[object Date]';
  },
  isError: function isError(e) {
    return this.objectToString(e) === '[object Error]' || e instanceof Error;
  },
  isFunction: function isFunction(arg) {
    return typeof arg === 'function';
  },
  isPrimitive: function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || _typeof(arg) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
  },
  objectToString: function objectToString(o) {
    return Object.prototype.toString.call(o);
  },
  isPromise: function isPromise(promise) {
    return this.isObject(promise) && this.isFunction(promise.then) && this.isFunction(promise.catch);
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Form/VaForm.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var VaFormvue_type_script_lang_js_ = ({
  name: 'VaForm',
  mixins: [events],
  inheritAttrs: false,
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    type: {
      type: String,
      default: 'horizontal',
      required: false,
      validator: function validator(v) {
        return ['horizontal', 'inline', 'vertical'].includes(v);
      }
    }
  },
  methods: {
    noop: function noop() {},
    validateFields: function validateFields(cb) {
      var _this = this;

      this.validate = false;
      this.$nextTick(function () {
        _this.validate = true;

        _this.$nextTick(function () {
          if (utils_type.isFunction(cb)) {
            cb(_this.result);
          }
        });
      });
    },
    resetValidation: function resetValidation(cb) {
      var _this2 = this;

      this.validate = false;
      this.$nextTick(function () {
        _this2.result = {
          results: {},
          isvalid: true
        };

        _this2.$emit('validateChange', _this2.result);

        if (utils_type.isFunction(cb)) {
          cb(_this2.result);
        }
      });
    }
  },
  watch: {
    validate: function validate(val) {
      this.broadcast('VaValidate', 'Va@openValidate', val);

      if (val) {
        this.result = this._result;
      } else {
        this.result = {
          results: {},
          isvalid: true
        };
      }
    },
    result: function result(val) {
      if (this.validate) {
        this.$emit('validateChange', val);
      }
    },
    type: function type(val) {
      this.broadcast('VaFormItem', 'Va@formTypeChange', val);
    }
  },
  mounted: function mounted() {
    if (!this.validate) {
      this.result = {
        results: {},
        isvalid: true
      };
    }

    this.broadcast('VaValidate', 'Va@openValidate', this.validate);
    this.broadcast('VaFormItem', 'Va@formTypeChange', this.type);
  },
  computed: {
    classObj: function classObj() {
      var type = this.type;
      var classes = {};
      classes['va-form-horizontal'] = type === 'horizontal';
      classes['va-form-inline'] = type === 'inline';
      classes['clearfix'] = true;
      return classes;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$on('openValidate', function () {
      _this3.validate = true;
    });
    this.$on('closeValidate', function () {
      _this3.validate = false;
    });
    this.$on('Va@validateChange', function (val) {
      var name = val.name;
      var validateResult = Object.assign({}, _this3._result);
      if (!validateResult.results) validateResult.results = {};
      validateResult.results[name] = val.result;
      validateResult.isvalid = true;

      for (var i in validateResult.results) {
        if (!validateResult.results[i]['isvalid']) {
          validateResult.isvalid = false;
          break;
        }
      }

      _this3._result = validateResult;

      if (_this3.validate) {
        _this3.result = _this3._result;

        _this3.$emit('validateChange', _this3.result);
      }
    });
    this.$on('Va@validateDestroy', function (val) {
      delete _this3.result.results[val.name];
      delete _this3._result.results[val.name];
    });
    this.$on('Va@requestFormType', function () {
      _this3.broadcast('VaFormItem', 'Va@formTypeChange', _this3.type);
    });
  },
  data: function data() {
    return {
      // eslint-disable-next-line
      _result: {
        results: {},
        isvalid: true
      },
      result: {
        results: {},
        isvalid: true
      },
      validate: false
    };
  }
});
// CONCATENATED MODULE: ./src/Form/VaForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var Form_VaFormvue_type_script_lang_js_ = (VaFormvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Form/VaForm.vue





/* normalize component */

var VaForm_component = normalizeComponent(
  Form_VaFormvue_type_script_lang_js_,
  VaFormvue_type_template_id_6ae64bd3_render,
  VaFormvue_type_template_id_6ae64bd3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaForm = (VaForm_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Card/VaCard.vue?vue&type=template&id=1e8ebcda&
var VaCardvue_type_template_id_1e8ebcda_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[(_vm.hasHeaderData)?_c('div',{class:_vm.headerClassObj,style:(_vm.headerStyleObj)},[_c('div',{class:"va-card-header-inner"},[_c('div',{class:"va-card-header-inner-left"},[_vm._t("topLeft")],2),_c('div',{class:"va-card-header-inner-right"},[_vm._t("topRight")],2)])]):_vm._e(),_c('div',{class:"va-card-body",style:(_vm.bodyStyleObj)},[_vm._t("default")],2)])}
var VaCardvue_type_template_id_1e8ebcda_staticRenderFns = []


// CONCATENATED MODULE: ./src/Card/VaCard.vue?vue&type=template&id=1e8ebcda&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Card/VaCard.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaCardvue_type_script_lang_js_ = ({
  name: 'VaCard',
  props: {
    elevation: {
      type: [Number, String],
      default: 0,
      validator: function validator(v) {
        v = v.toString();
        return ['0', '1', '2', '3', '4', '5'].includes(v);
      }
    },
    padding: {
      type: [Number, String],
      default: '10px'
    }
  },
  computed: {
    classObj: function classObj() {
      var elevation = this.elevation;
      var classes = {};
      classes['va-card'] = true;
      classes['va-card-elevation-' + elevation] = true;
      return classes;
    },
    bodyStyleObj: function bodyStyleObj() {
      var padding = this.padding;
      var style = {};
      style['padding'] = padding;
      return style;
    },
    headerClassObj: function headerClassObj() {
      var classes = {};
      classes['va-card-header'] = true;
      return classes;
    },
    headerStyleObj: function headerStyleObj() {
      var padding = this.padding;
      var style = {};
      style['padding-left'] = padding;
      style['padding-right'] = padding;
      return style;
    },
    hasHeaderData: function hasHeaderData() {
      return this.$slots.topLeft || this.$slots.topRight;
    }
  }
});
// CONCATENATED MODULE: ./src/Card/VaCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var Card_VaCardvue_type_script_lang_js_ = (VaCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Card/VaCard.vue?vue&type=style&index=0&lang=scss&
var VaCardvue_type_style_index_0_lang_scss_ = __webpack_require__("ad9a");

// CONCATENATED MODULE: ./src/Card/VaCard.vue






/* normalize component */

var VaCard_component = normalizeComponent(
  Card_VaCardvue_type_script_lang_js_,
  VaCardvue_type_template_id_1e8ebcda_render,
  VaCardvue_type_template_id_1e8ebcda_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCard = (VaCard_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tabs/VaTabs.vue?vue&type=template&id=2cc38467&
var VaTabsvue_type_template_id_2cc38467_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{class:_vm.classObj},_vm._l((_vm.tabs),function(tab,i){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tab.isVisible),expression:"tab.isVisible"}],key:i,class:[_vm.liclassObj(tab), _vm.disabledTabClass(tab)]},[_c('a',{attrs:{"href":tab.hash},domProps:{"innerHTML":_vm._s(tab.header)},on:{"click":function($event){return _vm.selectTab(tab.hash, $event)}}})])}),0),_c('div',{class:"va-tab-content"},[_vm._t("default")],2)])}
var VaTabsvue_type_template_id_2cc38467_staticRenderFns = []


// CONCATENATED MODULE: ./src/Tabs/VaTabs.vue?vue&type=template&id=2cc38467&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./src/utils/ExpiringStorage.js



var ExpiringStorage_ExpiringStorage =
/*#__PURE__*/
function () {
  function ExpiringStorage() {
    _classCallCheck(this, ExpiringStorage);
  }

  _createClass(ExpiringStorage, [{
    key: "get",
    value: function get(key) {
      var cached = JSON.parse(window.localStorage.getItem(key));

      if (!cached) {
        return null;
      }

      var expires = new Date(cached.expires);

      if (expires < new Date()) {
        window.localStorage.removeItem(key);
        return null;
      }

      return cached.value;
    }
  }, {
    key: "set",
    value: function set(key, value, lifetimeInMinutes) {
      var currentTime = new Date().getTime();
      var expires = new Date(currentTime + lifetimeInMinutes * 60000);
      window.localStorage.setItem(key, JSON.stringify({
        value: value,
        expires: expires
      }));
    }
  }]);

  return ExpiringStorage;
}();

/* harmony default export */ var utils_ExpiringStorage = (new ExpiringStorage_ExpiringStorage());
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tabs/VaTabs.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaTabsvue_type_script_lang_js_ = ({
  name: 'VaTabs',
  props: {
    cacheLifetime: {
      type: Number,
      default: 5,
      required: false
    },
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          useUrlFragment: false
        };
      }
    }
  },
  data: function data() {
    return {
      tabs: [],
      activeTabHash: ''
    };
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['clearfix'] = true;
      classes['va-nav-tabs'] = true;
      return classes;
    },
    storageKey: function storageKey() {
      return "va-tabs.cache.".concat(window.location.host).concat(window.location.pathname);
    }
  },
  created: function created() {
    this.tabs = this.$children;
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('hashchange', function () {
      return _this.selectTab(window.location.hash);
    });

    if (this.findTab(window.location.hash)) {
      this.selectTab(window.location.hash);
      return;
    }

    var previousSelectedTabHash = utils_ExpiringStorage.get(this.storageKey);

    if (this.findTab(previousSelectedTabHash)) {
      this.selectTab(previousSelectedTabHash);
      return;
    }

    if (this.tabs.length) {
      this.selectTab(this.tabs[0].hash);
    }
  },
  methods: {
    findTab: function findTab(hash) {
      return this.tabs.find(function (tab) {
        return tab.hash === hash;
      });
    },
    selectTab: function selectTab(selectedTabHash, event) {
      if (event && !this.options.useUrlFragment) {
        event.preventDefault();
      }

      var selectedTab = this.findTab(selectedTabHash);

      if (!selectedTab) {
        return;
      }

      if (selectedTab.isDisabled) {
        return;
      }

      this.tabs.forEach(function (tab) {
        tab.isActive = tab.hash === selectedTab.hash;
      });
      this.$emit('changed', {
        tab: selectedTab
      });
      this.activeTabHash = selectedTab.hash;
      utils_ExpiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLifetime);
    },
    setTabVisible: function setTabVisible(hash, visible) {
      var tab = this.findTab(hash);

      if (!tab) {
        return;
      }

      tab.isVisible = visible;

      if (tab.isActive) {
        tab.isActive = visible;
        this.tabs.every(function (tab) {
          if (tab.isVisible) {
            tab.isActive = true;
            return false;
          }

          return true;
        });
      }
    },
    liclassObj: function liclassObj(tab) {
      var classes = {};
      classes['va-nav-tab'] = true;
      classes['va-nav-tab-active'] = tab.isActive;
      return classes;
    },
    disabledTabClass: function disabledTabClass(tab) {
      if (tab.isDisabled) {
        return 'va-nav-tab-disabled';
      } else {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Tabs/VaTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var Tabs_VaTabsvue_type_script_lang_js_ = (VaTabsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Tabs/VaTabs.vue?vue&type=style&index=0&lang=scss&
var VaTabsvue_type_style_index_0_lang_scss_ = __webpack_require__("4713");

// CONCATENATED MODULE: ./src/Tabs/VaTabs.vue






/* normalize component */

var VaTabs_component = normalizeComponent(
  Tabs_VaTabsvue_type_script_lang_js_,
  VaTabsvue_type_template_id_2cc38467_render,
  VaTabsvue_type_template_id_2cc38467_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTabs = (VaTabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Icon/VaIcon.vue?vue&type=template&id=0ddba81b&
var VaIconvue_type_template_id_0ddba81b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.fontStyle, 'fa-' + _vm.type],style:({fontSize:_vm.size,color:_vm.color,margin:_vm.margin,backgroundColor:_vm.bgColor,borderRadius:'4px',padding:_vm.padding})},[_vm._t("default")],2)}
var VaIconvue_type_template_id_0ddba81b_staticRenderFns = []


// CONCATENATED MODULE: ./src/Icon/VaIcon.vue?vue&type=template&id=0ddba81b&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Icon/VaIcon.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaIconvue_type_script_lang_js_ = ({
  name: 'VaIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    iconStyle: {
      type: String,
      default: 'solid',
      required: false,
      validator: function validator(v) {
        return ['solid', 'regular', 'brands'].includes(v);
      }
    },
    size: {
      type: String,
      required: false,
      default: '1em'
    },
    color: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      default: 'transparent',
      required: false
    },
    margin: {
      type: String,
      default: '0px',
      required: false
    },
    padding: {
      type: String,
      default: '0px',
      required: false
    },
    classPrefix: {
      type: String,
      default: 'va'
    }
  },
  computed: {
    fontStyle: function fontStyle() {
      switch (this.iconStyle) {
        case 'regular':
          return 'far';

        case 'solid':
          return 'fas';

        case 'brands':
          return 'fab';

        default:
          return 'fas';
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Icon/VaIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var Icon_VaIconvue_type_script_lang_js_ = (VaIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Icon/VaIcon.vue?vue&type=style&index=0&lang=scss&
var VaIconvue_type_style_index_0_lang_scss_ = __webpack_require__("6ab3");

// CONCATENATED MODULE: ./src/Icon/VaIcon.vue






/* normalize component */

var VaIcon_component = normalizeComponent(
  Icon_VaIconvue_type_script_lang_js_,
  VaIconvue_type_template_id_0ddba81b_render,
  VaIconvue_type_template_id_0ddba81b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaIcon = (VaIcon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ToggleIcon/VaToggleIcon.vue?vue&type=template&id=f23f3648&scoped=true&
var VaToggleIconvue_type_template_id_f23f3648_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"va-toggle-icon_wrapper",style:(_vm.style)},_vm.$listeners),[_c('div',_vm._g({staticClass:"va-toggle-icon_container"},_vm.listeners),[_c('transition-group',{attrs:{"name":"fade"}},[(_vm.isActive)?_c('va-icon',_vm._b({key:"1",staticClass:"va-toggle-icon_icon",attrs:{"type":_vm.typeActive,"size":_vm.size}},'va-icon',_vm.$attrs,false)):_c('va-icon',_vm._b({key:"2",staticClass:"va-toggle-icon_icon",attrs:{"type":_vm.type,"size":_vm.size}},'va-icon',_vm.$attrs,false))],1)],1)])}
var VaToggleIconvue_type_template_id_f23f3648_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/ToggleIcon/VaToggleIcon.vue?vue&type=template&id=f23f3648&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ToggleIcon/VaToggleIcon.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaToggleIconvue_type_script_lang_js_ = ({
  name: 'VaToggleIcon',
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(v) {
        return ['hover', 'click'].includes(v);
      }
    },
    type: {
      type: String,
      required: true
    },
    typeActive: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: '1em'
    }
  },
  watch: {
    active: function active(val) {
      this.isActive = val;
    }
  },
  computed: {
    listeners: function listeners() {
      switch (this.trigger) {
        case 'hover':
          return {
            mouseenter: this.onActivate,
            mouseleave: this.onDeactivate
          };

        case 'click':
          return {
            click: this.toggle
          };

        default:
          return {};
      }
    }
  },
  data: function data() {
    return {
      isActive: this.active,
      style: {
        display: 'inline-block',
        width: this.$props.size,
        height: this.$props.size,
        position: 'relative'
      }
    };
  },
  methods: {
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    onActivate: function onActivate() {
      this.isActive = true;
    },
    onDeactivate: function onDeactivate() {
      this.isActive = false;
    }
  }
});
// CONCATENATED MODULE: ./src/ToggleIcon/VaToggleIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var ToggleIcon_VaToggleIconvue_type_script_lang_js_ = (VaToggleIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/ToggleIcon/VaToggleIcon.vue?vue&type=style&index=0&id=f23f3648&scoped=true&lang=css&
var VaToggleIconvue_type_style_index_0_id_f23f3648_scoped_true_lang_css_ = __webpack_require__("cb99");

// CONCATENATED MODULE: ./src/ToggleIcon/VaToggleIcon.vue






/* normalize component */

var VaToggleIcon_component = normalizeComponent(
  ToggleIcon_VaToggleIconvue_type_script_lang_js_,
  VaToggleIconvue_type_template_id_f23f3648_scoped_true_render,
  VaToggleIconvue_type_template_id_f23f3648_scoped_true_staticRenderFns,
  false,
  null,
  "f23f3648",
  null
  
)

/* harmony default export */ var VaToggleIcon = (VaToggleIcon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Toggle/VaToggle.vue?vue&type=template&id=7b472f9e&
var VaTogglevue_type_template_id_7b472f9e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObj,on:{"click":function($event){$event.preventDefault();}}},[_c('input',{class:"va-toggle__input",attrs:{"name":_vm.name,"tabindex":"-1","type":"checkbox"},domProps:{"checked":_vm.value},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.toggle($event)}}}),_c('div',{class:"va-toggle__slide",attrs:{"aria-label":_vm.label,"tabindex":_vm.disabled ? -1 : 0},on:{"click":_vm.toggle,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.toggle($event)}}},[_c('div',{class:"va-toggle__inner"},[_c('span',{class:"va-toggle__handle"}),_c('span',{class:"va-toggle__icon"},[_c('va-icon',{attrs:{"type":_vm.icon}})],1)])])])}
var VaTogglevue_type_template_id_7b472f9e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Toggle/VaToggle.vue?vue&type=template&id=7b472f9e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Toggle/VaToggle.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaTogglevue_type_script_lang_js_ = ({
  name: 'VaToggle',
  props: {
    name: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      required: false,
      validator: function validator(v) {
        return ['md', 'lg'].includes(v);
      }
    }
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-toggle'] = true;
      classes['va-toggle--checked'] = this.value;
      classes['va-toggle--disabled'] = this.disabled;
      classes['va-toggle--lg'] = this.size === 'lg';
      return classes;
    },
    icon: function icon() {
      return this.value ? 'check' : 'times';
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var newState = !this.value;
      this.$emit('input', newState);
      this.$emit('change', newState);
    }
  }
});
// CONCATENATED MODULE: ./src/Toggle/VaToggle.vue?vue&type=script&lang=js&
 /* harmony default export */ var Toggle_VaTogglevue_type_script_lang_js_ = (VaTogglevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Toggle/VaToggle.vue?vue&type=style&index=0&lang=scss&
var VaTogglevue_type_style_index_0_lang_scss_ = __webpack_require__("eaec");

// CONCATENATED MODULE: ./src/Toggle/VaToggle.vue






/* normalize component */

var VaToggle_component = normalizeComponent(
  Toggle_VaTogglevue_type_script_lang_js_,
  VaTogglevue_type_template_id_7b472f9e_render,
  VaTogglevue_type_template_id_7b472f9e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaToggle = (VaToggle_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Input/VaInput.vue?vue&type=template&id=17d7bc2f&
var VaInputvue_type_template_id_17d7bc2f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showButtonsWarning)?_c('div',{class:_vm.classObj,style:({'width': _vm.actualWidth})},[(_vm.prefix !== '')?_c('span',{class:"va-input-prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),(_vm.noVModel)?_c('input',_vm._b({ref:"input",class:_vm.inputClassObj,style:(_vm.inputStyleObj),attrs:{"name":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"type":_vm.type,"tabindex":"0"},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":function($event){return _vm.update($event.target.value)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterPressed($event)}}},'input',_vm.$attrs,false)):((_vm.type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",class:_vm.inputClassObj,style:(_vm.inputStyleObj),attrs:{"name":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"tabindex":"0","type":"checkbox"},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.value)>-1:(_vm.currentValue)},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":function($event){return _vm.update($event.target.value)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterPressed($event)},"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}},'input',_vm.$attrs,false)):((_vm.type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",class:_vm.inputClassObj,style:(_vm.inputStyleObj),attrs:{"name":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"tabindex":"0","type":"radio"},domProps:{"value":_vm.value,"checked":_vm._q(_vm.currentValue,_vm.value)},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":function($event){return _vm.update($event.target.value)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterPressed($event)},"change":function($event){_vm.currentValue=_vm.value}}},'input',_vm.$attrs,false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",class:_vm.inputClassObj,style:(_vm.inputStyleObj),attrs:{"name":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"tabindex":"0","type":_vm.type},domProps:{"value":_vm.value,"value":(_vm.currentValue)},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.update($event.target.value)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterPressed($event)}}},'input',_vm.$attrs,false)),(_vm.icon !== 'undefined' || _vm.clearable)?_c('div',{class:"va-input-icon-wrapper"},[(_vm.clearable)?_c('va-icon',{class:"va-input-clearable",attrs:{"type":"times","icon-style":"solid"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.clean($event)}}}):_vm._e(),_c('va-icon',{class:"va-input-show-icon",attrs:{"type":_vm.icon,"icon-style":_vm.iconStyle}})],1):_vm._e(),(_vm.postfix !== '')?_c('span',{class:"va-input-postfix"},[_vm._v(_vm._s(_vm.postfix))]):_vm._e(),(_vm.buttons)?_c('va-input-ops',{attrs:{"parent-position":_vm.position},on:{"confirm":_vm.opsConfirm,"cancel":_vm.opsCancel}}):_vm._e(),_c('validate',{attrs:{"name":_vm.name,"rules":_vm.rules,"custom-validate":_vm.customValidate,"current":_vm.value},model:{value:(_vm.validStatus),callback:function ($$v) {_vm.validStatus=$$v},expression:"validStatus"}})],1):_c('div',[_c('va-alert',{attrs:{"type":"warning"}},[_c('h4',[_vm._v("Hold on")]),_c('p',[_vm._v(" If you're going to use "),_c('b',[_vm._v("buttons")]),_vm._v(" with this input component, you need to also use the "),_c('b',[_vm._v("loading")]),_vm._v(" prop. Handle the "),_c('b',[_vm._v("@confirm")]),_vm._v(" event emitted by the input component by setting the "),_c('b',[_vm._v("loading")]),_vm._v(" prop to true, "),_c('i',[_vm._v("doing some task")]),_vm._v(", and finally setting the "),_c('b',[_vm._v("loading")]),_vm._v(" prop back to false. It is important that events happen in that order, because the input component is watching the "),_c('b',[_vm._v("loading")]),_vm._v(" prop for those changes. That's how it knows to hide the confirm and cancel buttons. ")])])],1)}
var VaInputvue_type_template_id_17d7bc2f_staticRenderFns = []


// CONCATENATED MODULE: ./src/Input/VaInput.vue?vue&type=template&id=17d7bc2f&

// CONCATENATED MODULE: ./src/Mixin/inputMixin.js
/* harmony default export */ var inputMixin = ({
  props: {
    name: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    customValidate: {
      type: Function
    },
    rules: {
      type: Array
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      validStatus: ''
    };
  },
  computed: {
    actualWidth: function actualWidth() {
      var width = this.width;

      switch (width) {
        case 'xs':
          return '80px';

        case 'sm':
          return '160px';

        case 'md':
          return '255px';

        case 'lg':
          return '320px';

        case 'xl':
          return '480px';
      }

      return width;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/validate.vue?vue&type=template&id=17fd6308&
var validatevue_type_template_id_17fd6308_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validate && _vm.tips)?_c('div',{class:"va-err-tip"},[_vm._v(_vm._s(_vm.tips))]):_vm._e()}
var validatevue_type_template_id_17fd6308_staticRenderFns = []


// CONCATENATED MODULE: ./src/validate.vue?vue&type=template&id=17fd6308&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// CONCATENATED MODULE: ./src/Locale/VaModal.js
/* harmony default export */ var VaModal = ({
  confirm: {
    en: 'Confirm',
    es: 'Confirmar',
    fr: 'Confirmer',
    ru: 'Подтвердить'
  },
  cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    fr: 'Annuler',
    ru: 'Отмена'
  }
});
// CONCATENATED MODULE: ./src/Locale/VaSelect.js
/* harmony default export */ var VaSelect = ({
  all: {
    en: 'All',
    es: 'Todos',
    fr: 'Tous',
    ru: 'Все'
  }
});
// CONCATENATED MODULE: ./src/Locale/VaValidate.js
/* harmony default export */ var VaValidate = ({
  required: {
    en: 'This field is required',
    es: 'Este campo es requerido',
    fr: 'Ce champs est requis',
    ru: 'Это поле обязательное'
  },
  maxLength: {
    en: 'Input can not be longer than ',
    es: 'La entrada no puede ser más larga que ',
    fr: 'Le nombre de caractère doit être inférieur ou égale à ',
    ru: 'Данные не могут быть длиннее чем '
  },
  minLength: {
    en: 'Input can not be less than ',
    es: 'La entrada no puede ser menor que ',
    fr: 'Le nombre de caractère doit être supérieur ou égale à ',
    ru: 'Данные не могут быть меньше чем '
  },
  phone: {
    en: 'Please enter a valid phone number',
    es: 'Por favor ingrese un número de teléfono válido',
    fr: "Merci d'inscrire un numéro de téléphone valide",
    ru: 'Введите правильный номер телефона'
  },
  number: {
    en: 'Numbers only',
    es: 'Solo numeros',
    fr: 'Chiffres uniquement',
    ru: 'Только цифры'
  },
  telephone: {
    en: 'Please enter a valid telephone number',
    es: 'Por favor introduce un número de teléfono válido',
    fr: "Merci d'inscrire un numéro de téléphone valide",
    ru: 'Введите праивльный номер телефона'
  },
  email: {
    en: 'Please enter a valid email address',
    es: 'Por favor, introduce una dirección de correo electrónico válida',
    fr: "Merci d'inscrire une adresse email valide",
    ru: 'Введите правильный e-mail адрес'
  }
});
// CONCATENATED MODULE: ./src/Locale/VaDatepicker.js
/* harmony default export */ var VaDatepicker = ({
  sunday: {
    en: 'Sun',
    es: 'Do',
    fr: 'Dim',
    ru: 'Вс'
  },
  monday: {
    en: 'Mon',
    es: 'Lu',
    fr: 'Lun',
    ru: 'Пн'
  },
  tuesday: {
    en: 'Tue',
    es: 'Ma',
    fr: 'Mar',
    ru: 'Вт'
  },
  wednesday: {
    en: 'Wed',
    es: 'Mi',
    fr: 'Mer',
    ru: 'Ср'
  },
  thursday: {
    en: 'Thu',
    es: 'Ju',
    fr: 'Jeu',
    ru: 'Чт'
  },
  friday: {
    en: 'Fri',
    es: 'Vi',
    fr: 'Ven',
    ru: 'Пт'
  },
  saturday: {
    en: 'Sat',
    es: 'Sá',
    fr: 'Sam',
    ru: 'Сб'
  },
  january: {
    en: 'January',
    es: 'Ene',
    fr: 'Janvier',
    ru: 'Январь'
  },
  february: {
    en: 'February',
    es: 'Feb',
    fr: 'Février',
    ru: 'Февраль'
  },
  march: {
    en: 'March',
    es: 'Mar',
    fr: 'Mars',
    ru: 'Март'
  },
  april: {
    en: 'April',
    es: 'Abr',
    fr: 'Avril',
    ru: 'Апрель'
  },
  may: {
    en: 'May',
    es: 'May',
    fr: 'Mai',
    ru: 'Май'
  },
  june: {
    en: 'June',
    es: 'Jun',
    fr: 'Juin',
    ru: 'Июнь'
  },
  july: {
    en: 'July',
    es: 'Jul',
    fr: 'Juillet',
    ru: 'Июль'
  },
  august: {
    en: 'August',
    es: 'Aug',
    fr: 'Août',
    ru: 'Август'
  },
  september: {
    en: 'September',
    es: 'Sep',
    fr: 'Septembre',
    ru: 'Сентябрь'
  },
  october: {
    en: 'October',
    es: 'Oct',
    fr: 'Octobre',
    ru: 'Октябрь'
  },
  november: {
    en: 'November',
    es: 'Nov',
    fr: 'Novembre',
    ru: 'Ноябрь'
  },
  december: {
    en: 'December',
    es: 'Dec',
    fr: 'Décembre',
    ru: 'Декабрь'
  }
});
// CONCATENATED MODULE: ./src/Locale/VaTimepicker.js
/* harmony default export */ var VaTimepicker = ({
  hour: {
    en: 'H',
    es: 'H',
    fr: 'H',
    ru: 'Ч'
  },
  minute: {
    en: 'M',
    es: 'M',
    fr: 'M',
    ru: 'М'
  },
  second: {
    en: 'S',
    es: 'S',
    fr: 'S',
    ru: 'С'
  }
});
// CONCATENATED MODULE: ./src/Locale/index.js





/* harmony default export */ var Locale = ({
  VaModal: VaModal,
  VaSelect: VaSelect,
  VaValidate: VaValidate,
  VaDatepicker: VaDatepicker,
  VaTimepicker: VaTimepicker
});
// CONCATENATED MODULE: ./src/Mixin/localeMixin.js

/* harmony default export */ var localeMixin = (function (name) {
  return {
    methods: {
      getL: function getL(key) {
        return Locale[name][key][this.VaLocale || window.VaLocale || 'en'];
      }
    }
  };
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/validate.vue?vue&type=script&lang=js&






//
//
//
//



/* harmony default export */ var validatevue_type_script_lang_js_ = ({
  name: 'VaValidate',
  mixins: [events, localeMixin('VaValidate')],
  props: {
    value: {
      type: String
    },
    customValidate: {
      type: Function
    },
    rules: {
      type: Array
    },
    name: {
      type: String
    },
    current: {}
  },
  data: function data() {
    return {
      tips: '',
      validate: false,
      status: '',
      vStatus: this.value,
      results: {}
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@openValidate', function (val) {
      _this.validate = val;
      val ? _this.vStatus = _this.status : _this.vStatus = '';
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('VaForm', 'Va@validateChange', {
      name: this.name,
      result: {
        results: {},
        isvalid: true
      }
    });
    this.dispatch('VaForm', 'Va@validateDestroy', {
      name: this.name,
      result: this.results
    });
  },
  computed: {
    _results: {
      get: function get() {
        return this.results;
      },
      set: function set(val) {
        var self = this;
        var tips = '';
        var status = '';

        for (var key in val) {
          var obj = val[key];

          if (utils_type.isObject(obj)) {
            obj.tips ? tips += obj.tips + '  ' : '';

            if (obj.validStatus !== 'success') {
              status = 'error';
            }
          }
        }

        status !== 'error' ? status = 'success' : 0;
        self.status = status;

        if (self.validate) {
          self.vStatus = self.status;
        }

        var isvalid = true;
        self.tips = tips;

        for (var i in val) {
          var validStatus = val[i].validStatus;

          if (validStatus === 'error') {
            isvalid = false;
            break;
          }
        }

        var newVal = Object.assign({}, val);
        newVal.isvalid = isvalid;

        if (this.isEqual(newVal, this.results)) {
          return;
        }

        this.results = newVal;
        self.dispatch('VaForm', 'Va@validateChange', {
          name: self.name,
          result: self.results
        });
      }
    }
  },
  watch: {
    current: {
      handler: function handler(newVal) {
        this.valid(newVal);
      },
      immediate: true
    },
    vStatus: function vStatus(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    isEqual: function isEqual(a, b) {
      var e = true;
      var propsA = Object.keys(a);
      var propsB = Object.keys(b);

      if (propsA.length !== propsB.length) {
        return false;
      }

      propsA.forEach(function (i) {
        if (a[i].validStatus !== b[i].validStatus) {
          e = false;
          return false;
        }
      });
      return e;
    },
    setResult: function setResult(key, value) {
      var o = Object.assign({}, this.results);
      o[key] = value;
      this._results = o;
    },
    valid: function valid(val) {
      if (this.rules || utils_type.isFunction(this.customValidate)) {
        this.rulesValid(val);
      }
    },
    rulesItemValid: function rulesItemValid(rule, value) {
      var self = this;
      var tip = rule.tip;
      var type = rule.type;

      switch (type) {
        case 'required':
          self.requiredValid(value, tip);
          break;

        case 'phone':
          self.phoneValid(value, tip);
          break;

        case 'number':
          self.numberValid(value, tip);
          break;

        case 'telephone':
          self.telValid(value, tip);
          break;

        case 'email':
          self.emailValid(value, tip);
          break;
      }

      if (type.indexOf('maxlength') > -1) {
        self.maxlengthValid(type, value, tip); // eslint-disable-next-line

        return;
      }

      if (type.indexOf('minlength') > -1) {
        self.minlengthValid(type, value, tip); // eslint-disable-next-line

        return;
      }
    },
    customValid: function customValid(val) {
      this.setResult('customValidate', this.customValidate(val));
    },
    requiredValid: function requiredValid(val, tip) {
      var self = this;
      self._results = self._results || {};

      if (utils_type.isNullOrUndefined(val) || val.length === 0) {
        self.setResult('requiredValid', {
          validStatus: 'error',
          tips: tip || self.getL('required')
        });
      } else {
        self.setResult('requiredValid', {
          validStatus: 'success',
          tips: ''
        });
      }
    },
    maxlengthValid: function maxlengthValid(type, val, tip) {
      var self = this;
      var maxlength = type.split('=')[1] - 0;
      self._results = self._results || {};

      if (val) {
        if (val.length > maxlength) {
          self.setResult('maxlengthValid', {
            validStatus: 'error',
            tips: tip || self.getL('maxLength') + maxlength
          });
        } else {
          self.setResult('maxlengthValid', {
            validStatus: 'success',
            tips: ''
          });
        }
      }
    },
    minlengthValid: function minlengthValid(type, val, tip) {
      var self = this;
      var minlength = type.split('=')[1] - 0;
      self._results = self._results || {};

      if (val) {
        if (val.length < minlength) {
          self.setResult('minlengthValid', {
            validStatus: 'error',
            tips: tip || self.getL('minLength') + minlength
          });
        } else {
          self.setResult('minlengthValid', {
            validStatus: 'success',
            tips: ''
          });
        }
      }
    },
    rulesValid: function rulesValid(value) {
      var self = this;
      self.rules.forEach(function (val) {
        self.rulesItemValid(val, value);
      });

      if (utils_type.isFunction(self.customValidate)) {
        self.customValid(value);
      }
    },
    phoneValid: function phoneValid(value, tip) {
      var rule = /^1\d{10}$/;

      if (rule.test(value) || value === '') {
        this.setResult('isPhoneValid', {
          validStatus: 'success',
          tips: ''
        });
      } else {
        this.setResult('isPhoneValid', {
          validStatus: 'error',
          tips: tip || this.getL('phone')
        });
      }
    },
    numberValid: function numberValid(value, tip) {
      var rule = /^\d*$/;

      if (rule.test(value) || value === '') {
        this.setResult('isNumberValid', {
          validStatus: 'success',
          tips: ''
        });
      } else {
        this.setResult('isNumberValid', {
          validStatus: 'error',
          tips: tip || this.getL('number')
        });
      }
    },
    telValid: function telValid(value, tip) {
      // eslint-disable-next-line
      var rule = /^[2-9]\d{2}-\d{3}-\d{4}$/;

      if (rule.test(value) || value === '') {
        this.setResult('isTelValid', {
          validStatus: 'success',
          tips: ''
        });
      } else {
        this.setResult('isTelValid', {
          validStatus: 'error',
          tips: tip || this.getL('telephone')
        });
      }
    },
    emailValid: function emailValid(value, tip) {
      var rule = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

      if (rule.test(value) || value === '') {
        this.setResult('isEmailValid', {
          validStatus: 'success',
          tips: ''
        });
      } else {
        this.setResult('isEmailValid', {
          validStatus: 'error',
          tips: tip || this.getL('email')
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/validate.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_validatevue_type_script_lang_js_ = (validatevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/validate.vue





/* normalize component */

var validate_component = normalizeComponent(
  src_validatevue_type_script_lang_js_,
  validatevue_type_template_id_17fd6308_render,
  validatevue_type_template_id_17fd6308_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var validate = (validate_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Input/VaInput.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VaInputvue_type_script_lang_js_ = ({
  name: 'VaInput',
  mixins: [inputMixin, events],
  inheritAttrs: false,
  props: {
    value: {},
    size: {
      type: String
    },
    onChange: {
      type: Function
    },
    type: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      default: 'undefined'
    },
    iconStyle: {
      type: String,
      default: 'regular',
      required: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false,
      required: false
    },
    buttons: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: undefined
    },
    prefix: {
      type: String,
      default: '',
      required: false
    },
    postfix: {
      type: String,
      default: '',
      required: false
    },
    noVModel: {
      type: Boolean,
      default: false,
      required: false
    },
    theme: {
      type: String,
      default: 'primary',
      required: false,
      validator: function validator(v) {
        return ['default', 'primary', 'success', 'warning', 'danger', 'purple'].includes(v);
      }
    }
  },
  data: function data() {
    var cv = this.value;
    return {
      focused: false,
      currentValue: cv,
      position: {},
      showButtonsWarning: false,
      autofilled: false
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@inputOpsCancel', function (val) {
      _this.currentValue = val;
    });
    this.$on('Va@inputOpsConfirm', function () {});
    this.$on('Va@inputOpsBlur', function () {
      _this.focused = false;
    });
    this.$on('Va@pageScroll', function () {
      _this.setPosition();
    });
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.setPosition, false);
    window.addEventListener('scroll', this.setPosition, false);

    if (this.buttons && this.loading === undefined) {
      this.showButtonsWarning = true;
    }

    if (this.autofocus) {
      this.focused = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.setPosition, false);
    window.removeEventListener('resize', this.setPosition, false);
  },
  components: {
    validate: validate
  },
  computed: {
    inputStyleObj: function inputStyleObj() {
      var type = this.type;
      var style = {};

      if (type === 'file') {
        style['opacity'] = '0.2';
        style['z-index'] = '1';
        style['position'] = 'absolute';
      }

      style['width'] = this.actualWidth;
      return style;
    },
    classObj: function classObj() {
      var validStatus = this.validStatus,
          clearable = this.clearable,
          size = this.size,
          icon = this.icon,
          prefix = this.prefix,
          postfix = this.postfix,
          type = this.type;
      var classes = {};
      classes['va-has-error'] = validStatus === 'error';
      classes['va-has-success'] = validStatus === 'success';
      classes['va-has-warn'] = validStatus === 'warn';
      classes['va-input-con'] = true;
      classes['va-clearable'] = clearable;
      classes['va-show-icon'] = !!icon;
      size ? classes['va-input-' + size] = true : '';
      classes['va-input-has-prefix'] = prefix !== '';
      classes['va-input-has-postfix'] = postfix !== '';
      classes['va-input-file'] = type === 'file';
      classes['inline'] = true;
      return classes;
    },
    inputClassObj: function inputClassObj() {
      var theme = this.theme;
      var classes = {};
      classes['va-form-control'] = true;
      classes['va-form-control-' + theme] = true;
      return classes;
    }
  },
  watch: {
    loading: function loading(val) {
      this.broadcast('VaInputOps', 'Va@inputLoading', val);
    },
    currentValue: function currentValue(val) {
      this.broadcast('VaInputOps', 'Va@inputCurrentValueUpdate', val);
    },
    value: function value(val) {
      this.currentValue = val;
      this.$refs.input.value = val;
    }
  },
  methods: {
    clean: function clean() {
      this.$emit('input', '');
      this.$emit('clean');
      this.$refs.input.value = '';
      this.$refs.input.focus();
    },
    update: function update(val) {
      this.$emit('input', val);
      this.$emit('change', val);

      if (this.buttons) {
        this.broadcast('VaInputOps', 'Va@inputUpdate', this.currentValue);
      }
    },
    onBlur: function onBlur() {
      this.$emit('blur', this.value);

      if (this.buttons) {
        this.broadcast('VaInputOps', 'Va@inputBlur', this.currentValue);
      }
    },
    blur: function blur() {
      this.focused = false;
    },
    onFocus: function onFocus() {
      this.$emit('focus', this.value);

      if (this.buttons) {
        this.position = this.getPosition();
        this.broadcast('VaInputOps', 'Va@inputFocus', this.currentValue);
      }
    },
    focus: function focus() {
      var _this2 = this;

      setTimeout(function () {
        _this2.focused = true;

        _this2.$refs.input.focus();
      }, 50);
    },
    enterPressed: function enterPressed(e) {
      this.$emit('keyup', e);
      this.opsConfirm();
    },
    setPosition: function setPosition() {
      this.position = this.getPosition();
    },
    getPosition: function getPosition() {
      var rect = this.$refs.input.getBoundingClientRect();
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        x: rect.x,
        y: rect.y
      };
    },
    opsConfirm: function opsConfirm() {
      this.$emit('confirm', this.value);
    },
    opsCancel: function opsCancel() {
      this.$emit('cancel');
    }
  }
});
// CONCATENATED MODULE: ./src/Input/VaInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var Input_VaInputvue_type_script_lang_js_ = (VaInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Input/VaInput.vue?vue&type=style&index=0&lang=scss&
var VaInputvue_type_style_index_0_lang_scss_ = __webpack_require__("952c");

// CONCATENATED MODULE: ./src/Input/VaInput.vue






/* normalize component */

var VaInput_component = normalizeComponent(
  Input_VaInputvue_type_script_lang_js_,
  VaInputvue_type_template_id_17d7bc2f_render,
  VaInputvue_type_template_id_17d7bc2f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaInput = (VaInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Modal/VaModal.vue?vue&type=template&id=55daa50e&
var VaModalvue_type_template_id_55daa50e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",class:_vm.classObj,style:(_vm.styleObj)},[_c('div',{class:"va-modal-dialog",style:({'width': _vm.width })},[_c('va-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modalIsLoading),expression:"modalIsLoading"}],class:"va-modal-loading"},[_c('va-loading',{attrs:{"color":"#888","size":"md"}})],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modalIsLoading),expression:"!modalIsLoading"}],class:"va-modal-content"},[_vm._t("header",[_c('div',{class:"va-modal-header"},[_c('div',{staticClass:"va-modal-closer"},[_c('va-button',{class:"va-close",attrs:{"tabindex":"-1","type":"subtle"},on:{"click":_vm.close}},[_c('va-icon',{attrs:{"type":"times"}})],1)],1),_c('div',{class:"va-modal-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)])]),_c('div',{class:"va-modal-body"},[_vm._t("body")],2),_c('div',{class:"va-modal-footer"},[_vm._t("footer",[_c('va-button',{attrs:{"focused":_vm.focused,"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v(_vm._s(_vm.getL('confirm')))]),_c('va-button',{attrs:{"type":"subtle"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v(_vm._s(_vm.getL('cancel')))])])],2)],2)],1)])}
var VaModalvue_type_template_id_55daa50e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Modal/VaModal.vue?vue&type=template&id=55daa50e&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/focus-trap/index.js
var focus_trap = __webpack_require__("6c92");
var focus_trap_default = /*#__PURE__*/__webpack_require__.n(focus_trap);

// CONCATENATED MODULE: ./src/utils/getScrollBarWidth.js
/* harmony default export */ var getScrollBarWidth = (function () {
  var inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';
  var outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);
  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 === w2) w2 = outer.clientWidth;
  document.body.removeChild(outer);
  return w1 - w2;
});
// CONCATENATED MODULE: ./src/utils/EventListener.js
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @param {object} Object with a 'remove' method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  }
};
/* harmony default export */ var utils_EventListener = (EventListener);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// CONCATENATED MODULE: ./src/utils/element.js






// browser environment sniffing
var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]'; // UA sniffing for working around browser-specific quirks

var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
/**
 * for IE9 compatibility: when both class and :class are present
 * getAttribute('class') returns wrong value..
 *
 * @param {Element} el
 * @return {String}
 */

function getClass(el) {
  var classname = el.className;

  if (_typeof(classname) === 'object') {
    classname = classname.baseVal || '';
  }

  return classname;
}
/**
 * in IE9, setAttribute('class') will result in empty class
 * if the element also has the :class attribute; however in
 * phantomJS, setting `className` does not work on SVG elements..
 * so we have to do a conditional check here.
 *
 * @param {Element} el
 * @param {String} cls
 */


function setClass(el, cls) {
  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
    el.className = cls;
  } else {
    el.setAttribute('class', cls);
  }
}
/**
 * add class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */


function addClass(el, cls) {
  if (el.classList) {
    el.classList.add(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';

    if (cur.indexOf(' ' + cls + ' ') < 0) {
      setClass(el, (cur + cls).trim());
    }
  }
}
/**
 * remove class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */


function removeClass(el, cls) {
  if (el.classList) {
    el.classList.remove(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    var tar = ' ' + cls + ' ';

    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }

    setClass(el, cur.trim());
  }

  if (!el.className) {
    el.removeAttribute('class');
  }
}

/* harmony default export */ var utils_element = ({
  getClass: getClass,
  removeClass: removeClass,
  addClass: addClass,
  setClass: setClass,
  inBrowser: inBrowser,
  UA: UA,
  isIE9: isIE9
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Modal/VaModal.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var VaModalvue_type_script_lang_js_ = ({
  name: 'VaModal',
  mixins: [localeMixin('VaModal')],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    show: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: String,
      default: '600px',
      required: false
    },
    effect: {
      type: String,
      default: 'fade-up',
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    backdrop: {
      type: Boolean,
      default: true,
      required: false
    },
    backdropClickable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: function data() {
    var show = this.show;
    return {
      isShow: show,
      focused: false,
      numberOfParentModals: 0,
      focusTrap: null
    };
  },
  computed: {
    classObj: function classObj() {
      var effect = this.effect;
      var classes = {};
      classes['va-modal'] = true;
      classes['va-modal-' + effect] = true;
      return classes;
    },
    styleObj: function styleObj() {
      var backdrop = this.backdrop,
          numberOfParentModals = this.numberOfParentModals;
      var style = {};

      if (!backdrop) {
        style['background'] = 'none !important';
      }

      var topMargin = parseInt(numberOfParentModals) * 10;
      style['padding-top'] = topMargin + 'px';
      return style;
    },
    modalIsLoading: function modalIsLoading() {
      return this.loading;
    }
  },
  created: function created() {
    var _this = this;

    var escapeHandler = function escapeHandler(e) {
      if (e.key === 'Escape' && _this.isTop()) {
        _this.close();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', function () {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.focusTrap = focus_trap_default()(this.$refs.modal, {
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: true,
      fallbackFocus: this.$refs.modal
    });
    document.querySelector('body').appendChild(this.$refs.modal);
    this.$once('hook:beforeDestroy', function () {
      document.querySelector('body').removeChild(_this2.$refs.modal);
    });
  },
  watch: {
    modalIsLoading: function modalIsLoading(val) {
      var _this3 = this;

      if (!val) {
        setTimeout(function () {
          _this3.focusTrap.activate();
        }, 50);
      }
    },
    isShow: function isShow(val) {
      var _this4 = this;

      /**
       * Stackable logic
       */
      if (val) {
        this.$emit('show', {
          type: 'show'
        });
        var x = document.getElementsByClassName('va-modal-in');
        this.numberOfParentModals = x.length;
        /**
         * If any parent modals do exist, then let's stack them in a
         * nicely fashion, by moving each over to the left a bit.
         */

        var distanceToMove = 20;

        if (this.numberOfParentModals > 0) {
          for (var i = 0; i < this.numberOfParentModals; i++) {
            var currentMarginLeft = x[i].style['margin-left'];

            if (currentMarginLeft && currentMarginLeft !== '0px') {
              /**
               * If this modal already has a margin-left applied,
               * then we must have hit it already. If that's the case,
               * then we simply double the value by whatever it
               * already is.
               */
              // Slice 'px' off from the end.
              var m = Math.abs(currentMarginLeft.slice(0, -2));
              var dist = parseInt(m + distanceToMove);
              x[i].style['margin-left'] = '-' + dist + 'px';
            } else {
              /**
               * If the modal does not already have a margin-left,
               * then we just move it over by distanceToMove.
               */
              x[i].style['margin-left'] = distanceToMove * -1 + 'px';
            }
          }
        }
      } else {
        this.$emit('hide', {
          type: 'hide'
        });

        var _x = document.getElementsByClassName('va-modal-in');

        this.numberOfParentModals = _x.length;
        var _distanceToMove = 20;

        if (this.numberOfParentModals > 0) {
          for (var _i = 0; _i < this.numberOfParentModals; _i++) {
            var _currentMarginLeft = _x[_i].style['margin-left'];

            if (_currentMarginLeft && _currentMarginLeft !== '0px') {
              var _m = Math.abs(_currentMarginLeft.slice(0, -2));

              var _dist = parseInt(_m - _distanceToMove);

              _x[_i].style['margin-left'] = '-' + _dist + 'px';
            } else {//
            }
          }
        }
      }
      /**
       * Classes
       */


      var el = this.$el;
      var body = document.body;
      var scrollBarWidth = getScrollBarWidth();

      if (val) {
        if (!this.modalIsLoading) {
          el.querySelector('.' + 'va-modal-content').focus();
        }

        el.style.display = 'block'; // this timeout is required for opacity transition

        setTimeout(function () {
          utils_element.addClass(el, 'va-modal-in');
        }, 20);
        utils_element.addClass(body, 'va-modal-open');

        if (!scrollBarWidth) {
          utils_element.addClass(body, 'va-modal-hide-y');
        }

        if (this.backdropClickable) {
          this._blurModalContentEvent = utils_EventListener.listen(this.$el, 'click', function (e) {
            if (e.target === el) _this4.isShow = false;
          });
        }

        if (!this.modalIsLoading) {
          this.focusTrap.activate();
        }
      } else {
        if (this._blurModalContentEvent) this._blurModalContentEvent.remove();
        utils_element.removeClass(el, 'va-modal-in');
        utils_element.addClass(el, 'va-modal-out');
        setTimeout(function () {
          el.style.display = 'none';
          utils_element.removeClass(body, 'va-modal-open');
          utils_element.removeClass(body, 'va-modal-hide-y');
          utils_element.removeClass(el, 'va-modal-out');
          body.style.paddingRight = '0';

          _this4.$emit('closed', {
            type: 'closed'
          });
        }, 300);
        this.focusTrap.deactivate();
      }
    }
  },
  methods: {
    isTop: function isTop() {
      return this.isShow && (!this.$refs.modal.style['margin-left'] || this.$refs.modal.style['margin-left'] === '0px');
    },
    close: function close() {
      this.isShow = false;
    },
    open: function open() {
      this.isShow = true;
    },
    confirm: function confirm() {
      this.$emit('confirm', {
        type: 'confirm'
      });
    }
  }
});
// CONCATENATED MODULE: ./src/Modal/VaModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var Modal_VaModalvue_type_script_lang_js_ = (VaModalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Modal/VaModal.vue?vue&type=style&index=0&lang=scss&
var VaModalvue_type_style_index_0_lang_scss_ = __webpack_require__("8423");

// CONCATENATED MODULE: ./src/Modal/VaModal.vue






/* normalize component */

var VaModal_component = normalizeComponent(
  Modal_VaModalvue_type_script_lang_js_,
  VaModalvue_type_template_id_55daa50e_render,
  VaModalvue_type_template_id_55daa50e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Modal_VaModal = (VaModal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Affix/VaAffix.vue?vue&type=template&id=63199ae2&
var VaAffixvue_type_template_id_63199ae2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-affix",style:(_vm.affixStyle)},[_vm._t("default")],2)}
var VaAffixvue_type_template_id_63199ae2_staticRenderFns = []


// CONCATENATED MODULE: ./src/Affix/VaAffix.vue?vue&type=template&id=63199ae2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Affix/VaAffix.vue?vue&type=script&lang=js&

//
//
//
//
//
//
/* harmony default export */ var VaAffixvue_type_script_lang_js_ = ({
  name: 'VaAffix',
  props: {
    offset: {
      type: [Number, String],
      default: 0,
      required: false
    }
  },
  computed: {
    affixStyle: function affixStyle() {
      return {
        top: "".concat(this.offset, "px")
      };
    }
  }
});
// CONCATENATED MODULE: ./src/Affix/VaAffix.vue?vue&type=script&lang=js&
 /* harmony default export */ var Affix_VaAffixvue_type_script_lang_js_ = (VaAffixvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Affix/VaAffix.vue?vue&type=style&index=0&lang=scss&
var VaAffixvue_type_style_index_0_lang_scss_ = __webpack_require__("ac62");

// CONCATENATED MODULE: ./src/Affix/VaAffix.vue






/* normalize component */

var VaAffix_component = normalizeComponent(
  Affix_VaAffixvue_type_script_lang_js_,
  VaAffixvue_type_template_id_63199ae2_render,
  VaAffixvue_type_template_id_63199ae2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaAffix = (VaAffix_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadio.vue?vue&type=template&id=69c2a00e&
var VaRadiovue_type_template_id_69c2a00e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:"va-radio-con"},[_c('span',{class:_vm.objClass},[_c('span',{class:"va-radio-inner",attrs:{"tabindex":_vm.disabled ? -1 : 0},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handleClick($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleClick($event)}}}),_c('input',{class:"va-radio-input",attrs:{"disabled":_vm.disabled,"name":_vm.name,"tabindex":"-1","type":"radio"},domProps:{"checked":_vm.currentChecked},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}})]),_c('span',{class:"va-label",attrs:{"tabindex":"-1"}},[_vm._t("default")],2),_c('validate',{attrs:{"current":_vm.checked,"custom-validate":_vm.customValidate,"name":_vm.name,"rules":_vm.rules}})],1)}
var VaRadiovue_type_template_id_69c2a00e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Radio/VaRadio.vue?vue&type=template&id=69c2a00e&

// CONCATENATED MODULE: ./src/Mixin/validationMixin.js
/* harmony default export */ var validationMixin = ({
  props: {
    name: {
      type: String
    },
    customValidate: {
      type: Function
    },
    rules: {
      type: Array
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadio.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VaRadiovue_type_script_lang_js_ = ({
  name: 'VaRadio',
  mixins: [validationMixin, events],
  props: {
    name: {
      type: String
    },
    value: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    validate: validate
  },
  data: function data() {
    var checked = this.checked;

    if (checked !== undefined) {
      this.$emit('input', checked);
    } else {
      checked = !!this.value;
    }

    return {
      currentChecked: checked
    };
  },
  computed: {
    objClass: function objClass() {
      var currentChecked = this.currentChecked,
          disabled = this.disabled;
      var classes = {};
      classes['va-radio-span'] = true;
      classes['va-radio-checked'] = currentChecked;
      classes['va-radio-disabled'] = disabled;
      return classes;
    }
  },
  watch: {
    value: function value(val) {
      this.currentChecked = val;
    },
    checked: function checked(val) {
      this.currentChecked = val;
    },
    currentChecked: function currentChecked(val) {
      this.$emit('input', val);
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@radiogroupChange', function (val) {
      // this.currentChecked = val.indexOf(this.label) > -1
      _this.currentChecked = val === _this.label;
    });
  },
  methods: {
    handleClick: function handleClick() {
      if (this.currentChecked) return;
      this.currentChecked = true;
      this.dispatch('VaRadioGroup', 'Va@radioChange', this.label);
      this.$emit('change', this.currentChecked);
    }
  }
});
// CONCATENATED MODULE: ./src/Radio/VaRadio.vue?vue&type=script&lang=js&
 /* harmony default export */ var Radio_VaRadiovue_type_script_lang_js_ = (VaRadiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Radio/VaRadio.vue?vue&type=style&index=0&lang=scss&
var VaRadiovue_type_style_index_0_lang_scss_ = __webpack_require__("1960");

// CONCATENATED MODULE: ./src/Radio/VaRadio.vue






/* normalize component */

var VaRadio_component = normalizeComponent(
  Radio_VaRadiovue_type_script_lang_js_,
  VaRadiovue_type_template_id_69c2a00e_render,
  VaRadiovue_type_template_id_69c2a00e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaRadio = (VaRadio_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Table/VaTable.vue?vue&type=template&id=b6b935dc&
var VaTablevue_type_template_id_b6b935dc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default")],2)}
var VaTablevue_type_template_id_b6b935dc_staticRenderFns = []


// CONCATENATED MODULE: ./src/Table/VaTable.vue?vue&type=template&id=b6b935dc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Table/VaTable.vue?vue&type=script&lang=js&

//
//
//
//
//
//
/* harmony default export */ var VaTablevue_type_script_lang_js_ = ({
  name: 'VaTable',
  props: {
    hover: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: String,
      default: 'lg',
      validator: function validator(v) {
        return ['lg', 'md', 'sm'].includes(v);
      }
    }
  },
  computed: {
    classObj: function classObj() {
      var size = this.size,
          hover = this.hover;
      var classes = {};
      classes['va-table'] = true;
      classes['va-table-' + size] = true;
      classes['va-table-hover'] = hover;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Table/VaTable.vue?vue&type=script&lang=js&
 /* harmony default export */ var Table_VaTablevue_type_script_lang_js_ = (VaTablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Table/VaTable.vue?vue&type=style&index=0&lang=scss&
var VaTablevue_type_style_index_0_lang_scss_ = __webpack_require__("243b");

// CONCATENATED MODULE: ./src/Table/VaTable.vue






/* normalize component */

var VaTable_component = normalizeComponent(
  Table_VaTablevue_type_script_lang_js_,
  VaTablevue_type_template_id_b6b935dc_render,
  VaTablevue_type_template_id_b6b935dc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTable = (VaTable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Alert/VaAlert.vue?vue&type=template&id=3c021d4e&
var VaAlertvue_type_template_id_3c021d4e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["va-alert", ("va-alert-" + _vm.type)]},[_c('div',{class:("va-alert-" + _vm.type + "-icon")},[_c('va-icon',{attrs:{"type":_vm.iconType,"icon-style":_vm.iconStyle}})],1),_c('div',[(_vm.title)?_c('h1',{class:("va-alert-" + _vm.type + "-title")},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',[_vm._t("default")],2)])])}
var VaAlertvue_type_template_id_3c021d4e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Alert/VaAlert.vue?vue&type=template&id=3c021d4e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Alert/VaAlert.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaAlertvue_type_script_lang_js_ = ({
  name: 'VaAlert',
  props: {
    title: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'warning',
      required: false,
      validator: function validator(v) {
        return ['success', 'info', 'warning', 'danger', 'help'].includes(v);
      }
    }
  },
  computed: {
    iconType: function iconType() {
      var type = this.type;

      switch (type) {
        case 'success':
          return 'check-circle';

        case 'info':
          return 'info-circle';

        case 'warning':
          return 'exclamation-circle';

        case 'help':
          return 'question-circle';

        case 'danger':
          return 'exclamation-circle';
      }

      return 'info-circle';
    },
    iconStyle: function iconStyle() {
      var type = this.type;

      switch (type) {
        case 'success':
          return 'solid';

        case 'info':
          return 'solid';

        case 'warning':
          return 'solid';

        case 'help':
          return 'solid';

        case 'danger':
          return 'solid';
      }

      return 'solid';
    }
  }
});
// CONCATENATED MODULE: ./src/Alert/VaAlert.vue?vue&type=script&lang=js&
 /* harmony default export */ var Alert_VaAlertvue_type_script_lang_js_ = (VaAlertvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Alert/VaAlert.vue?vue&type=style&index=0&lang=scss&
var VaAlertvue_type_style_index_0_lang_scss_ = __webpack_require__("818b");

// CONCATENATED MODULE: ./src/Alert/VaAlert.vue






/* normalize component */

var VaAlert_component = normalizeComponent(
  Alert_VaAlertvue_type_script_lang_js_,
  VaAlertvue_type_template_id_3c021d4e_render,
  VaAlertvue_type_template_id_3c021d4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaAlert = (VaAlert_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Aside/VaAside.vue?vue&type=template&id=62e17dbb&
var VaAsidevue_type_template_id_62e17dbb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":(this.placement === 'left') ? 'slideleft' : 'slideright'}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"aside",class:_vm.classObj,style:({width:_vm.width})},[_c('div',{class:"va-aside-dialog"},[_c('div',{class:"va-aside-content"},[(_vm.header)?_c('div',{class:"va-aside-header"},[_c('button',{class:"va-close",attrs:{"type":"button"},on:{"click":_vm.close}},[_c('span',[_vm._v("×")])]),_c('div',{class:"va-aside-title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{class:"va-aside-body"},[_vm._t("default")],2)])])])])}
var VaAsidevue_type_template_id_62e17dbb_staticRenderFns = []


// CONCATENATED MODULE: ./src/Aside/VaAside.vue?vue&type=template&id=62e17dbb&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Aside/VaAside.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VaAsidevue_type_script_lang_js_ = ({
  name: 'VaAside',
  props: {
    placement: {
      type: String,
      default: 'left',
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    header: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: String,
      default: '304px',
      required: false
    }
  },
  data: function data() {
    return {
      show: false,
      focusTrap: null
    };
  },
  computed: {
    classObj: function classObj() {
      var placement = this.placement;
      var classes = {};
      classes['va-aside'] = true;
      classes['va-aside-left'] = placement === 'left';
      classes['va-aside-right'] = placement === 'right';
      return classes;
    }
  },
  created: function created() {
    var _this = this;

    var escapeHandler = function escapeHandler(e) {
      if (e.key === 'Escape' && _this.show) {
        _this.close();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', function () {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    document.querySelector('body').appendChild(this.$refs.aside);
    this.$once('hook:beforeDestroy', function () {
      document.querySelector('body').removeChild(_this2.$refs.aside);
    });
    this.focusTrap = focus_trap_default()(this.$refs.aside, {
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: true,
      fallbackFocus: this.$refs.aside
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.performClose();
  },
  watch: {
    show: function show(val) {
      var _this3 = this;

      var backdrop = document.createElement('div');
      var body = document.body;
      backdrop.className = 'va-aside-backdrop';

      if (val) {
        body.appendChild(backdrop);
        utils_element.addClass(body, 'va-modal-open'); // This timeout is included to allow for opacity transition.

        setTimeout(function () {
          backdrop.className += ' ' + 'va-aside-in';
          _this3._clickEvent = utils_EventListener.listen(backdrop, 'click', _this3.close);

          _this3.$emit('show');
        }, 20);
        this.focusTrap.activate();
      } else {
        this.focusTrap.deactivate();
        this.performClose();
      }
    }
  },
  methods: {
    open: function open() {
      this.show = true;
    },
    close: function close() {
      this.show = false;
    },
    performClose: function performClose() {
      if (this._clickEvent) this._clickEvent.remove();
      var body = document.body;
      var backdrop = document.querySelector('.' + 'va-aside-backdrop');

      if (backdrop) {
        backdrop.className = 'va-aside-backdrop';
        setTimeout(function () {
          utils_element.removeClass(body, 'va-modal-open');
          body.removeChild(backdrop);
        }, 300);
        this.$emit('hide');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Aside/VaAside.vue?vue&type=script&lang=js&
 /* harmony default export */ var Aside_VaAsidevue_type_script_lang_js_ = (VaAsidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Aside/VaAside.vue?vue&type=style&index=0&lang=scss&
var VaAsidevue_type_style_index_0_lang_scss_ = __webpack_require__("cb1a");

// CONCATENATED MODULE: ./src/Aside/VaAside.vue






/* normalize component */

var VaAside_component = normalizeComponent(
  Aside_VaAsidevue_type_script_lang_js_,
  VaAsidevue_type_template_id_62e17dbb_render,
  VaAsidevue_type_template_id_62e17dbb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaAside = (VaAside_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Range/VaRange.vue?vue&type=template&id=876e0930&
var VaRangevue_type_template_id_876e0930_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",style:({width: _vm.width || '100%'})},[_c('input',{ref:"range",class:"va-range",attrs:{"type":"range","name":_vm.name,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.currentValue},on:{"input":_vm.onInput}}),_c('transition',{attrs:{"name":"fade"}},[(_vm.showoutput)?_c('div',{staticClass:"output_position"},[_c('output',{attrs:{"for":"r"}})]):_vm._e()])],1)}
var VaRangevue_type_template_id_876e0930_staticRenderFns = []


// CONCATENATED MODULE: ./src/Range/VaRange.vue?vue&type=template&id=876e0930&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Range/VaRange.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var VaRangevue_type_script_lang_js_ = ({
  name: 'VaRange',
  mixins: [events],
  props: {
    name: {
      type: String
    },
    min: {
      type: [String, Number],
      default: '0',
      required: false
    },
    max: {
      type: [String, Number],
      default: '100',
      required: false
    },
    step: {
      type: [String, Number],
      default: '1',
      required: false
    },
    value: {
      type: [Number, String],
      default: 0,
      required: false
    },
    width: {
      type: String
    }
  },
  data: function data() {
    var value = this.value;
    return {
      showoutput: false,
      currentValue: value,
      preBarElement: null,
      isMobile: false
    };
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.update();
    },
    value: function value(val) {
      this.currentValue = parseInt(val);
    },
    min: function min() {
      this.update();
    },
    max: function max() {
      this.update();
    },
    step: function step() {
      this.update();
    }
  },
  methods: {
    update: function update() {
      this.preBarElement.style.width = this.getVal() + 'px';
    },
    onInput: function onInput(e) {
      this.currentValue = parseInt(e.target.value);
      this.$emit('input', parseInt(e.target.value));
    },
    getVal: function getVal() {
      if (!this.$refs.range) return;
      var w = parseInt(this.$refs.range.clientWidth, 10);
      var cv = parseInt(this.currentValue, 10);
      var min = parseInt(this.min, 10);
      var max = parseInt(this.max, 10);
      /**
       *  I wonder if there's a way to figure out the width of the runnable track..
       *  Right now, we listen for isMobile from App.
       *  Width is 16px on desktop, 28px on mobile.
       */

      var thumbWidth;
      this.isMobile ? thumbWidth = 28 : thumbWidth = 16;
      max = max - min;
      cv = cv - min;
      min = min - min;

      if (min === 0 && max === 100) {
        return cv * w / 100 - cv * thumbWidth / 100; // because the thumb is 16px wide
      } else {
        var p = cv * 100 / max;
        var pp = p * w / 100;
        pp = pp - p * thumbWidth / 100;
        return pp;
      }
    },
    init: function init() {
      var _this = this;

      var wrp = document.createElement('div');
      var preBar = document.createElement('p');
      wrp.className = 'va-range-barCnt';
      preBar.className = 'va-range-preBar';
      this.$refs.range.className = this.$refs.range.className.length ? this.$refs.range.className + ' colorized' : 'colorized';
      this.$refs.range.parentNode.replaceChild(wrp, this.$refs.range);
      wrp.appendChild(this.$refs.range);
      wrp.appendChild(preBar);
      var r = this.$refs.range;
      this._inputEvent = utils_EventListener.listen(r, 'input', function () {
        preBar.style.width = _this.getVal() + 'px';
      });
      this.$nextTick(function () {
        preBar.style.width = _this.getVal() + 'px';
      });
      this.$refs.range.value = this.value;
      this.preBarElement = preBar;
    },
    _resizeEvent: function _resizeEvent() {
      this.update();
    }
  },
  computed: {
    styleObj: function styleObj() {
      var style = {};
      var l = this.value - this.min;
      var r = this.max - this.min;
      style['transform'] = 'translate(calc(' + l / r + ' * 11.25em - 50%))';
      return style;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$on('Va@rangeIsMobile', function (val) {
      if (val === true) {
        _this2.isMobile = true;
      } else {
        _this2.isMobile = false;
      }
    });
    this.dispatch('VaApp', 'Va@requestIsMobile', true);
  },
  mounted: function mounted() {
    this.init();
    window.addEventListener('resize', this._resizeEvent, false);
  },
  beforeDestroy: function beforeDestroy() {
    if (this._inputEvent) this._inputEvent.remove();
    if (this._mouseupEvent) this._mouseupEvent.remove();
    if (this._mousedownEvent) this._mousedownEvent.remove();
    /**
     * This event was not created using EventListener.
     */

    window.removeEventListener('resize', this._resizeEvent, false);
  }
});
// CONCATENATED MODULE: ./src/Range/VaRange.vue?vue&type=script&lang=js&
 /* harmony default export */ var Range_VaRangevue_type_script_lang_js_ = (VaRangevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Range/VaRange.vue?vue&type=style&index=0&lang=scss&
var VaRangevue_type_style_index_0_lang_scss_ = __webpack_require__("93aa");

// CONCATENATED MODULE: ./src/Range/VaRange.vue






/* normalize component */

var VaRange_component = normalizeComponent(
  Range_VaRangevue_type_script_lang_js_,
  VaRangevue_type_template_id_876e0930_render,
  VaRangevue_type_template_id_876e0930_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaRange = (VaRange_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Badge/VaBadge.vue?vue&type=template&id=754cb39c&
var VaBadgevue_type_template_id_754cb39c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classObj,style:({ margin: _vm.margin })},[_vm._t("default")],2)}
var VaBadgevue_type_template_id_754cb39c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Badge/VaBadge.vue?vue&type=template&id=754cb39c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Badge/VaBadge.vue?vue&type=script&lang=js&

//
//
//
//
//
//
/* harmony default export */ var VaBadgevue_type_script_lang_js_ = ({
  name: 'VaBadge',
  props: {
    type: {
      type: String,
      default: 'default',
      required: false,
      validator: function validator(v) {
        return ['default', 'primary', 'success', 'info', 'warning', 'danger'].includes(v);
      }
    },
    margin: {
      type: String,
      default: '0px',
      required: false
    }
  },
  computed: {
    classObj: function classObj() {
      var type = this.type;
      var classes = {};
      classes['va-badge'] = true;
      classes['va-badge-' + type] = true;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Badge/VaBadge.vue?vue&type=script&lang=js&
 /* harmony default export */ var Badge_VaBadgevue_type_script_lang_js_ = (VaBadgevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Badge/VaBadge.vue?vue&type=style&index=0&lang=scss&
var VaBadgevue_type_style_index_0_lang_scss_ = __webpack_require__("9fbc");

// CONCATENATED MODULE: ./src/Badge/VaBadge.vue






/* normalize component */

var VaBadge_component = normalizeComponent(
  Badge_VaBadgevue_type_script_lang_js_,
  VaBadgevue_type_template_id_754cb39c_render,
  VaBadgevue_type_template_id_754cb39c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaBadge = (VaBadge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaColumn.vue?vue&type=template&id=74a7a532&
var VaColumnvue_type_template_id_74a7a532_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default")],2)}
var VaColumnvue_type_template_id_74a7a532_staticRenderFns = []


// CONCATENATED MODULE: ./src/Grid/VaColumn.vue?vue&type=template&id=74a7a532&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaColumn.vue?vue&type=script&lang=js&


//
//
//
//
//
//
/* harmony default export */ var VaColumnvue_type_script_lang_js_ = ({
  name: 'VaColumn',
  props: {
    xs: Number,
    sm: Number,
    md: Number,
    lg: Number
  },
  computed: {
    classObj: function classObj() {
      var _ref;

      return ['va-col', (_ref = {}, _defineProperty(_ref, "va-col-xs-".concat(this.xs), this.xs), _defineProperty(_ref, "va-col-sm-".concat(this.sm), this.sm), _defineProperty(_ref, "va-col-md-".concat(this.md), this.md), _defineProperty(_ref, "va-col-lg-".concat(this.lg), this.lg), _ref)];
    }
  }
});
// CONCATENATED MODULE: ./src/Grid/VaColumn.vue?vue&type=script&lang=js&
 /* harmony default export */ var Grid_VaColumnvue_type_script_lang_js_ = (VaColumnvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Grid/VaColumn.vue





/* normalize component */

var VaColumn_component = normalizeComponent(
  Grid_VaColumnvue_type_script_lang_js_,
  VaColumnvue_type_template_id_74a7a532_render,
  VaColumnvue_type_template_id_74a7a532_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaColumn = (VaColumn_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Select/VaOption.vue?vue&type=template&id=0f790d8c&
var VaOptionvue_type_template_id_0f790d8c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticStyle:{"position":"relative"}},[_c('a',{class:_vm.classes,on:{"click":function($event){$event.preventDefault();return _vm.selectOption(_vm.option)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.fullLabel))])],2)])}
var VaOptionvue_type_template_id_0f790d8c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Select/VaOption.vue?vue&type=template&id=0f790d8c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Select/VaOption.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var VaOptionvue_type_script_lang_js_ = ({
  name: 'VaOption',
  inject: ['addSelectOption', 'isOptionSelected', 'selectOption'],
  props: {
    value: {},
    label: {
      type: String,
      required: false
    }
  },
  computed: {
    fullLabel: function fullLabel() {
      return this.label || this.value;
    },
    option: function option() {
      return {
        label: this.fullLabel,
        value: this.value
      };
    },
    classes: function classes() {
      var classes = {};
      classes['va-select-item-active'] = this.isOptionSelected(this.option);
      return classes;
    }
  },
  mounted: function mounted() {
    this.addSelectOption(this.value, this.fullLabel);
  }
});
// CONCATENATED MODULE: ./src/Select/VaOption.vue?vue&type=script&lang=js&
 /* harmony default export */ var Select_VaOptionvue_type_script_lang_js_ = (VaOptionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Select/VaOption.vue





/* normalize component */

var VaOption_component = normalizeComponent(
  Select_VaOptionvue_type_script_lang_js_,
  VaOptionvue_type_template_id_0f790d8c_render,
  VaOptionvue_type_template_id_0f790d8c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaOption = (VaOption_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Button/VaButton.vue?vue&type=template&id=4da8f70e&
var VaButtonvue_type_template_id_4da8f70e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"btn",class:_vm.classObj,style:(_vm.styleObj),on:{"click":_vm.onClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterKeyDown($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterKeyUp($event)}}},[_c('div',{class:_vm.innerClassObj,style:(_vm.innerStyleObj)},[(_vm.iconBefore !== undefined)?_c('va-icon',{style:(_vm.iconBeforeStyleObj),attrs:{"type":_vm.iconBefore}}):_vm._e(),_vm._t("default"),(_vm.iconAfter !== undefined)?_c('va-icon',{style:(_vm.iconAfterStyleObj),attrs:{"type":_vm.iconAfter}}):_vm._e()],2),(_vm.loadingSpinner)?_c('va-loading',{attrs:{"color":_vm.spinColor,"size":_vm.size}}):_vm._e()],1)}
var VaButtonvue_type_template_id_4da8f70e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Button/VaButton.vue?vue&type=template&id=4da8f70e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Button/VaButton.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaButtonvue_type_script_lang_js_ = ({
  name: 'VaButton',
  props: {
    type: {
      type: String,
      default: 'default',
      required: false,
      validator: function validator(v) {
        return ['default', 'primary', 'primary-light', 'primary-dark', 'paleblue', 'success', 'info', 'warning', 'danger', 'subtle', 'link', 'subtle-link', 'active', 'dark', 'darker', 'help', 'help-light', 'help-dark', 'black'].includes(v);
      }
    },
    size: {
      type: String,
      default: 'md',
      required: false,
      validator: function validator(v) {
        return ['xs', 'sm', 'md', 'lg'].includes(v);
      }
    },
    active: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    block: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: false,
      required: false
    },
    round: {
      type: Boolean,
      default: false,
      required: false
    },
    focused: {
      type: Boolean,
      default: false,
      required: false
    },
    tall: {
      type: Boolean,
      default: false,
      required: false
    },
    iconBefore: {
      type: String,
      required: false
    },
    iconAfter: {
      type: String,
      required: false
    }
  },
  data: function data() {
    var loading = this.loading;
    return {
      loadingSpinner: loading,
      isFocused: this.focused,
      componentWasMounted: false
    };
  },
  computed: {
    spinColor: function spinColor() {
      var type = this.type,
          active = this.active;
      var white = '#FFFFFF';
      var darker = '#45526B';

      if (active) {
        return darker;
      }

      switch (type) {
        case 'default':
          return darker;

        case 'primary':
          return white;

        case 'primary-light':
          return white;

        case 'primary-dark':
          return white;

        case 'success':
          return white;

        case 'info':
          return white;

        case 'warning':
          return darker;

        case 'subtle':
          return darker;

        case 'link':
          return darker;

        case 'subtle-link':
          return darker;

        case 'danger':
          return white;

        case 'dark':
          return white;

        case 'darker':
          return white;
      }

      return white;
    },
    classObj: function classObj() {
      var type = this.type,
          size = this.size,
          block = this.block,
          active = this.active,
          disabled = this.disabled,
          round = this.round,
          isFocused = this.isFocused;
      var classes = {};
      classes['va-btn'] = true;
      classes['va-btn-block'] = block;
      classes['va-btn-active'] = active;
      classes['va-btn-disabled'] = disabled;
      size ? classes['va-btn-' + size] = true : '';
      type ? classes['va-btn-' + type] = true : '';
      classes['va-btn-round'] = round;
      classes['va-btn-' + type + '-focused'] = isFocused;
      return classes;
    },
    innerClassObj: function innerClassObj() {
      var loadingSpinner = this.loadingSpinner;
      var classes = {};
      classes['va-btn-text-fade'] = true;
      loadingSpinner ? classes['va-btn-text-fade-out'] = true : '';
      return classes;
    },
    innerStyleObj: function innerStyleObj() {
      var iconBefore = this.iconBefore,
          iconAfter = this.iconAfter;
      var style = {};

      if (this.componentWasMounted) {
        var l = iconBefore !== undefined;
        var r = iconAfter !== undefined;

        if (this.$el.style.width !== '100%') {
          if (l) {
            style['padding-left'] = '26px';
          }

          if (r) {
            style['padding-right'] = '26px';
          }
        }
      }

      return style;
    },
    styleObj: function styleObj() {
      var tall = this.tall;
      var style = {};

      if (tall) {
        style['height'] = '100%';
        style['border-radius'] = '0px';
      }

      return style;
    },
    iconBeforeStyleObj: function iconBeforeStyleObj() {
      var style = {};
      style['position'] = 'absolute';
      style['left'] = '3px';
      return style;
    },
    iconAfterStyleObj: function iconAfterStyleObj() {
      var style = {};
      style['position'] = 'absolute';
      style['right'] = '3px';
      return style;
    }
  },
  watch: {
    loading: function loading(val) {
      var _this = this;

      if (val) {
        var rect = this.$el.getBoundingClientRect();
        this.$el.style.width = rect.width + 'px';
        this.$el.style.height = rect.height + 'px';
        this.loadingSpinner = true;
      } else {
        this.$el.style.width = 'auto';
        this.$el.style.height = 'auto';
        this.$nextTick(function () {
          _this.loadingSpinner = false;
        });
      }
    }
  },
  methods: {
    triggerMouseEvent: function triggerMouseEvent(node, eventType) {
      var clickEvent = document.createEvent('MouseEvents');
      clickEvent.initEvent(eventType, true, true);
      this.$refs.btn.dispatchEvent(clickEvent);
    },
    enterKeyDown: function enterKeyDown() {
      this.triggerMouseEvent(this.$refs.btn, 'mouseover');
      this.triggerMouseEvent(this.$refs.btn, 'mousedown');
    },
    enterKeyUp: function enterKeyUp() {
      if (this.disabled) {
        return;
      }

      this.triggerMouseEvent(this.$refs.btn, 'mouseup');
      this.triggerMouseEvent(this.$refs.btn, 'click');
    },
    focus: function focus() {
      this.$refs.btn.focus();
    },
    onClick: function onClick(event) {
      if (this.disabled) {
        return;
      }

      this.$emit('click', event);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var el = _this2.$el;
      _this2.componentWasMounted = true;
      _this2._clickEvent = utils_EventListener.listen(window, 'click', function (e) {
        if (!el.contains(e.target)) {
          _this2.isFocused = false;
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._clickEvent) this._clickEvent.remove();
  }
});
// CONCATENATED MODULE: ./src/Button/VaButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var Button_VaButtonvue_type_script_lang_js_ = (VaButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Button/VaButton.vue?vue&type=style&index=0&lang=scss&
var VaButtonvue_type_style_index_0_lang_scss_ = __webpack_require__("30bd");

// CONCATENATED MODULE: ./src/Button/VaButton.vue






/* normalize component */

var VaButton_component = normalizeComponent(
  Button_VaButtonvue_type_script_lang_js_,
  VaButtonvue_type_template_id_4da8f70e_render,
  VaButtonvue_type_template_id_4da8f70e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaButton = (VaButton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Select/VaSelect.vue?vue&type=template&id=f84c2542&
var VaSelectvue_type_template_id_f84c2542_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj,style:(_vm.styleObj)},[_c('va-button',{ref:"button",class:["va-dropdown-toggle", "va-select-btn", _vm.showSelected && _vm.multiple && _vm.value.length ? "va-select-multiple" : '', _vm.show ? "va-select-btn-open" : ''],style:({minWidth:'100%'}),attrs:{"disabled":_vm.disabled,"size":_vm.size,"type":_vm.type},nativeOn:{"mousedown":function($event){return _vm.toggleDropdown($event)}}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showPlaceholder || !_vm.showSelected)?_c('span',{class:"va-select-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e()]),(_vm.showSelected)?_c('span',{staticStyle:{"display":"flex","flex-wrap":"wrap","margin-right":"14px"}},[(_vm.multiple)?[_c('transition-group',{staticClass:"va-trans-group-flex",attrs:{"name":"fade"}},_vm._l((_vm.selectedItems),function(item,index){return _c('div',{key:index,class:"va-selected-tag va-selected-tag-multiple",attrs:{"tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.del(item)}}},[_c('span',{class:"va-selected-tag__label"},[_vm._t("item",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.format(item))}})],{"item":item})],2),_c('span',{class:"va-selected-tag__icon"},[_c('va-icon',{attrs:{"type":"times"}})],1)])}),0)]:[_c('div',{staticClass:"va-single-flex-wrap"},[_vm._t("item",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.format(_vm.selectedItems[0]))}})],{"item":_vm.selectedItems[0]})],2)]],2):_vm._e(),_vm._v(" "),_c('va-icon',{attrs:{"type":_vm.show ? 'angle-up' : 'angle-down',"color":"#A5ADBA"}})],1),_c('transition',{attrs:{"name":"fadeDown"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"},{name:"va-position",rawName:"v-va-position",value:(_vm.show),expression:"show"}],ref:"menu",class:["va-dropdown-menu", _vm.search ? "va-has-search" : ""],style:({minWidth: '100%', maxHeight: _vm.menuMaxHeight})},[(_vm.search)?_c('li',[_c('div',{class:"va-search-wrap"},[_c('va-input',{ref:"searchInput",class:"va-select-search",attrs:{"placeholder":_vm.inputPlaceholder,"icon":"search","icon-style":"solid","clearable":""},on:{"confirm":_vm.addExtra},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)]):_vm._e(),(_vm.multiple)?_c('li',{class:"va-select-all"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.selectAll($event)}}},[_vm._v(" "+_vm._s(_vm.getL('all'))+" "),_c('va-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.allSelected),expression:"allSelected"}],attrs:{"color":"#0052CC","margin":"5px 0 0 0","size":"10px","type":"check"}})],1)]):_vm._e(),_c('div',{class:"va-select-items-wrapper"},[_vm._t("default",_vm._l((_vm.filterOptions),function(option,index){return _c('va-option',{key:index,attrs:{"label":option.label,"value":option.value}})}))],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNotify),expression:"showNotify"}],class:"va-notify",attrs:{"transition":"fadeDown"}},[_vm._v("Limit: "+_vm._s(_vm.limit))])])]),_c('div',{staticClass:"clearfix"}),_c('validate',{attrs:{"current":_vm.value,"custom-validate":_vm.customValidate,"name":_vm.name,"rules":_vm.rules},model:{value:(_vm.validStatus),callback:function ($$v) {_vm.validStatus=$$v},expression:"validStatus"}})],1)}
var VaSelectvue_type_template_id_f84c2542_staticRenderFns = []


// CONCATENATED MODULE: ./src/Select/VaSelect.vue?vue&type=template&id=f84c2542&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Select/VaSelect.vue?vue&type=script&lang=js&












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var VaSelectvue_type_script_lang_js_ = ({
  name: 'VaSelect',
  mixins: [validationMixin, inputMixin, localeMixin('VaSelect')],
  props: {
    showSelected: {
      type: Boolean,
      default: true,
      required: false
    },
    inputPlaceholder: {
      type: String,
      default: '',
      required: false
    },
    size: {
      type: String,
      required: false
    },
    context: {},
    type: {
      type: String,
      default: 'default',
      required: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    value: {},
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
    search: {
      type: Boolean,
      default: false,
      required: false
    },
    extra: {
      type: Boolean,
      default: false,
      required: false
    },
    limit: {
      type: Number,
      default: 1024,
      required: false
    },
    menuMaxHeight: {
      type: String,
      default: '300px',
      required: false
    },
    matchCase: {
      type: Boolean,
      default: false,
      required: false
    },
    format: {
      type: Function,
      default: function _default(item) {
        if (!item) return '';
        return item.label;
      }
    },
    noUncheck: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      validStatus: '',
      searchText: '',
      show: false,
      showNotify: false,
      currentValue: this.value,
      currentOptions: this.options,
      activeItemClass: 'va-select-item-active'
    };
  },
  provide: function provide() {
    return {
      addSelectOption: this.addOption,
      selectOption: this.select,
      isOptionSelected: this.isSelected
    };
  },
  watch: {
    value: function value(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.currentValue = val;
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    multiple: function multiple(val) {
      if (val === false) {
        if (Array.isArray(this.value) && this.value.length > 1) {
          this.value = this.value[0];
        }
      }
    },
    show: function show(val) {
      if (val) {
        if (this.search) {
          this.$refs.searchInput.focus();
        }
      }
    }
  },
  components: {
    validate: validate
  },
  created: function created() {
    document.addEventListener('keyup', this.keyup);
  },
  computed: {
    defaultSlotWasUsed: function defaultSlotWasUsed() {
      return !!this.$slots.default;
    },
    styleObj: function styleObj() {
      var style = {};
      var actualWidth = this.actualWidth;
      actualWidth.slice(-1) === '%' ? style['width'] = actualWidth : style['min-width'] = actualWidth;
      return style;
    },
    classObj: function classObj() {
      var validStatus = this.validStatus;
      var classes = {};
      classes['va-has-error'] = validStatus === 'error';
      classes['va-has-success'] = validStatus === 'success';
      classes['va-has-warn'] = validStatus === 'warn';
      classes['va-btn-group'] = true;
      classes['va-select-group'] = true;
      classes['va-dropdown-con'] = true;
      return classes;
    },
    filterOptions: function filterOptions() {
      return this.filter(this.currentOptions, this.searchText);
    },
    selectedItems: {
      get: function get() {
        var a;

        if (utils_type.isArray(this.currentValue)) {
          a = this.currentValue;
        } else {
          a = [this.currentValue];
        }

        return this.findInOptions(a);
      },
      set: function set(value) {
        var self = this;

        if (this.multiple) {
          var ret = [];

          for (var i = 0; i < value.length; i++) {
            ret.push(value[i].value);
          }

          var timeout;
          if (timeout) clearTimeout(timeout);

          if (ret.length > this.limit) {
            this.showNotify = true;
            this.remove(value, this.limit);
            timeout = setTimeout(function () {
              self.showNotify = false;
            }, 1000);
          } else {
            this.currentValue = ret;
          }
        } else {
          this.currentValue = value[0] ? value[0].value : '';
        }
      }
    },
    allSelected: function allSelected() {
      var options = this.filter(this.currentOptions, this.searchText);
      var values = this.currentValue;

      if (!values || options.length !== values.length || options.length === 0) {
        return false;
      }

      for (var i = 0, l = options.length; i < l; i++) {
        var value = options[i].value;

        if (values.indexOf(value) === -1) {
          return false;
        }
      }

      return true;
    },
    showPlaceholder: function showPlaceholder() {
      if (utils_type.isArray(this.currentValue)) {
        return this.currentValue.length <= 0;
      } else {
        return !this.currentValue;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._closeEvent = utils_EventListener.listen(window, 'click', function (e) {
        if (!_this.$el.contains(e.target)) _this.show = false;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._closeEvent) this._closeEvent.remove();
    document.removeEventListener('keyup', this.keyup);
  },
  methods: {
    isSelected: function isSelected(option) {
      return this.findIndex(option.value) !== -1;
    },
    keyup: function keyup(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },
    filter: function filter(options, search) {
      if (search === '') return options;
      var ret = [];

      for (var i = 0, l = options.length; i < l; i++) {
        var v = options[i] && String(options[i].label).replace(/<.*?>/g, '');
        var s = search;

        if (!this.matchCase) {
          v = v.toLocaleLowerCase();
          s = s.toLocaleLowerCase();
        }

        if (v !== '' && v.includes(s)) {
          ret.push(options[i]);
        }
      }

      return ret;
    },
    selectAll: function selectAll() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.filter(this.currentOptions, this.searchText);
      }
    },
    addExtra: function addExtra() {
      if (this.extra && this.searchText.replace(/\s+$|^\s+/g, '')) {
        this.addOption(this.searchText, this.searchText);
        this.add({
          value: this.searchText,
          label: this.searchText
        });
        this.searchText = '';
      }
    },
    findInOptions: function findInOptions(a) {
      var options = this.currentOptions;
      var ret = [];

      for (var i = 0; i < a.length; i++) {
        var s = this.find(a[i], options);
        s != null ? ret.push(s) : 0;
      }

      return ret;
    },
    find: function find(v, array) {
      var a = array || this.selectedItems;

      for (var i = 0; i < a.length; i++) {
        if (JSON.stringify(v) === JSON.stringify(a[i].value)) {
          return a[i];
        }
      }

      return null;
    },
    findIndex: function findIndex(v, array) {
      var a = array || this.selectedItems;

      for (var i = 0; i < a.length; i++) {
        if (JSON.stringify(v) === JSON.stringify(a[i].value)) {
          return i;
        }
      }

      return -1;
    },
    optionExists: function optionExists(option) {
      return this.currentOptions.map(function (option) {
        return option.value;
      }).indexOf(option.value) !== -1;
    },
    addOption: function addOption(value, label) {
      var option = {
        value: value,
        label: label
      };

      if (this.optionExists(option)) {
        return;
      }

      this.currentOptions.push(option);
    },
    add: function add(option) {
      var a = this.selectedItems.slice(0);

      if (this.multiple) {
        a.push(option);
      } else {
        a = [option];
      }

      this.selectedItems = a;
    },
    del: function del(item) {
      var index = this.findIndex(item.value);
      this.remove(this.selectedItems, index, 1);
    },
    remove: function remove(array, index, num) {
      var a = array.slice(0);
      num ? a.splice(index, num) : a.splice(index);
      this.selectedItems = a;
    },
    select: function select(option) {
      var index = this.findIndex(option.value);

      if (this.multiple) {
        index === -1 ? this.add(option) : this.remove(this.selectedItems, index, 1);
      } else {
        index === -1 ? this.selectedItems = [option] : this.noUncheck ? this.selectedItems = [option] : this.selectedItems = [];
        this.show = false;
        this.$refs.button.focus();
      }
    },
    toggleDropdown: function toggleDropdown(e) {
      var tagName = e.target.tagName.toUpperCase(); // If the target wasn't the button, don't open it

      if (tagName !== 'BUTTON') {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (!this.disabled && !this.readonly) {
        this.show = !this.show;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Select/VaSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var Select_VaSelectvue_type_script_lang_js_ = (VaSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Select/VaSelect.vue?vue&type=style&index=0&lang=scss&
var VaSelectvue_type_style_index_0_lang_scss_ = __webpack_require__("773a");

// CONCATENATED MODULE: ./src/Select/VaSelect.vue






/* normalize component */

var VaSelect_component = normalizeComponent(
  Select_VaSelectvue_type_script_lang_js_,
  VaSelectvue_type_template_id_f84c2542_render,
  VaSelectvue_type_template_id_f84c2542_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Select_VaSelect = (VaSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Topbar/VaTopbar.vue?vue&type=template&id=4f1e7114&
var VaTopbarvue_type_template_id_4f1e7114_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj,style:(_vm.styleObj)},[_c('div',{class:"va-topbar-inner"},[_c('div',{class:"va-topbar-left"},[_vm._t("left")],2),_c('div',{class:"va-topbar-center"},[_vm._t("center")],2),_c('div',{class:"va-topbar-right"},[_vm._t("right")],2)])])}
var VaTopbarvue_type_template_id_4f1e7114_staticRenderFns = []


// CONCATENATED MODULE: ./src/Topbar/VaTopbar.vue?vue&type=template&id=4f1e7114&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Topbar/VaTopbar.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaTopbarvue_type_script_lang_js_ = ({
  name: 'VaTopbar',
  mixins: [events],
  props: {
    theme: {
      type: String,
      default: 'blue',
      required: false
    }
  },
  data: function data() {
    var t = this.theme;
    return {
      currentDesktopMinimumWidth: 0,
      currentDesktopMargin: 0,
      currentContentWidth: 0,
      currentTopbarHeight: 0,
      currentMinibarWidth: 0,
      currentSidebarWidth: 0,
      sidebarPriority: false,
      minibarPriority: false,
      currentWindowWidth: 0,
      topbarPriority: false,
      topbarPadded: false,
      isReverse: false,
      isMobile: false,
      isSplit: false,
      isRTL: false,
      th: t
    };
  },
  mounted: function mounted() {
    var _this = this;

    /**
     * This needs to be wrapped in a short setTimeout to give
     * App time to call enableReceivers().
     */
    setTimeout(function () {
      _this.dispatch('VaApp', 'Va@configTopbarThemeChange', _this.th);
    }, 10);
  },
  created: function created() {
    var _this2 = this;

    this.$on('Va@topbarPresenceCheck', function () {
      _this2.dispatch('VaApp', 'Va@topbarPresenceReply', true);
    });
    this.$on('Va@desktopMinimumWidthChange', function (val) {
      _this2.currentDesktopMinimumWidth = val;
    });
    this.$on('Va@desktopMarginChange', function (val) {
      _this2.currentDesktopMargin = val;
    });
    this.$on('Va@minibarWidthChange', function (val) {
      _this2.currentMinibarWidth = val;
    });
    this.$on('Va@topbarHeightChange', function (val) {
      _this2.currentTopbarHeight = val;
    });
    this.$on('Va@contentWidthChange', function (val) {
      _this2.currentContentWidth = val;
    });
    this.$on('Va@sidebarWidthChange', function (val) {
      _this2.currentSidebarWidth = val;
    });
    this.$on('Va@sidebarPriorityChange', function (val) {
      _this2.sidebarPriority = val;
    });
    this.$on('Va@minibarPriorityChange', function (val) {
      _this2.minibarPriority = val;
    });
    this.$on('Va@windowWidthChange', function (val) {
      _this2.currentWindowWidth = val;
    });
    this.$on('Va@topbarPriorityChange', function (val) {
      _this2.topbarPriority = val;
    });
    this.$on('Va@topbarPaddedChange', function (val) {
      _this2.topbarPadded = val;
    });
    this.$on('Va@reverseChange', function (val) {
      _this2.isReverse = val;
    });
    this.$on('Va@topbarIsMobile', function (val) {
      _this2.isMobile = val;
    });
    this.$on('Va@topbarThemeChange', function (val) {
      _this2.th = val;
    });
    this.$on('Va@splitChange', function (val) {
      _this2.isSplit = val;
    });
    this.$on('Va@rtlChange', function (val) {
      _this2.isRTL = val;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('VaApp', 'Va@topbarDisconnect', true);
  },
  watch: {
    theme: function theme(val) {
      this.th = val;
      this.dispatch('VaApp', 'Va@configTopbarThemeChange', this.th);
    }
  },
  computed: {
    classObj: function classObj() {
      var th = this.th;
      var classes = {};
      classes['va-topbar'] = true;
      classes['va-topbar--theme-' + th] = true;
      return classes;
    },
    styleObj: function styleObj() {
      var dmw = parseInt(this.currentDesktopMinimumWidth);
      var dm = parseInt(this.currentDesktopMargin);
      var th = parseInt(this.currentTopbarHeight);
      var sw = parseInt(this.currentSidebarWidth);
      var cw = parseInt(this.currentContentWidth);
      var mw = parseInt(this.currentMinibarWidth);
      var sp = this.sidebarPriority;
      var mp = this.minibarPriority;
      var tp = this.topbarPriority;
      var tpad = this.topbarPadded;
      var reverse = this.isReverse;
      var mobile = this.isMobile;
      var split = this.isSplit;
      var rtl = this.isRTL;
      var style = {};
      style['height'] = th + 'px';
      style['left'] = '0px';
      style['right'] = '0px';
      /**
       * Adjust the margins if content width is smaller than
       * desktop minimum width.
       */

      if (!mobile) {
        if (cw < dmw) {
          var x = dmw - cw;
          dm = dm - x / 2;
        }
      } else {
        dm = 0;
        dmw = 0;
      }
      /**
       * If a minimum desktop width is set
       */


      if (dmw !== 0) {
        style['min-width'] = dmw - mw - sw + 'px';
      } else {
        style['min-width'] = '0px';
      }
      /**
       * Ready to be thoroughly confused?
       */


      if (sp) {
        if (split) {
          if (reverse) {
            if (mp) {
              style['left'] = dm + sw + 'px';
              style['right'] = dm + mw + 'px';
            } else {
              style['left'] = dm + sw + 'px';
              style['right'] = dm + 'px';
            }
          } else {
            if (mp) {
              style['left'] = dm + mw + 'px';
              style['right'] = dm + sw + 'px';
            } else {
              style['left'] = dm + 'px';
              style['right'] = dm + sw + 'px';
            }
          }
        } else {
          if (reverse) {
            if (mp) {
              style['left'] = sw + mw + dm + 'px';
              style['right'] = dm + 'px';
            } else {
              style['left'] = dm + sw + 'px';
              style['right'] = dm + 'px';
            }
          } else {
            if (mp) {
              style['left'] = sw + mw + dm + 'px';
              style['right'] = dm + 'px';
            } else {
              style['left'] = sw + mw + dm + 'px';
              style['right'] = dm + 'px';
            }
          }
        }
      }

      if (!sp) {
        if (split) {
          if (reverse) {
            if (mp) {
              style['left'] = dm + 'px';
              style['right'] = dm + mw + 'px';
            } else {
              style['left'] = dm + 'px';
              style['right'] = dm + 'px';
            }
          } else {
            if (mp) {
              style['left'] = dm + mw + 'px';
              style['right'] = dm + 'px';
            } else {
              style['left'] = dm + 'px';
              style['right'] = dm + 'px';
            }
          }
        } else {
          if (reverse) {
            if (mp) {
              style['left'] = sw + mw + dm + 'px';
              style['right'] = dm + 'px';
            } else {
              style['left'] = dm + 'px';
              style['right'] = dm + 'px';
            }
          } else {
            if (mp) {
              style['left'] = dm + mw + 'px';
              style['right'] = dm + 'px';
            } else {
              style['left'] = dm + 'px';
              style['right'] = dm + 'px';
            }
          }
        }
      }

      if (rtl) {
        // rtl only effective when not split
        if (!split) {
          if (reverse) {
            if (sp) {
              style['left'] = dm + 'px';
              style['right'] = sw + mw + dm + 'px';
            } else {
              if (mp) {
                style['left'] = dm + 'px';
                style['right'] = dm + mw + 'px';
              }
            }
          } else {
            if (sp) {
              if (mp) {
                style['right'] = mw + sw + dm + 'px';
                style['left'] = dm + 'px';
              } else {
                style['right'] = dm + sw + 'px';
                style['left'] = dm + 'px';
              }
            } else {
              if (mp) {
                style['right'] = mw + sw + dm + 'px';
                style['left'] = dm + 'px';
              }
            }
          }
        }
      }

      if (tp) {
        style['left'] = '0px';
        style['right'] = '0px';

        if (tpad) {
          style['padding-left'] = dm + 8 + 'px';
          style['padding-right'] = dm + 8 + 'px';
          /**
           * Why 8px?
           * Because a 50px Minibar looks best, and if the
           * first or last element in a padded topbar is
           * an icon, this lines it up nicely with the
           * icons in the Minibar.
           */
        }
      } // Less than 40 and we don't want overflow.
      // Greater than 40 and we do, because we don't want
      // to hide dropdown menus.
      // That means..
      // Dropdown menus in the topbar won't appear when the
      // topbar has a height of less than 40px.


      if (th < 40) {
        style['overflow'] = 'hidden';
      } else {
        style['overflow'] = 'visible';
      }

      return style;
    }
  }
});
// CONCATENATED MODULE: ./src/Topbar/VaTopbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var Topbar_VaTopbarvue_type_script_lang_js_ = (VaTopbarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Topbar/VaTopbar.vue?vue&type=style&index=0&lang=scss&
var VaTopbarvue_type_style_index_0_lang_scss_ = __webpack_require__("93ca");

// CONCATENATED MODULE: ./src/Topbar/VaTopbar.vue






/* normalize component */

var VaTopbar_component = normalizeComponent(
  Topbar_VaTopbarvue_type_script_lang_js_,
  VaTopbarvue_type_template_id_4f1e7114_render,
  VaTopbarvue_type_template_id_4f1e7114_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTopbar = (VaTopbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Mobile/VaMobile.vue?vue&type=template&id=eb4a2d72&
var VaMobilevue_type_template_id_eb4a2d72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile)?_vm._t("default"):_vm._e()],2)}
var VaMobilevue_type_template_id_eb4a2d72_staticRenderFns = []


// CONCATENATED MODULE: ./src/Mobile/VaMobile.vue?vue&type=template&id=eb4a2d72&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Mobile/VaMobile.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var VaMobilevue_type_script_lang_js_ = ({
  name: 'VaMobile',
  mixins: [events],
  data: function data() {
    return {
      isMobile: false
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@mobileIsMobile', function (val) {
      _this.isMobile = val;
    });
    /**
     * In case this component is instantiated after the App
     * has initially broadcasted isMobile, let's request it.
     */

    this.dispatch('VaApp', 'Va@requestIsMobile', true);
  }
});
// CONCATENATED MODULE: ./src/Mobile/VaMobile.vue?vue&type=script&lang=js&
 /* harmony default export */ var Mobile_VaMobilevue_type_script_lang_js_ = (VaMobilevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Mobile/VaMobile.vue





/* normalize component */

var VaMobile_component = normalizeComponent(
  Mobile_VaMobilevue_type_script_lang_js_,
  VaMobilevue_type_template_id_eb4a2d72_render,
  VaMobilevue_type_template_id_eb4a2d72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaMobile = (VaMobile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Form/VaFormItem.vue?vue&type=template&id=7c2dada6&
var VaFormItemvue_type_template_id_7c2dada6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[(_vm.label || _vm.inline || _vm.horizontal)?_c('label',_vm._b({class:("va-col-sm-" + _vm.label_col + " va-control-label")},'label',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.label || ' ')+" "),(_vm.need)?_c('em',{class:"va-form-need"},[_vm._v("*")]):_vm._e()]):_vm._e(),_c('div',{class:("va-col-sm-" + _vm.col + " va-flex")},[_vm._t("default")],2)])}
var VaFormItemvue_type_template_id_7c2dada6_staticRenderFns = []


// CONCATENATED MODULE: ./src/Form/VaFormItem.vue?vue&type=template&id=7c2dada6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Form/VaFormItem.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaFormItemvue_type_script_lang_js_ = ({
  name: 'VaFormItem',
  mixins: [events],
  inheritAttrs: false,
  props: {
    label: {
      type: String
    },
    labelCol: {
      type: [Number, String],
      default: 0,
      required: false
    },
    wrapCol: {
      type: Number
    },
    formCol: {
      type: Number
    },
    need: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      inline: false,
      vertical: false,
      horizontal: true
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@formTypeChange', function (val) {
      _this.inline = val === 'inline';
      _this.vertical = val === 'vertical';
      _this.horizontal = val === 'horizontal';
    });
    this.dispatch('VaForm', 'Va@requestFormType', true);
  },
  computed: {
    label_col: function label_col() {
      var lc = parseInt(this.labelCol);
      var defaultCol = this.inline ? 0 : 2;
      defaultCol = this.vertical ? 12 : defaultCol;
      return lc || defaultCol;
    },
    col: function col() {
      if (this.inline && !this.formCol) {
        return 0;
      }

      if (this.formCol) {
        return this.formCol;
      }

      var wrapCol = this.wrapCol ? this.wrapCol : 12;
      return this.label_col === 12 ? 12 : wrapCol - this.label_col;
    },
    classObj: function classObj() {
      var classes = {};
      classes['va-form-group'] = true;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Form/VaFormItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var Form_VaFormItemvue_type_script_lang_js_ = (VaFormItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Form/VaFormItem.vue





/* normalize component */

var VaFormItem_component = normalizeComponent(
  Form_VaFormItemvue_type_script_lang_js_,
  VaFormItemvue_type_template_id_7c2dada6_render,
  VaFormItemvue_type_template_id_7c2dada6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaFormItem = (VaFormItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapse.vue?vue&type=template&id=5e8ad08b&
var VaCollapsevue_type_template_id_5e8ad08b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-collapse"},[_vm._t("default")],2)}
var VaCollapsevue_type_template_id_5e8ad08b_staticRenderFns = []


// CONCATENATED MODULE: ./src/Collapse/VaCollapse.vue?vue&type=template&id=5e8ad08b&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapse.vue?vue&type=script&lang=js&

//
//
//
//
//
//
/* harmony default export */ var VaCollapsevue_type_script_lang_js_ = ({
  name: 'VaCollapse',
  props: {
    accordion: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    change: function change(child) {
      // eslint-disable-next-line
      var items = [];

      if (this.accordion) {
        this.$children.forEach(function (item) {
          if (child !== item) {
            item.isOpen = false;
          }
        });
      }

      this.$children.forEach(function (item) {
        if (item.index) {
          items.push({
            index: item.index,
            isOpen: item.isOpen,
            header: item.header
          });
        }
      });
      this.$emit('change', items);
    }
  }
});
// CONCATENATED MODULE: ./src/Collapse/VaCollapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var Collapse_VaCollapsevue_type_script_lang_js_ = (VaCollapsevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Collapse/VaCollapse.vue?vue&type=style&index=0&lang=scss&
var VaCollapsevue_type_style_index_0_lang_scss_ = __webpack_require__("b357");

// CONCATENATED MODULE: ./src/Collapse/VaCollapse.vue






/* normalize component */

var VaCollapse_component = normalizeComponent(
  Collapse_VaCollapsevue_type_script_lang_js_,
  VaCollapsevue_type_template_id_5e8ad08b_render,
  VaCollapsevue_type_template_id_5e8ad08b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCollapse = (VaCollapse_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapsePanel.vue?vue&type=template&id=58812c41&
var VaCollapsePanelvue_type_template_id_58812c41_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-collapse__panel"},[_c('div',{class:"va-collapse__panel__header",on:{"click":function($event){return _vm.toggle()}}},[_vm._t("header",[(!_vm.isOpen)?_c('va-icon',{attrs:{"type":"angle-right"}}):_c('va-icon',{attrs:{"type":"angle-down"}}),_vm._v(" "+_vm._s(_vm.header)+" ")],{"isOpen":_vm.isOpen})],2),_c('va-collapse-transition',[(_vm.isOpen)?_c('div',{class:"va-collapse__panel__body"},[_vm._t("default")],2):_vm._e()])],1)}
var VaCollapsePanelvue_type_template_id_58812c41_staticRenderFns = []


// CONCATENATED MODULE: ./src/Collapse/VaCollapsePanel.vue?vue&type=template&id=58812c41&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapsePanel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaCollapsePanelvue_type_script_lang_js_ = ({
  name: 'VaCollapsePanel',
  props: {
    header: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    },
    index: {}
  },
  data: function data() {
    var isOpen = this.open;
    return {
      isOpen: isOpen
    };
  },
  watch: {
    open: function open(val) {
      this.isOpen = val;
    }
  },
  methods: {
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
      var item = {
        index: this.index,
        header: this.header,
        isOpen: this.isOpen
      };
      this.$parent.change(this);
      this.$emit('change', item);
    }
  }
});
// CONCATENATED MODULE: ./src/Collapse/VaCollapsePanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var Collapse_VaCollapsePanelvue_type_script_lang_js_ = (VaCollapsePanelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Collapse/VaCollapsePanel.vue





/* normalize component */

var VaCollapsePanel_component = normalizeComponent(
  Collapse_VaCollapsePanelvue_type_script_lang_js_,
  VaCollapsePanelvue_type_template_id_58812c41_render,
  VaCollapsePanelvue_type_template_id_58812c41_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCollapsePanel = (VaCollapsePanel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapseTransition.vue?vue&type=template&id=5e2fded2&
var VaCollapseTransitionvue_type_template_id_5e2fded2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"VaCollapseTransition"},on:{"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)}
var VaCollapseTransitionvue_type_template_id_5e2fded2_staticRenderFns = []


// CONCATENATED MODULE: ./src/Collapse/VaCollapseTransition.vue?vue&type=template&id=5e2fded2&

// EXTERNAL MODULE: external "velocity-animate"
var external_velocity_animate_ = __webpack_require__("044b");
var external_velocity_animate_default = /*#__PURE__*/__webpack_require__.n(external_velocity_animate_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Collapse/VaCollapseTransition.vue?vue&type=script&lang=js&
//
//
//
//
//
//


function animate(node, show, transitionName, done) {
  var ok;

  function complete() {
    if (!ok) {
      ok = true;
      done();
    }
  }

  node.style.display = show ? 'block' : 'none';
  external_velocity_animate_default()(node, transitionName, {
    duration: 200,
    complete: complete,
    easing: 'easeInOutQuad'
  });
  return {
    stop: function stop() {
      external_velocity_animate_default()(node, 'finish');
      complete();
    }
  };
}

/* harmony default export */ var VaCollapseTransitionvue_type_script_lang_js_ = ({
  name: 'VaCollapseTransition',
  methods: {
    enter: function enter(element, done) {
      return animate(element, false, 'slideDown', done);
    },
    leave: function leave(element, done) {
      return animate(element, true, 'slideUp', done);
    }
  }
});
// CONCATENATED MODULE: ./src/Collapse/VaCollapseTransition.vue?vue&type=script&lang=js&
 /* harmony default export */ var Collapse_VaCollapseTransitionvue_type_script_lang_js_ = (VaCollapseTransitionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Collapse/VaCollapseTransition.vue





/* normalize component */

var VaCollapseTransition_component = normalizeComponent(
  Collapse_VaCollapseTransitionvue_type_script_lang_js_,
  VaCollapseTransitionvue_type_template_id_5e2fded2_render,
  VaCollapseTransitionvue_type_template_id_5e2fded2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCollapseTransition = (VaCollapseTransition_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Minibar/VaMinibar.vue?vue&type=template&id=5a133ad4&
var VaMinibarvue_type_template_id_5a133ad4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj,style:(_vm.styleObj)},[_c('div',{class:"va-minibar-inner",style:(_vm.styleObjInner)},[_c('div',{class:"va-minibar-top"},[_vm._t("top",_vm._l((_vm.topItems),function(item,index){return _c('div',{key:index},[(item.method)?_c('va-minibar-item',{attrs:{"tooltip":item.tooltip,"brand":item.brand},nativeOn:{"click":function($event){return item.method($event)}}},[_c('va-icon',{attrs:{"type":item.icon,"size":item.size,"icon-style":item.iconStyle || 'solid'}})],1):_c('va-minibar-item',{attrs:{"brand":item.brand,"tooltip":item.tooltip}},[_c('va-icon',{attrs:{"type":item.icon,"size":item.size,"icon-style":item.iconStyle || 'solid'}})],1)],1)}))],2),_c('div',{class:"va-minibar-bottom"},[_vm._t("bottom",_vm._l((_vm.bottomItems),function(item,index){return _c('div',{key:index},[(item.method)?_c('va-minibar-item',{attrs:{"tooltip":item.tooltip},nativeOn:{"click":function($event){return item.method($event)}}},[_c('va-icon',{attrs:{"type":item.icon,"size":item.size,"icon-style":item.iconStyle || 'solid'}})],1):_c('va-minibar-item',{attrs:{"tooltip":item.tooltip}},[_c('va-icon',{attrs:{"type":item.icon,"size":item.size,"icon-style":item.iconStyle || 'solid'}})],1)],1)}))],2)])])}
var VaMinibarvue_type_template_id_5a133ad4_staticRenderFns = []


// CONCATENATED MODULE: ./src/Minibar/VaMinibar.vue?vue&type=template&id=5a133ad4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Minibar/VaMinibar.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaMinibarvue_type_script_lang_js_ = ({
  name: 'VaMinibar',
  mixins: [events],
  props: {
    topItems: {
      type: Array,
      required: false
    },
    bottomItems: {
      type: Array,
      required: false
    },
    theme: {
      type: String,
      default: 'blue',
      required: false
    }
  },
  data: function data() {
    var t = this.theme;
    return {
      currentDesktopMinimumWidth: 0,
      currentDesktopMargin: 0,
      currentContentWidth: 0,
      currentMinibarWidth: 0,
      currentTopbarHeight: 0,
      minibarPriority: false,
      currentSidebarWidth: 0,
      sidebarPriority: false,
      currentWindowWidth: 0,
      isReverse: false,
      isMobile: false,
      isSplit: false,
      isRTL: false,
      th: t
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.dispatch('VaApp', 'Va@minibarConnected', true);
    /**
     * This needs to be wrapped in a short setTimeout to give
     * App time to call enableReceivers().
     */

    setTimeout(function () {
      _this.dispatch('VaApp', 'Va@configMinibarThemeChange', _this.th);
    }, 10);
  },
  created: function created() {
    var _this2 = this;

    this.$on('Va@minibarPresenceCheck', function () {
      _this2.dispatch('VaApp', 'Va@minibarPresenceReply', true);
    });
    this.$on('Va@desktopMinimumWidthChange', function (val) {
      _this2.currentDesktopMinimumWidth = val;
    });
    this.$on('Va@desktopMarginChange', function (val) {
      _this2.currentDesktopMargin = val;
    });
    this.$on('Va@contentWidthChange', function (val) {
      _this2.currentContentWidth = val;
    });
    this.$on('Va@topbarHeightChange', function (val) {
      _this2.currentTopbarHeight = val;
    });
    this.$on('Va@minibarWidthChange', function (val) {
      _this2.currentMinibarWidth = val;
    });
    this.$on('Va@sidebarWidthChange', function (val) {
      _this2.currentSidebarWidth = val;
    });
    this.$on('Va@minibarPriorityChange', function (val) {
      _this2.minibarPriority = val;
    });
    this.$on('Va@sidebarPriorityChange', function (val) {
      _this2.sidebarPriority = val;
    });
    this.$on('Va@windowWidthChange', function (val) {
      _this2.currentWindowWidth = val;
    });
    this.$on('Va@minibarIsMobile', function (val) {
      _this2.isMobile = val;
    });
    this.$on('Va@reverseChange', function (val) {
      _this2.isReverse = val;
    });
    this.$on('Va@minibarThemeChange', function (val) {
      _this2.th = val;
    });
    this.$on('Va@splitChange', function (val) {
      _this2.isSplit = val;
    });
    this.$on('Va@rtlChange', function (val) {
      _this2.isRTL = val;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('VaApp', 'Va@minibarDisconnect', true);
  },
  watch: {
    theme: function theme(val) {
      this.th = val;
      this.dispatch('VaApp', 'Va@configMinibarThemeChange', this.th);
    }
  },
  computed: {
    classObj: function classObj() {
      var th = this.th;
      var classes = {};
      classes['va-minibar'] = true;
      classes['va-minibar--theme-' + th] = true;
      return classes;
    },
    styleObjInner: function styleObjInner() {
      var style = {}; // style['background'] = 'linear-gradient(to left, rgba(0, 0, 0, 0.1) 0px, rgba(0, 0, 0, 0.15) 1px, rgba(0, 0, 0, 0.1) 1px, rgba(0, 0, 0, 0) 40px)'

      return style;
    },
    styleObj: function styleObj() {
      var dmw = parseInt(this.currentDesktopMinimumWidth);
      var dm = parseInt(this.currentDesktopMargin);
      var mw = parseInt(this.currentMinibarWidth);
      var th = parseInt(this.currentTopbarHeight);
      var cw = parseInt(this.currentContentWidth);
      var sw = parseInt(this.currentSidebarWidth);
      var sp = this.sidebarPriority;
      var mp = this.minibarPriority;
      var reverse = this.isReverse;
      var mobile = this.isMobile;
      var split = this.isSplit;
      var rtl = this.isRTL;
      var style = {};
      style['width'] = mw + 'px';
      style['min-width'] = mw + 'px';

      if (mp) {
        style['top'] = '0px';
      } else {
        style['top'] = th + 'px';
      }

      style['bottom'] = '0px';
      /**
       * Adjust the margins if content width is smaller than
       * desktop minimum width.
       */

      if (!mobile) {
        if (cw < dmw) {
          var x = dmw - cw;
          dm = dm - x / 2;
        }
      } else {
        dm = 0;
        dmw = 0;
      }

      if (split) {
        if (reverse) {
          style['right'] = dm + 'px';
        } else {
          style['left'] = dm + 'px';
        }
      } else {
        if (reverse) {
          if (rtl) {
            style['right'] = dm + 'px';
          } else {
            style['left'] = dm + sw + 'px';
          }
        } else {
          if (rtl) {
            style['right'] = dm + sw + 'px';
          } else {
            style['left'] = dm + 'px';
          }
        }
      }

      if (!mp && sp && !reverse && !split && !rtl) {
        style['top'] = '0px';
      }

      if (rtl && !split && !reverse && mp) {
        style['top'] = '0px';
      }

      if (rtl && !split && reverse && !mp && sp) {
        style['top'] = '0px';
      }
      /**
       * Less than 20 and we don't want overflow.
       * Greater than 20 and we do, because we don't want
       * to hide tooltips.
       */


      if (mw < 20) {
        style['overflow'] = 'hidden';
      } else {
        style['overflow'] = 'visible';
      }

      return style;
    }
  }
});
// CONCATENATED MODULE: ./src/Minibar/VaMinibar.vue?vue&type=script&lang=js&
 /* harmony default export */ var Minibar_VaMinibarvue_type_script_lang_js_ = (VaMinibarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Minibar/VaMinibar.vue?vue&type=style&index=0&lang=scss&
var VaMinibarvue_type_style_index_0_lang_scss_ = __webpack_require__("6c89");

// CONCATENATED MODULE: ./src/Minibar/VaMinibar.vue






/* normalize component */

var VaMinibar_component = normalizeComponent(
  Minibar_VaMinibarvue_type_script_lang_js_,
  VaMinibarvue_type_template_id_5a133ad4_render,
  VaMinibarvue_type_template_id_5a133ad4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaMinibar = (VaMinibar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Loading/VaLoading.vue?vue&type=template&id=070162ae&
var VaLoadingvue_type_template_id_070162ae_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('span',{ref:"load",class:_vm.classObj},[_c('i',{class:_vm.iclassObj}),_vm._t("default"),_c('svg',{class:"va-spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{class:"va-path",style:({ stroke: _vm.color }),attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])],2)])}
var VaLoadingvue_type_template_id_070162ae_staticRenderFns = []


// CONCATENATED MODULE: ./src/Loading/VaLoading.vue?vue&type=template&id=070162ae&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Loading/VaLoading.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaLoadingvue_type_script_lang_js_ = ({
  name: 'VaLoading',
  props: {
    type: {
      type: String
    },
    size: {
      type: String,
      default: 'md',
      validator: function validator(v) {
        return ['xl', 'lg', 'md', 'sm', 'xs'].includes(v);
      }
    },
    center: {
      type: Boolean
    },
    color: {
      type: String,
      default: '#6C798F',
      required: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.center) {
      document.querySelector('body').appendChild(this.$refs.load);
      this.$once('hook:beforeDestroy', function () {
        document.querySelector('body').removeChild(_this.$refs.load);
      });
    }
  },
  computed: {
    classObj: function classObj() {
      var center = this.center;
      var classes = {};
      classes['va-page-loading-con'] = true;
      classes['va-loading-center'] = center;
      return classes;
    },
    iclassObj: function iclassObj() {
      var type = this.type,
          size = this.size;
      var classes = {};
      classes['va-page-loading'] = true;
      type ? classes['va-loading-' + type] = true : '';
      size ? classes['va-loading-' + size] = true : '';
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Loading/VaLoading.vue?vue&type=script&lang=js&
 /* harmony default export */ var Loading_VaLoadingvue_type_script_lang_js_ = (VaLoadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Loading/VaLoading.vue?vue&type=style&index=0&lang=scss&
var VaLoadingvue_type_style_index_0_lang_scss_ = __webpack_require__("6fe2");

// CONCATENATED MODULE: ./src/Loading/VaLoading.vue






/* normalize component */

var VaLoading_component = normalizeComponent(
  Loading_VaLoadingvue_type_script_lang_js_,
  VaLoadingvue_type_template_id_070162ae_render,
  VaLoadingvue_type_template_id_070162ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaLoading = (VaLoading_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tooltip/VaTooltip.vue?vue&type=template&id=2d3be3da&
var VaTooltipvue_type_template_id_2d3be3da_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tooltip",class:"va-tooltip_wrapper"},[_c('span',_vm._g({ref:"trigger",class:"va-tooltip_trigger"},_vm.listeners),[_vm._t("default")],2),_c('transition',{attrs:{"name":_vm.effect}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],ref:"popover",class:_vm.classObj},[(_vm.arrow)?_c('div',{class:"va-tooltip-arrow"}):_vm._e(),_c('div',{class:"va-tooltip-inner"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])],1)}
var VaTooltipvue_type_template_id_2d3be3da_staticRenderFns = []


// CONCATENATED MODULE: ./src/Tooltip/VaTooltip.vue?vue&type=template&id=2d3be3da&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// CONCATENATED MODULE: ./src/Mixin/popoverMixin.js
var PopoverMixin = {
  props: {
    trigger: {
      type: String,
      default: 'hover'
    },
    effect: {
      type: String,
      default: 'fadeDown'
    },
    title: {
      type: String
    },
    content: {
      type: String
    },
    header: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'top'
    },
    noresize: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function
    }
  },
  data: function data() {
    var show = this.show;
    return {
      isShow: show,
      listeners: this.getListeners(),
      position: {
        top: 0,
        left: 0
      }
    };
  },
  watch: {
    isShow: function isShow(val) {
      var _this = this;

      if (val && !this.noresize) {
        this.$nextTick(function () {
          _this.resize();
        });
      }
    }
  },
  methods: {
    getListeners: function getListeners() {
      switch (this.trigger) {
        case 'hover':
          return {
            mouseenter: this.showHandler,
            mouseleave: this.hide
          };

        case 'focus':
          return {};

        case 'mouse':
          return {
            mousedown: this.showHandler,
            mouseup: this.hide
          };

        default:
          return {
            click: this.click
          };
      }
    },
    click: function click() {
      this.toggle();

      if (this.onClick) {
        this.onClick();
      }
    },
    showHandler: function showHandler() {
      var _this2 = this;

      setTimeout(function () {
        _this2.isShow = true;
      }, 200);
    },
    hide: function hide() {
      var _this3 = this;

      setTimeout(function () {
        _this3.isShow = false;
      }, 200);
    },
    toggle: function toggle() {
      this.isShow = !this.isShow;
    },
    resize: function resize() {
      var popover = this.$refs.popover;
      if (!popover) return;
      var triger = this.$refs.trigger;
      if (!triger) return;
      popover.style.display = 'block';

      switch (this.placement) {
        case 'top':
          this.position.left = triger.offsetLeft - popover.offsetWidth / 2 + triger.offsetWidth / 2;
          this.position.top = triger.offsetTop - popover.offsetHeight;
          break;

        case 'top left':
          this.position.left = triger.offsetLeft;
          this.position.top = triger.offsetTop - popover.offsetHeight;
          break;

        case 'top right':
          this.position.left = triger.offsetLeft - Math.abs(triger.offsetWidth - popover.offsetWidth);
          this.position.top = triger.offsetTop - popover.offsetHeight;
          break;

        case 'left':
          this.position.left = triger.offsetLeft - popover.offsetWidth;
          this.position.top = triger.offsetTop + triger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;

        case 'left top':
          this.position.left = triger.offsetLeft - popover.offsetWidth;
          this.position.top = triger.offsetTop;
          break;

        case 'left bottom':
          this.position.left = triger.offsetLeft - popover.offsetWidth;
          this.position.top = triger.offsetTop - Math.abs(triger.offsetHeight - popover.offsetHeight);
          break;

        case 'right':
          this.position.left = triger.offsetLeft + triger.offsetWidth;
          this.position.top = triger.offsetTop + triger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;

        case 'right top':
          this.position.left = triger.offsetLeft + triger.offsetWidth;
          this.position.top = triger.offsetTop;
          break;

        case 'right bottom':
          this.position.left = triger.offsetLeft + triger.offsetWidth;
          this.position.top = triger.offsetTop - Math.abs(triger.offsetHeight - popover.offsetHeight);
          break;

        case 'bottom':
          this.position.left = triger.offsetLeft - popover.offsetWidth / 2 + triger.offsetWidth / 2;
          this.position.top = triger.offsetTop + triger.offsetHeight;
          break;

        case 'bottom left':
          this.position.left = triger.offsetLeft;
          this.position.top = triger.offsetTop + triger.offsetHeight;
          break;

        case 'bottom right':
          this.position.left = triger.offsetLeft - Math.abs(triger.offsetWidth - popover.offsetWidth);
          this.position.top = triger.offsetTop + triger.offsetHeight;
          break;

        default:
          console.error('Wrong placement group');
      }

      popover.style.top = this.position.top + 'px';
      popover.style.left = this.position.left + 'px';
    }
  },
  mounted: function mounted() {
    if (!this.$refs.popover) return;
    this.resize();
    this.$refs.popover.style.display = 'none';
    this.isShow = false;

    if (this.trigger === 'focus') {
      var input = this.$refs.trigger.querySelector('input');

      if (input) {
        input.removeEventListener('focus', this.showHandler);
        input.removeEventListener('blur', this.hide);
        input.addEventListener('focus', this.showHandler);
        input.addEventListener('blur', this.hide);
      }
    }
  }
};
/* harmony default export */ var popoverMixin = (PopoverMixin);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Tooltip/VaTooltip.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaTooltipvue_type_script_lang_js_ = ({
  name: 'VaTooltip',
  props: {
    arrow: {
      type: Boolean,
      default: false
    },
    effect: {
      type: String,
      default: 'tooltip-fade-top' // tooltip-fade-top, -left, -right, -bottom

    }
  },
  mixins: [popoverMixin],
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-tooltip'] = true;
      classes['va-tooltip-' + this.placement.split(' ').join('-')] = true;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Tooltip/VaTooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var Tooltip_VaTooltipvue_type_script_lang_js_ = (VaTooltipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Tooltip/VaTooltip.vue?vue&type=style&index=0&lang=scss&
var VaTooltipvue_type_style_index_0_lang_scss_ = __webpack_require__("c531");

// CONCATENATED MODULE: ./src/Tooltip/VaTooltip.vue






/* normalize component */

var VaTooltip_component = normalizeComponent(
  Tooltip_VaTooltipvue_type_script_lang_js_,
  VaTooltipvue_type_template_id_2d3be3da_render,
  VaTooltipvue_type_template_id_2d3be3da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTooltip = (VaTooltip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Desktop/VaDesktop.vue?vue&type=template&id=4d9f6f0c&
var VaDesktopvue_type_template_id_4d9f6f0c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_vm._t("default"):_vm._e()],2)}
var VaDesktopvue_type_template_id_4d9f6f0c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Desktop/VaDesktop.vue?vue&type=template&id=4d9f6f0c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Desktop/VaDesktop.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var VaDesktopvue_type_script_lang_js_ = ({
  name: 'VaDesktop',
  mixins: [events],
  data: function data() {
    return {
      isMobile: false
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@desktopIsMobile', function (val) {
      _this.isMobile = val;
    });
    /**
     * In case this component is instantiated after the App
     * has initially broadcasted isMobile, let's request it.
     */

    this.dispatch('VaApp', 'Va@requestIsMobile', true);
  }
});
// CONCATENATED MODULE: ./src/Desktop/VaDesktop.vue?vue&type=script&lang=js&
 /* harmony default export */ var Desktop_VaDesktopvue_type_script_lang_js_ = (VaDesktopvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Desktop/VaDesktop.vue





/* normalize component */

var VaDesktop_component = normalizeComponent(
  Desktop_VaDesktopvue_type_script_lang_js_,
  VaDesktopvue_type_template_id_4d9f6f0c_render,
  VaDesktopvue_type_template_id_4d9f6f0c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaDesktop = (VaDesktop_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadioBtn.vue?vue&type=template&id=3df50177&
var VaRadioBtnvue_type_template_id_3df50177_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-button',{class:_vm.classObj,attrs:{"disabled":_vm.disabled,"type":_vm.currentChecked ? 'primary' : 'default'},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._t("default")],2)}
var VaRadioBtnvue_type_template_id_3df50177_staticRenderFns = []


// CONCATENATED MODULE: ./src/Radio/VaRadioBtn.vue?vue&type=template&id=3df50177&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadioBtn.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var VaRadioBtnvue_type_script_lang_js_ = ({
  name: 'VaRadioBtn',
  mixins: [validationMixin, events],
  props: {
    value: {
      type: String
    },
    label: {
      type: [String, Number]
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(val) {
      this.currentChecked = val;
    },
    checked: function checked(val) {
      this.currentChecked = val;
    },
    currentChecked: function currentChecked(val) {
      this.$emit('input', val);
    }
  },
  data: function data() {
    var checked = this.checked;

    if (checked !== undefined) {
      this.$emit('input', checked);
    } else {
      checked = !!this.value;
    }

    return {
      currentChecked: checked
    };
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-radio-btn'] = true;
      return classes;
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@radiogroupChange', function (val) {
      _this.currentChecked = val === _this.label;
    });
  },
  methods: {
    handleClick: function handleClick() {
      if (this.currentChecked) return;
      this.currentChecked = true;
      this.dispatch('VaRadioGroup', 'Va@radioChange', this.label);
      this.$emit('change', this.currentChecked);
    }
  }
});
// CONCATENATED MODULE: ./src/Radio/VaRadioBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var Radio_VaRadioBtnvue_type_script_lang_js_ = (VaRadioBtnvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Radio/VaRadioBtn.vue





/* normalize component */

var VaRadioBtn_component = normalizeComponent(
  Radio_VaRadioBtnvue_type_script_lang_js_,
  VaRadioBtnvue_type_template_id_3df50177_render,
  VaRadioBtnvue_type_template_id_3df50177_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaRadioBtn = (VaRadioBtn_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebar.vue?vue&type=template&id=6076e0e9&
var VaSidebarvue_type_template_id_6076e0e9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj,style:(_vm.styleObj)},[_c('div',{class:"va-sidebar-scrollarea"},[_vm._t("default")],2)])}
var VaSidebarvue_type_template_id_6076e0e9_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebar.vue?vue&type=template&id=6076e0e9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebar.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//

/* harmony default export */ var VaSidebarvue_type_script_lang_js_ = ({
  name: 'VaSidebar',
  mixins: [events],
  props: {
    compact: {
      type: Boolean,
      default: false,
      required: false
    },
    textLinks: {
      type: Boolean,
      default: false,
      required: false
    },
    theme: {
      type: String,
      default: 'default',
      required: false
    },
    showToggle: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    var tli = this.textLinks;
    var s = this.showToggle;
    var c = this.compact;
    var t = this.theme;
    return {
      currentDesktopMinimumWidth: 0,
      currentDesktopMargin: 0,
      currentSidebarWidth: 0,
      currentTopbarHeight: 0,
      minibarPriority: false,
      currentContentWidth: 0,
      sidebarPriority: false,
      currentMinibarWidth: 0,
      currentWindowWidth: 0,
      isReverse: false,
      isMobile: false,
      isSplit: false,
      isRTL: false,
      comp: c,
      tl: tli,
      th: t,
      st: s
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@sidebarPresenceCheck', function () {
      _this.dispatch('VaApp', 'Va@sidebarPresenceReply', true);
    });
    this.$on('Va@desktopMinimumWidthChange', function (val) {
      _this.currentDesktopMinimumWidth = val;
    });
    this.$on('Va@desktopMarginChange', function (val) {
      _this.currentDesktopMargin = val;
    });
    this.$on('Va@minibarWidthChange', function (val) {
      _this.currentMinibarWidth = val;
    });
    this.$on('Va@topbarHeightChange', function (val) {
      _this.currentTopbarHeight = val;
    });
    this.$on('Va@contentWidthChange', function (val) {
      _this.currentContentWidth = val;
    });
    this.$on('Va@sidebarWidthChange', function (val) {
      _this.currentSidebarWidth = val;
    });
    this.$on('Va@minibarPriorityChange', function (val) {
      _this.minibarPriority = val;
    });
    this.$on('Va@sidebarPriorityChange', function (val) {
      _this.sidebarPriority = val;
    });
    this.$on('Va@windowWidthChange', function (val) {
      _this.currentWindowWidth = val;
    });
    this.$on('Va@sidebarIsMobile', function (val) {
      _this.isMobile = val;
    });
    this.$on('Va@reverseChange', function (val) {
      _this.isReverse = val;
    });
    this.$on('Va@sidebarThemeChange', function (val) {
      _this.th = val;
    });
    this.$on('Va@showToggleChange', function (val) {
      _this.st = val;
    });
    this.$on('Va@splitChange', function (val) {
      _this.isSplit = val;
    });
    this.$on('Va@textLinksChange', function (val) {
      _this.tl = val;
    });
    this.$on('Va@compactChange', function (val) {
      _this.comp = val;
    });
    this.$on('Va@rtlChange', function (val) {
      _this.isRTL = val;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.dispatch('VaApp', 'Va@sidebarConnected', true);
    /**
     * This needs to be wrapped in a short setTimeout to give
     * App time to call enableReceivers().
     */

    setTimeout(function () {
      _this2.dispatch('VaApp', 'Va@configSidebarThemeChange', _this2.th);

      _this2.dispatch('VaApp', 'Va@configCompactChange', _this2.comp);

      _this2.dispatch('VaApp', 'Va@configTextLinksChange', _this2.tl);

      _this2.dispatch('VaApp', 'Va@configShowToggleChange', _this2.st);
    }, 10);
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('VaApp', 'Va@sidebarDisconnect', true);
  },
  watch: {
    theme: function theme(val) {
      this.th = val;
      this.dispatch('VaApp', 'Va@configSidebarThemeChange', this.th);
    }
  },
  computed: {
    classObj: function classObj() {
      var th = this.th,
          isMobile = this.isMobile,
          comp = this.comp,
          tl = this.tl;
      var classes = {};
      classes['va-sidebar'] = true;
      classes['va-sidebar--theme-' + th] = true;
      classes['va-sidebar-mobile'] = isMobile;
      classes['va-sidebar-compact'] = comp;
      classes['va-sidebar-text-links'] = tl;
      return classes;
    },
    styleObj: function styleObj() {
      var dmw = parseInt(this.currentDesktopMinimumWidth);
      var dm = parseInt(this.currentDesktopMargin);
      var sw = parseInt(this.currentSidebarWidth);
      var th = parseInt(this.currentTopbarHeight);
      var cw = parseInt(this.currentContentWidth);
      var mw = parseInt(this.currentMinibarWidth);
      var sp = this.sidebarPriority;
      var mp = this.minibarPriority;
      var reverse = this.isReverse;
      var mobile = this.isMobile;
      var split = this.isSplit;
      var rtl = this.isRTL;
      var style = {};
      style['width'] = sw + 'px';
      style['min-width'] = sw + 'px';

      if (sp) {
        style['top'] = '0px';
      } else {
        style['top'] = th + 'px';
      }
      /**
       * Adjust the margins if content width is smaller than
       * desktop minimum width.
       */


      if (!mobile) {
        if (cw < dmw) {
          var x = dmw - cw;
          dm = dm - x / 2;
        }
      } else {
        dm = 0;
        dmw = 0;
      }

      if (split) {
        if (reverse) {
          style['left'] = dm + 'px';
        } else {
          style['right'] = dm + 'px';
        }
      } else {
        if (reverse) {
          if (rtl) {
            style['right'] = dm + mw + 'px';
          } else {
            style['left'] = dm + 'px';
          }
        } else {
          if (rtl) {
            style['right'] = dm + 'px';
          } else {
            style['left'] = dm + mw + 'px';
          }
        }
      }

      if (!sp && mp && reverse && !split && !rtl) {
        style['top'] = '0px';
      }

      if (rtl && !split && !reverse && !sp && mp) {
        style['top'] = '0px';
      }

      style['bottom'] = '0px';
      return style;
    }
  } // methods: {
  //   initResize (e) {
  //     /**
  //      * Prevent text selection while dragging.
  //      * https://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
  //      */
  //     if (e.stopPropagation) {
  //       e.stopPropagation()
  //     }
  //     if (e.preventDefault) {
  //       e.preventDefault()
  //     }
  //     e.cancelBubble = true
  //     e.returnValue = false
  //     window.addEventListener('mousemove', this.doResize, false)
  //     window.addEventListener('mouseup', this.stopResize, false)
  //   },
  //   doResize (e) {
  //     let el = this.$refs.sidebar
  //     this.dispatch('VaApp', 'Va@sidebarWidthChange', e.clientX - el.offsetLeft)
  //   },
  //   stopResize () {
  //     window.removeEventListener('mouseup', this.stopResize, false)
  //     window.removeEventListener('mousemove', this.doResize, false)
  //   }
  // }

});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarvue_type_script_lang_js_ = (VaSidebarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Sidebar/VaSidebar.vue?vue&type=style&index=0&lang=scss&
var VaSidebarvue_type_style_index_0_lang_scss_ = __webpack_require__("85ad");

// CONCATENATED MODULE: ./src/Sidebar/VaSidebar.vue






/* normalize component */

var VaSidebar_component = normalizeComponent(
  Sidebar_VaSidebarvue_type_script_lang_js_,
  VaSidebarvue_type_template_id_6076e0e9_render,
  VaSidebarvue_type_template_id_6076e0e9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebar = (VaSidebar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App/VaAppConfig.vue?vue&type=template&id=88a299d2&
var VaAppConfigvue_type_template_id_88a299d2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('va-button',{ref:"cfgbtn",style:(_vm.styleObj),attrs:{"type":"default","size":"md"},nativeOn:{"click":function($event){return _vm.showConfigModal($event)}}},[_vm._v(" AppConfig "),_c('va-icon',{attrs:{"type":"sliders-h","icon-style":"solid","margin":"0 0 0 10px"}})],1),_c('va-modal',{ref:"configModal",attrs:{"title":"AppConfig","width":"800px","backdrop":true}},[_c('div',{staticClass:"themeModalBody",attrs:{"slot":"body"},slot:"body"},[_c('va-mobile',[_c('p',[_vm._v(" The AppConfig is meant to be used on a desktop. If you're on a desktop, try increasing your resolution. ")])]),_c('va-desktop',[_c('va-tabs',[_c('va-tab',{attrs:{"name":"Colors and themes"}},[_c('p',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("There are hundreds of combinations of layouts that you can build when using the atlas App component.")]),_c('h3',[_vm._v("Built-in themes")]),_c('hr'),_c('va-row',{attrs:{"gutter":10}},[_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Minibar"),_c('br'),_c('va-select',{attrs:{"no-uncheck":""},model:{value:(_vm.minibarTheme),callback:function ($$v) {_vm.minibarTheme=$$v},expression:"minibarTheme"}},[_c('va-option',{attrs:{"value":"default","label":"Default"}}),_c('va-option',{attrs:{"value":"white","label":"White"}}),_c('va-option',{attrs:{"value":"blue","label":"Blue"}}),_c('va-option',{attrs:{"value":"dark","label":"Dark"}}),_c('va-option',{attrs:{"value":"darker","label":"Darker"}}),_c('va-option',{attrs:{"value":"purple","label":"Purple"}}),_c('va-option',{attrs:{"value":"black","label":"Black"}})],1)],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Sidebar"),_c('br'),_c('va-select',{attrs:{"no-uncheck":""},model:{value:(_vm.sidebarTheme),callback:function ($$v) {_vm.sidebarTheme=$$v},expression:"sidebarTheme"}},[_c('va-option',{attrs:{"value":"default","label":"Default"}}),_c('va-option',{attrs:{"value":"white","label":"White"}}),_c('va-option',{attrs:{"value":"blue","label":"Blue"}}),_c('va-option',{attrs:{"value":"dark","label":"Dark"}}),_c('va-option',{attrs:{"value":"darker","label":"Darker"}}),_c('va-option',{attrs:{"value":"purple","label":"Purple"}}),_c('va-option',{attrs:{"value":"black","label":"Black"}})],1)],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Topbar"),_c('br'),_c('va-select',{attrs:{"no-uncheck":""},model:{value:(_vm.topbarTheme),callback:function ($$v) {_vm.topbarTheme=$$v},expression:"topbarTheme"}},[_c('va-option',{attrs:{"value":"default","label":"Default"}}),_c('va-option',{attrs:{"value":"white","label":"White"}}),_c('va-option',{attrs:{"value":"blue","label":"Blue"}}),_c('va-option',{attrs:{"value":"dark","label":"Dark"}}),_c('va-option',{attrs:{"value":"darker","label":"Darker"}}),_c('va-option',{attrs:{"value":"purple","label":"Purple"}}),_c('va-option',{attrs:{"value":"black","label":"Black"}})],1)],1)])],1),_c('va-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("Background colors")]),_c('hr'),_c('va-column',{attrs:{"xs":6}},[_c('va-form',{attrs:{"type":"vertical"}},[_c('va-form-item',{attrs:{"label":"Document"}},[_c('va-input',{model:{value:(_vm.bgColor),callback:function ($$v) {_vm.bgColor=$$v},expression:"bgColor"}}),_vm._v(" "),_c('va-color-picker',{attrs:{"color":_vm.bgColor},on:{"change":_vm.onBgColorChange}})],1)],1)],1),_c('va-column',{attrs:{"xs":6}},[_c('va-form',{attrs:{"type":"vertical"}},[_c('va-form-item',{attrs:{"label":"Page (content)"}},[_c('va-input',{model:{value:(_vm.pageBgColor),callback:function ($$v) {_vm.pageBgColor=$$v},expression:"pageBgColor"}}),_vm._v(" "),_c('va-color-picker',{attrs:{"color":_vm.pageBgColor},on:{"change":_vm.onPageBgColorChange}})],1)],1)],1)],1)],1),_c('va-tab',{attrs:{"name":"Dimensions and positioning"}},[_c('h3',[_vm._v("Page")]),_c('hr'),_c('va-row',{attrs:{"gutter":10}},[_c('va-column',{attrs:{"xs":12}},[_c('p',[_vm._v(" Size"),_c('br'),_c('va-select',{attrs:{"no-uncheck":""},model:{value:(_vm.pageSize),callback:function ($$v) {_vm.pageSize=$$v},expression:"pageSize"}},[_c('va-option',{attrs:{"value":"sm","label":"Small"}}),_c('va-option',{attrs:{"value":"md","label":"Medium"}}),_c('va-option',{attrs:{"value":"lg","label":"Large"}})],1)],1)])],1),_c('va-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("Misc. App props")]),_c('hr'),_c('va-column',{attrs:{"xs":4}},[_c('p',[_c('va-checkbox',{model:{value:(_vm.sidebarPriority),callback:function ($$v) {_vm.sidebarPriority=$$v},expression:"sidebarPriority"}},[_vm._v("sidebarPriority")])],1),_c('p',[_c('va-checkbox',{model:{value:(_vm.minibarPriority),callback:function ($$v) {_vm.minibarPriority=$$v},expression:"minibarPriority"}},[_vm._v("minibarPriority")])],1),_c('p',[_c('va-tooltip',{attrs:{"trigger":"hover","content":"Disabled unless !topbarPriority, !minibarPriority and desktopMargin !== 0","placement":"right","effect":"tooltip-fade-right"}},[_c('va-checkbox',{attrs:{"disabled":_vm.shouldTopbarPriorityBeDisabled},model:{value:(_vm.topbarPriority),callback:function ($$v) {_vm.topbarPriority=$$v},expression:"topbarPriority"}},[_vm._v("topbarPriority")])],1)],1),_c('p',[_c('va-tooltip',{attrs:{"trigger":"hover","content":"Disabled unless topbarPriority and desktopMargin !== 0","placement":"right","effect":"tooltip-fade-right"}},[_c('va-checkbox',{attrs:{"disabled":_vm.shouldTopbarPaddedBeDisabled},model:{value:(_vm.topbarPadded),callback:function ($$v) {_vm.topbarPadded=$$v},expression:"topbarPadded"}},[_vm._v("topbarPadded")])],1)],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_c('va-checkbox',{model:{value:(_vm.rtl),callback:function ($$v) {_vm.rtl=$$v},expression:"rtl"}},[_vm._v("rtl")])],1),_c('p',[_c('va-checkbox',{model:{value:(_vm.reverse),callback:function ($$v) {_vm.reverse=$$v},expression:"reverse"}},[_vm._v("reverse")])],1),_c('p',[_c('va-checkbox',{model:{value:(_vm.split),callback:function ($$v) {_vm.split=$$v},expression:"split"}},[_vm._v("split")])],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_c('va-checkbox',{model:{value:(_vm.showToggle),callback:function ($$v) {_vm.showToggle=$$v},expression:"showToggle"}},[_vm._v("showToggle")])],1),_c('p',[_c('va-checkbox',{model:{value:(_vm.compact),callback:function ($$v) {_vm.compact=$$v},expression:"compact"}},[_vm._v("compact")])],1),_c('p',[_c('va-checkbox',{model:{value:(_vm.textLinks),callback:function ($$v) {_vm.textLinks=$$v},expression:"textLinks"}},[_vm._v("textLinks")])],1)])],1),_c('va-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("Content margin and minimum width")]),_c('hr'),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Desktop margin: "+_vm._s(_vm.desktopMargin)),_c('br'),_c('va-range',{ref:"desktopMarginRange",attrs:{"min":0,"max":1000,"step":1},model:{value:(_vm.desktopMargin),callback:function ($$v) {_vm.desktopMargin=$$v},expression:"desktopMargin"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Desktop minimum width: "+_vm._s(_vm.desktopMinimumWidth)),_c('br'),_c('va-range',{ref:"desktopMinimumWidthRange",attrs:{"min":0,"max":1024,"step":1},model:{value:(_vm.desktopMinimumWidth),callback:function ($$v) {_vm.desktopMinimumWidth=$$v},expression:"desktopMinimumWidth"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p')])],1),_c('va-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("Desktop bar dimensions")]),_c('hr'),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Sidebar width: "+_vm._s(_vm.desktopSidebarWidth)),_c('br'),_c('va-range',{ref:"desktopSidebarWidthRange",attrs:{"min":0,"max":400,"step":5},model:{value:(_vm.desktopSidebarWidth),callback:function ($$v) {_vm.desktopSidebarWidth=$$v},expression:"desktopSidebarWidth"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Minibar width: "+_vm._s(_vm.desktopMinibarWidth)),_c('br'),_c('va-range',{ref:"desktopMinibarWidthRange",attrs:{"min":0,"max":150,"step":5},model:{value:(_vm.desktopMinibarWidth),callback:function ($$v) {_vm.desktopMinibarWidth=$$v},expression:"desktopMinibarWidth"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Topbar height: "+_vm._s(_vm.desktopTopbarHeight)),_c('br'),_c('va-range',{ref:"desktopTopbarHeightRange",attrs:{"min":0,"max":150,"step":5},model:{value:(_vm.desktopTopbarHeight),callback:function ($$v) {_vm.desktopTopbarHeight=$$v},expression:"desktopTopbarHeight"}})],1)])],1),_c('va-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("Mobile bar dimensions")]),_c('hr'),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Sidebar width: "+_vm._s(_vm.mobileSidebarWidth)),_c('br'),_c('va-range',{ref:"mobileSidebarWidthRange",attrs:{"min":0,"max":400,"step":5},model:{value:(_vm.mobileSidebarWidth),callback:function ($$v) {_vm.mobileSidebarWidth=$$v},expression:"mobileSidebarWidth"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Minibar width: "+_vm._s(_vm.mobileMinibarWidth)),_c('br'),_c('va-range',{ref:"mobileMinibarWidthRange",attrs:{"min":0,"max":150,"step":5},model:{value:(_vm.mobileMinibarWidth),callback:function ($$v) {_vm.mobileMinibarWidth=$$v},expression:"mobileMinibarWidth"}})],1)]),_c('va-column',{attrs:{"xs":4}},[_c('p',[_vm._v(" Topbar height: "+_vm._s(_vm.mobileTopbarHeight)),_c('br'),_c('va-range',{ref:"mobileTopbarHeightRange",attrs:{"min":0,"max":150,"step":5},model:{value:(_vm.mobileTopbarHeight),callback:function ($$v) {_vm.mobileTopbarHeight=$$v},expression:"mobileTopbarHeight"}})],1)])],1)],1),_c('va-tab',{attrs:{"name":"Source"}},[_c('code',[_c('pre',{staticClass:"back"},[_c('span',{staticClass:"blue"},[_vm._v("<template>")]),_vm._v("\n  "),_c('span',{staticClass:"comment"},[_vm._v("<!-- https://vue-atlas.com/documentation/app -->")]),_vm._v("\n  "),_c('span',{staticClass:"blue"},[_vm._v("<va-app")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("bg-color")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.bgColor)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("page-bg-color")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.pageBgColor)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("desktop-margin")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.desktopMargin)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("desktop-minimum-width")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.desktopMinimumWidth)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("desktop-sidebar-width")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.desktopSidebarWidth)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("desktop-minibar-width")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.desktopMinibarWidth)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("desktop-topbar-height")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.desktopTopbarHeight)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("mobile-sidebar-width")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.mobileSidebarWidth)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("mobile-minibar-width")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.mobileMinibarWidth)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v("mobile-topbar-height")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.mobileTopbarHeight)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":rtl")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.rtl)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":reverse")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.reverse)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":split")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.split)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":sidebar-priority")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.sidebarPriority)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":minibar-priority")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.minibarPriority)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":topbar-priority")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.topbarPriority)+"\"")]),_vm._v("\n    "),_c('span',{staticClass:"yellow"},[_vm._v(":topbar-padded")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.topbarPadded)+"\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v("\n\n    "),_c('span',{staticClass:"comment"},[_vm._v("<!-- https://vue-atlas.com/documentation/topbar -->")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("<va-topbar")]),_vm._v(" "),_c('span',{staticClass:"yellow"},[_vm._v("theme")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.topbarTheme)+"\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<div")]),_vm._v(" "),_c('span',{staticClass:"yellow"},[_vm._v("slot")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"left\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v(" L "),_c('span',{staticClass:"blue"},[_vm._v("</div>")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<div")]),_vm._v(" "),_c('span',{staticClass:"yellow"},[_vm._v("slot")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"center\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v(" C "),_c('span',{staticClass:"blue"},[_vm._v("</div>")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<div")]),_vm._v(" "),_c('span',{staticClass:"yellow"},[_vm._v("slot")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"right\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v(" R "),_c('span',{staticClass:"blue"},[_vm._v("</div>")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("</va-topbar>")]),_vm._v("\n\n    "),_c('span',{staticClass:"comment"},[_vm._v("<!-- https://vue-atlas.com/documentation/minibar -->")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("<va-minibar")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v(":top-items")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"[{icon:'home'},{icon:'search'},{icon:'user'}]\"")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v(":bottom-items")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"[{icon:'question'}]\"")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v("theme")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.minibarTheme)+"\"")]),_vm._v(" "),_c('span',{staticClass:"blue"},[_vm._v("/>")]),_vm._v("\n\n    "),_c('span',{staticClass:"comment"},[_vm._v("<!-- https://vue-atlas.com/documentation/sidebar -->")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("<va-sidebar")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v("theme")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.sidebarTheme)+"\"")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v(":compact")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.compact)+"\"")]),_vm._v("\n      "),_c('span',{staticClass:"yellow"},[_vm._v(":text-links")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.textLinks)+"\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<va-sidebar-group")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v(":items")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"[{name:'Item1'}]\"")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v("title")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"Category 1\"")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v(":show-toggle")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.showToggle)+"\"")]),_vm._v(" "),_c('span',{staticClass:"blue"},[_vm._v("/>")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<va-sidebar-group")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v(":items")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"[{name:'Item1'}]\"")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v("title")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\"Category 2\"")]),_vm._v("\n        "),_c('span',{staticClass:"yellow"},[_vm._v(":show-toggle")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.showToggle)+"\"")]),_vm._v(" "),_c('span',{staticClass:"blue"},[_vm._v("/>")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("</va-sidebar>")]),_vm._v("\n\n    "),_c('span',{staticClass:"comment"},[_vm._v("<!-- https://vue-atlas.com/documentation/page -->")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("<va-page")]),_vm._v(" "),_c('span',{staticClass:"yellow"},[_vm._v("size")]),_vm._v("="),_c('span',{staticClass:"green"},[_vm._v("\""+_vm._s(_vm.pageSize)+"\"")]),_c('span',{staticClass:"blue"},[_vm._v(">")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("<transition>")]),_vm._v("\n        "),_c('span',{staticClass:"blue"},[_vm._v("<router-view>")]),_vm._v("\n          ...\n        "),_c('span',{staticClass:"blue"},[_vm._v("</router-view>")]),_vm._v("\n      "),_c('span',{staticClass:"blue"},[_vm._v("</transition>")]),_vm._v("\n    "),_c('span',{staticClass:"blue"},[_vm._v("</va-page>")]),_vm._v("\n\n  "),_c('span',{staticClass:"blue"},[_vm._v("</va-app>")]),_vm._v("\n"),_c('span',{staticClass:"blue"},[_vm._v("</template>")])])])])],1)],1)],1),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticStyle:{"text-align":"right"}},[_c('va-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.$refs.configModal.close()}}},[_vm._v(" Close ")])],1)])])],1)}
var VaAppConfigvue_type_template_id_88a299d2_staticRenderFns = []


// CONCATENATED MODULE: ./src/App/VaAppConfig.vue?vue&type=template&id=88a299d2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App/VaAppConfig.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaAppConfigvue_type_script_lang_js_ = ({
  name: 'VaAppConfig',
  mixins: [events],
  data: function data() {
    return {
      /**
       * Sensible defaults, but will be overwritten by
       * VaApp when it broadcasts initial values.
       * See broadcastDefaultsToConfig()
       */
      minibarTheme: 'default',
      sidebarTheme: 'default',
      topbarTheme: 'blue',
      showToggle: false,
      compact: false,
      textLinks: false,
      desktopSidebarWidth: 210,
      desktopMinibarWidth: 50,
      desktopTopbarHeight: 48,
      desktopMargin: 0,
      desktopMinimumWidth: 1024,
      mobileSidebarWidth: 0,
      mobileMinibarWidth: 0,
      mobileTopbarHeight: 50,
      sidebarPriority: false,
      minibarPriority: false,
      topbarPriority: false,
      topbarPadded: false,
      rtl: false,
      reverse: false,
      split: false,
      pageSize: 'md',
      bgColor: '#F4F5F7',
      pageBgColor: '#FFFFFF'
    };
  },
  watch: {
    desktopSidebarWidth: function desktopSidebarWidth(val) {
      this.dispatch('VaApp', 'Va@configDesktopSidebarWidthChange', val);
    },
    desktopTopbarHeight: function desktopTopbarHeight(val) {
      this.dispatch('VaApp', 'Va@configDesktopTopbarHeightChange', val);
    },
    desktopMinibarWidth: function desktopMinibarWidth(val) {
      this.dispatch('VaApp', 'Va@configDesktopMinibarWidthChange', val);
    },
    desktopMargin: function desktopMargin(val) {
      this.dispatch('VaApp', 'Va@configDesktopMarginChange', val);
    },
    desktopMinimumWidth: function desktopMinimumWidth(val) {
      this.dispatch('VaApp', 'Va@configDesktopMinimumWidthChange', val);
    },
    mobileSidebarWidth: function mobileSidebarWidth(val) {
      this.dispatch('VaApp', 'Va@configMobileSidebarWidthChange', val);
    },
    mobileTopbarHeight: function mobileTopbarHeight(val) {
      this.dispatch('VaApp', 'Va@configMobileTopbarHeightChange', val);
    },
    mobileMinibarWidth: function mobileMinibarWidth(val) {
      this.dispatch('VaApp', 'Va@configMobileMinibarWidthChange', val);
    },
    sidebarPriority: function sidebarPriority(val) {
      this.dispatch('VaApp', 'Va@configSidebarPriorityChange', val);
    },
    minibarPriority: function minibarPriority(val) {
      this.dispatch('VaApp', 'Va@configMinibarPriorityChange', val);
    },
    topbarPriority: function topbarPriority(val) {
      this.dispatch('VaApp', 'Va@configTopbarPriorityChange', val);
    },
    topbarPadded: function topbarPadded(val) {
      this.dispatch('VaApp', 'Va@configTopbarPaddedChange', val);
    },
    rtl: function rtl(val) {
      this.dispatch('VaApp', 'Va@configRtlChange', val);
    },
    split: function split(val) {
      this.dispatch('VaApp', 'Va@configSplitChange', val);
    },
    reverse: function reverse(val) {
      this.dispatch('VaApp', 'Va@configReverseChange', val);
    },
    compact: function compact(val) {
      this.dispatch('VaApp', 'Va@configCompactChange', val);
    },
    showToggle: function showToggle(val) {
      this.dispatch('VaApp', 'Va@configShowToggleChange', val);
    },
    textLinks: function textLinks(val) {
      this.dispatch('VaApp', 'Va@configTextLinksChange', val);
    },
    pageSize: function pageSize(val) {
      this.dispatch('VaApp', 'Va@configPageSizeChange', val);
    },
    topbarTheme: function topbarTheme(val) {
      this.dispatch('VaApp', 'Va@configTopbarThemeChange', val);
    },
    minibarTheme: function minibarTheme(val) {
      this.dispatch('VaApp', 'Va@configMinibarThemeChange', val);
    },
    sidebarTheme: function sidebarTheme(val) {
      this.dispatch('VaApp', 'Va@configSidebarThemeChange', val);
    },
    bgColor: function bgColor(val) {
      this.dispatch('VaApp', 'Va@configBgColorChange', val);
    },
    pageBgColor: function pageBgColor(val) {
      this.dispatch('VaApp', 'Va@configPageBgColorChange', val);
    }
  },
  methods: {
    showConfigModal: function showConfigModal() {
      var _this = this;

      this.$refs.configModal.open();
      setTimeout(function () {
        _this.$refs.desktopSidebarWidthRange.update();

        _this.$refs.desktopMinibarWidthRange.update();

        _this.$refs.desktopTopbarHeightRange.update();

        _this.$refs.mobileSidebarWidthRange.update();

        _this.$refs.mobileMinibarWidthRange.update();

        _this.$refs.mobileTopbarHeightRange.update();

        _this.$refs.desktopMarginRange.update();

        _this.$refs.desktopMinimumWidthRange.update();
      }, 10);
    },
    getPosition: function getPosition(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        x: rect.x,
        y: rect.y
      };
    },
    onBgColorChange: function onBgColorChange(e) {
      this.bgColor = e.hex;
    },
    onPageBgColorChange: function onPageBgColorChange(e) {
      this.pageBgColor = e.hex;
    }
  },
  created: function created() {
    var _this2 = this;

    /**
     * Here we set up receiver events so that if we pass defaults to the
     * App component, we can send them over to the config component.
     */
    this.$on('Va@configReceiveDesktopTopbarHeight', function (val) {
      _this2.desktopTopbarHeight = val;
    });
    this.$on('Va@configReceiveDesktopMinibarWidth', function (val) {
      _this2.desktopMinibarWidth = val;
    });
    this.$on('Va@configReceiveDesktopSidebarWidth', function (val) {
      _this2.desktopSidebarWidth = val;
    });
    this.$on('Va@configReceiveDesktopMinimumWidth', function (val) {
      _this2.desktopMinimumWidth = val;
    });
    this.$on('Va@configReceiveMobileMinibarWidth', function (val) {
      _this2.mobileMinibarWidth = val;
    });
    this.$on('Va@configReceiveMobileSidebarWidth', function (val) {
      _this2.mobileSidebarWidth = val;
    });
    this.$on('Va@configReceiveMobileTopbarHeight', function (val) {
      _this2.mobileTopbarHeight = val;
    });
    this.$on('Va@configReceiveSidebarPriority', function (val) {
      _this2.sidebarPriority = val;
    });
    this.$on('Va@configReceiveMinibarPriority', function (val) {
      _this2.minibarPriority = val;
    });
    this.$on('Va@configReceiveTopbarPriority', function (val) {
      _this2.topbarPriority = val;
    });
    this.$on('Va@configReceiveDesktopMargin', function (val) {
      _this2.desktopMargin = val;
    });
    this.$on('Va@configReceiveTopbarPadded', function (val) {
      _this2.topbarPadded = val;
    });
    this.$on('Va@configReceiveMinibarTheme', function (val) {
      _this2.minibarTheme = val;
    });
    this.$on('Va@configReceiveSidebarTheme', function (val) {
      _this2.sidebarTheme = val;
    });
    this.$on('Va@configReceiveTopbarTheme', function (val) {
      _this2.topbarTheme = val;
    });
    this.$on('Va@configReceivePageBgColor', function (val) {
      _this2.pageBgColor = val;
    });
    this.$on('Va@configReceiveShowToggle', function (val) {
      _this2.showToggle = val;
    });
    this.$on('Va@configReceiveTextLinks', function (val) {
      _this2.textLinks = val;
    });
    this.$on('Va@configReceivePageSize', function (val) {
      _this2.pageSize = val;
    });
    this.$on('Va@configReceiveCompact', function (val) {
      _this2.compact = val;
    });
    this.$on('Va@configReceiveReverse', function (val) {
      _this2.reverse = val;
    });
    this.$on('Va@configReceiveBgColor', function (val) {
      _this2.bgColor = val;
    });
    this.$on('Va@configReceiveSplit', function (val) {
      _this2.split = val;
    });
    this.$on('Va@configReceiveRtl', function (val) {
      _this2.rtl = val;
    });
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      return classes;
    },
    styleObj: function styleObj() {
      var style = {};
      style['position'] = 'fixed';
      style['right'] = '20px';
      style['z-index'] = '99999';
      style['bottom'] = '20px';
      return style;
    },
    shouldTopbarPriorityBeDisabled: function shouldTopbarPriorityBeDisabled() {
      if (this.sidebarPriority || this.minibarPriority) {
        return true;
      }

      if (this.desktopMargin === 0) {
        return true;
      }

      return false;
    },
    shouldTopbarPaddedBeDisabled: function shouldTopbarPaddedBeDisabled() {
      if (this.desktopMargin === 0) {
        return true;
      }

      if (!this.topbarPriority) {
        return true;
      }

      return false;
    }
  }
});
// CONCATENATED MODULE: ./src/App/VaAppConfig.vue?vue&type=script&lang=js&
 /* harmony default export */ var App_VaAppConfigvue_type_script_lang_js_ = (VaAppConfigvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/App/VaAppConfig.vue?vue&type=style&index=0&lang=scss&
var VaAppConfigvue_type_style_index_0_lang_scss_ = __webpack_require__("7b63");

// CONCATENATED MODULE: ./src/App/VaAppConfig.vue






/* normalize component */

var VaAppConfig_component = normalizeComponent(
  App_VaAppConfigvue_type_script_lang_js_,
  VaAppConfigvue_type_template_id_88a299d2_render,
  VaAppConfigvue_type_template_id_88a299d2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaAppConfig = (VaAppConfig_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Input/VaInputOps.vue?vue&type=template&id=649085bf&
var VaInputOpsvue_type_template_id_649085bf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeUp"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"popup",class:_vm.classObj,style:(_vm.styleObj)},[_c('va-button',{ref:"confirmButton",staticStyle:{"margin-right":"3px"},attrs:{"size":"sm","loading":_vm.loading,"type":"default"},nativeOn:{"click":function($event){return _vm.confirmClicked($event)}}},[_c('va-icon',{attrs:{"type":"check","size":"10px"}})],1),_c('va-button',{ref:"cancelButton",style:({ visibility: _vm.loading ? 'hidden' : 'visible' }),attrs:{"size":"sm","type":"default"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_c('va-icon',{attrs:{"type":"times","size":"10px"}})],1)],1)])}
var VaInputOpsvue_type_template_id_649085bf_staticRenderFns = []


// CONCATENATED MODULE: ./src/Input/VaInputOps.vue?vue&type=template&id=649085bf&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Input/VaInputOps.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaInputOpsvue_type_script_lang_js_ = ({
  name: 'VaInputOps',
  mixins: [events],
  props: {
    parentPosition: {
      type: Object
    }
  },
  data: function data() {
    return {
      show: false,
      initialValue: '',
      currentValue: '',
      needToSave: false,
      position: {},
      shouldBlur: false,
      loading: false,
      opacity: false
      /* exists to hide element until getPosition finishes to prevent flicker */

    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@inputBlur', function (val) {
      _this.handleBlur(val);
    });
    this.$on('Va@inputFocus', function (val) {
      _this.handleFocus(val);
    });
    this.$on('Va@inputLoading', function (val) {
      _this.handleInputLoading(val);
    });
    this.$on('Va@inputUpdate', function (val) {
      _this.handleInputUpdate(val);
    });
    this.$on('Va@inputEnterPressed', function (val) {
      _this.handleEnterPressed(val);
    });
    this.$on('Va@inputCurrentValueUpdate', function (val) {
      _this.handleCurrentValueUpdate(val);
    });
  },
  mounted: function mounted() {
    var $body = document.querySelector('body');
    $body.appendChild(this.$refs.popup);
  },
  beforeDestroy: function beforeDestroy() {
    var $body = document.querySelector('body');
    $body.removeChild(this.$refs.popup);
  },
  methods: {
    confirmClicked: function confirmClicked() {
      this.shouldBlur = true;
      this.confirm();
    },
    confirm: function confirm() {
      if (this.initialValue !== this.currentValue) {
        this.$emit('confirm');
        this.dispatch('VaInput', 'Va@inputOpsConfirm', true);
        this.dispatch('VaTextarea', 'Va@inputOpsConfirm', true);
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.needToSave = false;
      this.dispatch('VaInput', 'Va@inputOpsCancel', this.initialValue);
      this.dispatch('VaTextarea', 'Va@inputOpsCancel', this.initialValue);
      this.show = false;
    },
    handleBlur: function handleBlur(val) {
      if (val === this.initialValue) {
        this.show = false;
        this.needToSave = false;
      } else {
        this.needToSave = true;
      }

      this.shouldBlur = true;
    },
    handleFocus: function handleFocus(val) {
      var _this2 = this;

      this.shouldBlur = false;

      if (!this.needToSave) {
        this.initialValue = val;
        this.currentValue = val;
        this.show = true;
        /**
         * This short timeout provides, what seems like, a fine amount of
         * time for this element to be inserted into the DOM. When it's not
         * on the DOM, there's no position to get.
         */

        setTimeout(function () {
          _this2.setPosition();

          _this2.opacity = true;
        }, 10);
      }
    },
    handleInputLoading: function handleInputLoading(val) {
      this.loading = val;
    },
    handleInputUpdate: function handleInputUpdate(val) {
      if (val === this.initialValue) {
        this.needToSave = false;
      } else {
        this.needToSave = true;
      }
    },
    handleCurrentValueUpdate: function handleCurrentValueUpdate(val) {
      this.currentValue = val;
    },
    handleEnterPressed: function handleEnterPressed() {
      this.confirm();
    },
    setPosition: function setPosition() {
      this.position = this.getPosition();
    },
    getPosition: function getPosition() {
      var rect = this.$refs.popup.getBoundingClientRect();
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        x: rect.x,
        y: rect.y
      };
    }
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-input-ops'] = true;
      return classes;
    },
    styleObj: function styleObj() {
      var style = {};
      var opacity = this.opacity;
      var parentPosition = this.parentPosition;
      var position = this.position;
      style['position'] = 'fixed';
      style['top'] = parentPosition.top + parentPosition.height + 3 + 'px';
      style['left'] = parentPosition.left + (parentPosition.width - position.width) + 'px';
      style['opacity'] = opacity ? '1' : '0';
      return style;
    }
  },
  watch: {
    loading: function loading(val) {
      if (val === false && this.show === true) {
        if (this.shouldBlur) {
          this.show = false;
          this.shouldBlur = false;
        }

        this.needToSave = false;
        this.initialValue = this.currentValue;
      }
    },
    needToSave: function needToSave(val) {
      if (val) {
        this.show = true;
      }
    },
    show: function show(val) {
      if (!val) {
        this.opacity = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Input/VaInputOps.vue?vue&type=script&lang=js&
 /* harmony default export */ var Input_VaInputOpsvue_type_script_lang_js_ = (VaInputOpsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Input/VaInputOps.vue





/* normalize component */

var VaInputOps_component = normalizeComponent(
  Input_VaInputOpsvue_type_script_lang_js_,
  VaInputOpsvue_type_template_id_649085bf_render,
  VaInputOpsvue_type_template_id_649085bf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaInputOps = (VaInputOps_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Lozenge/VaLozenge.vue?vue&type=template&id=de876cdc&
var VaLozengevue_type_template_id_de876cdc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classObj},[_vm._t("default")],2)}
var VaLozengevue_type_template_id_de876cdc_staticRenderFns = []


// CONCATENATED MODULE: ./src/Lozenge/VaLozenge.vue?vue&type=template&id=de876cdc&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__("cc71");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Lozenge/VaLozenge.vue?vue&type=script&lang=js&


//
//
//
//
//
//
/* harmony default export */ var VaLozengevue_type_script_lang_js_ = ({
  name: 'VaLozenge',
  props: {
    type: {
      type: String,
      required: false,
      default: 'default',
      validator: function validator(v) {
        return ['default', 'primary', 'success', 'warning', 'danger', 'subtle', 'help'].includes(v);
      }
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    uppercase: {
      type: Boolean,
      required: false,
      default: false
    },
    truncate: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      validator: function validator(v) {
        return ['lg', 'sm'].includes(v);
      }
    }
  },
  computed: {
    classObj: function classObj() {
      var bold = this.bold,
          type = this.type,
          size = this.size,
          uppercase = this.uppercase,
          truncate = this.truncate;
      var classes = {};
      classes['va-lozenge'] = true;
      classes['va-lozenge-bold'] = bold;
      type ? classes['va-lozenge-' + type] = true : '';
      size ? classes['va-lozenge-' + size] = true : '';
      uppercase ? classes['va-lozenge-uppercase'] = true : '';
      truncate ? classes['va-lozenge-truncate'] = true : '';
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Lozenge/VaLozenge.vue?vue&type=script&lang=js&
 /* harmony default export */ var Lozenge_VaLozengevue_type_script_lang_js_ = (VaLozengevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Lozenge/VaLozenge.vue?vue&type=style&index=0&lang=scss&
var VaLozengevue_type_style_index_0_lang_scss_ = __webpack_require__("e0eb");

// CONCATENATED MODULE: ./src/Lozenge/VaLozenge.vue






/* normalize component */

var VaLozenge_component = normalizeComponent(
  Lozenge_VaLozengevue_type_script_lang_js_,
  VaLozengevue_type_template_id_de876cdc_render,
  VaLozengevue_type_template_id_de876cdc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaLozenge = (VaLozenge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaContainer.vue?vue&type=template&id=49e8d7e2&
var VaContainervue_type_template_id_49e8d7e2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default")],2)}
var VaContainervue_type_template_id_49e8d7e2_staticRenderFns = []


// CONCATENATED MODULE: ./src/Grid/VaContainer.vue?vue&type=template&id=49e8d7e2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Grid/VaContainer.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */ var VaContainervue_type_script_lang_js_ = ({
  name: 'VaContainer',
  props: {
    fluid: {
      type: Boolean
    }
  },
  computed: {
    classObj: function classObj() {
      var fluid = this.fluid;
      var classes = {};
      classes['va-container-fluid'] = fluid;
      classes['va-container'] = !fluid;
      classes['clearfix'] = true;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Grid/VaContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var Grid_VaContainervue_type_script_lang_js_ = (VaContainervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Grid/VaContainer.vue





/* normalize component */

var VaContainer_component = normalizeComponent(
  Grid_VaContainervue_type_script_lang_js_,
  VaContainervue_type_template_id_49e8d7e2_render,
  VaContainervue_type_template_id_49e8d7e2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaContainer = (VaContainer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown/VaDropdown.vue?vue&type=template&id=194755a9&
var VaDropdownvue_type_template_id_194755a9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["va-dropdown-con", _vm.classObj]},[_c('span',{ref:"trigger",attrs:{"focus":_vm.onFocus}},[_vm._t("trigger")],2),_c('transition',{attrs:{"name":_vm.effect}},[_c('ul',{directives:[{name:"va-position",rawName:"v-va-position",value:(_vm.show),expression:"show"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:"va-dropdown-menu"},[_vm._t("default")],2)])],1)}
var VaDropdownvue_type_template_id_194755a9_staticRenderFns = []


// CONCATENATED MODULE: ./src/Dropdown/VaDropdown.vue?vue&type=template&id=194755a9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown/VaDropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaDropdownvue_type_script_lang_js_ = ({
  name: 'VaDropdown',
  props: {
    triggerEvent: {
      type: String,
      default: 'click',
      required: false
    },
    clickClose: {
      type: Boolean,
      default: false,
      required: false
    },
    effect: {
      type: String,
      default: 'fadeDown',
      required: false
    },
    tall: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  methods: {
    open: function open() {
      this.show = true;
      this.$emit('show');
    },
    close: function close() {
      this.show = false;
      this.$emit('hide');
    },
    toggle: function toggle() {
      this.show ? this.close() : this.open();
      this.$emit('toggle');
    },
    onFocus: function onFocus() {}
  },
  computed: {
    classObj: function classObj() {
      var tall = this.tall;
      var classes = {};
      classes['va-dropdown-selected'] = this.show;
      classes['va-dropdown-con-tall'] = tall;
      return classes;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (!_this.$refs.trigger) {
        return;
      }

      var el = _this.$el;
      var trig = _this.$refs.trigger.children[0];

      if (_this.triggerEvent === 'click') {
        _this._clickEvent = utils_EventListener.listen(trig, 'click', _this.toggle);
        _this._closeEvent = utils_EventListener.listen(window, 'click', function (e) {
          if (!_this.clickClose && !el.contains(e.target) && _this.show) {
            _this.close();
          }
        });
      } else if (_this.triggerEvent === 'hover') {
        _this._mouseenterEvent = utils_EventListener.listen(trig, 'mouseenter', function () {
          _this.open();
        });
        _this._closeEvent = utils_EventListener.listen(_this.$el, 'mouseleave', function () {
          setTimeout(function () {
            _this.close();
          }, 500);
        });
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._closeEvent) this._closeEvent.remove();
    if (this._clickEvent) this._clickEvent.remove();
    if (this._mouseenterEvent) this._mouseenterEvent.remove();
  }
});
// CONCATENATED MODULE: ./src/Dropdown/VaDropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dropdown_VaDropdownvue_type_script_lang_js_ = (VaDropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Dropdown/VaDropdown.vue?vue&type=style&index=0&lang=scss&
var VaDropdownvue_type_style_index_0_lang_scss_ = __webpack_require__("5b53");

// CONCATENATED MODULE: ./src/Dropdown/VaDropdown.vue






/* normalize component */

var VaDropdown_component = normalizeComponent(
  Dropdown_VaDropdownvue_type_script_lang_js_,
  VaDropdownvue_type_template_id_194755a9_render,
  VaDropdownvue_type_template_id_194755a9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaDropdown = (VaDropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckbox.vue?vue&type=template&id=c5b6c752&
var VaCheckboxvue_type_template_id_c5b6c752_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObj},[_c('span',[_c('span',{class:"va-checkbox-inner",attrs:{"tabindex":_vm.disabled ? -1 : 0},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handleClick($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterPressed($event)}}},[_c('va-icon',{class:"va-checkbox-inner-check",attrs:{"type":"check"}})],1),_c('input',{class:"va-checkbox-input",attrs:{"disabled":_vm.disabled,"name":_vm.name,"tabindex":"-1","type":"checkbox"},domProps:{"checked":_vm.currentChecked},on:{"click":_vm.handleClick}})]),_c('span',{class:"va-label"},[_vm._t("default")],2),_c('validate',{attrs:{"current":_vm.currentChecked,"custom-validate":_vm.customValidate,"name":_vm.name,"rules":_vm.rules}})],1)}
var VaCheckboxvue_type_template_id_c5b6c752_staticRenderFns = []


// CONCATENATED MODULE: ./src/Checkbox/VaCheckbox.vue?vue&type=template&id=c5b6c752&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckbox.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VaCheckboxvue_type_script_lang_js_ = ({
  name: 'VaCheckbox',
  mixins: [validationMixin, events],
  props: {
    name: {
      type: String
    },
    value: {
      type: [String, Boolean]
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    validate: validate
  },
  data: function data() {
    var checked = this.checked;

    if (checked !== undefined) {
      this.$emit('input', checked);
    } else {
      checked = !!this.value;
    }

    return {
      currentChecked: checked
    };
  },
  watch: {
    value: function value(val) {
      this.currentChecked = val;
    },
    checked: function checked(val) {
      this.currentChecked = val;
    },
    currentChecked: function currentChecked(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    classObj: function classObj() {
      var currentChecked = this.currentChecked,
          disabled = this.disabled;
      var classes = {};
      classes['va-checkbox-label'] = true;
      classes['va-checkbox-checked'] = currentChecked;
      classes['va-checkbox-disabled'] = disabled;
      return classes;
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@checkboxgroupChange', function (val) {
      _this.currentChecked = val.indexOf(_this.label) > -1;
    });
  },
  methods: {
    handleClick: function handleClick() {
      this.currentChecked = !this.currentChecked;
      this.dispatch('VaCheckboxGroup', 'Va@checkboxChange', this);
      this.$emit('change', this.currentChecked);
    },
    enterPressed: function enterPressed() {
      this.handleClick();
    }
  }
});
// CONCATENATED MODULE: ./src/Checkbox/VaCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var Checkbox_VaCheckboxvue_type_script_lang_js_ = (VaCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Checkbox/VaCheckbox.vue?vue&type=style&index=0&lang=scss&
var VaCheckboxvue_type_style_index_0_lang_scss_ = __webpack_require__("0728");

// CONCATENATED MODULE: ./src/Checkbox/VaCheckbox.vue






/* normalize component */

var VaCheckbox_component = normalizeComponent(
  Checkbox_VaCheckboxvue_type_script_lang_js_,
  VaCheckboxvue_type_template_id_c5b6c752_render,
  VaCheckboxvue_type_template_id_c5b6c752_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCheckbox = (VaCheckbox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Textarea/VaTextarea.vue?vue&type=template&id=893f9bae&
var VaTextareavue_type_template_id_893f9bae_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showButtonsWarning)?_c('div',{ref:"textareaContainer",class:_vm.classObjContainer,style:(_vm.styleObjContainer)},[_c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",class:_vm.classObj,style:(_vm.styleObj),attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly,"maxlength":_vm.maxLength,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":(_vm.currentValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.update($event.target.value)}],"focus":_vm.focus,"blur":_vm.blur,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.kd_tab($event)}}},'textarea',_vm.$attrs,false)),(_vm.buttons)?_c('va-input-ops',{attrs:{"parent-position":_vm.position},on:{"confirm":_vm.opsConfirm,"cancel":_vm.opsCancel}}):_vm._e(),_c('validate',{attrs:{"name":_vm.name,"rules":_vm.rules,"custom-validate":_vm.customValidate,"current":_vm.value},model:{value:(_vm.validStatus),callback:function ($$v) {_vm.validStatus=$$v},expression:"validStatus"}})],1):_c('div',[_c('va-alert',{attrs:{"type":"warning"}},[_c('h4',[_vm._v("Hold on")]),_c('p',[_vm._v(" If you're going to use "),_c('b',[_vm._v("buttons")]),_vm._v(" with this textarea component, you need to also use the "),_c('b',[_vm._v("loading")]),_vm._v(" prop. Handle the "),_c('b',[_vm._v("@confirm")]),_vm._v(" event emitted by the input component, set the "),_c('b',[_vm._v("loading")]),_vm._v(" prop to true, "),_c('i',[_vm._v("do some task")]),_vm._v(", and finally set the "),_c('b',[_vm._v("loading")]),_vm._v(" prop back to false. It is important that events happen in that order, because the input component is watching the "),_c('b',[_vm._v("loading")]),_vm._v(" prop for those changes. That's how it knows to hide the confirm and cancel buttons. ")])])],1)}
var VaTextareavue_type_template_id_893f9bae_staticRenderFns = []


// CONCATENATED MODULE: ./src/Textarea/VaTextarea.vue?vue&type=template&id=893f9bae&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Textarea/VaTextarea.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VaTextareavue_type_script_lang_js_ = ({
  name: 'VaTextarea',
  mixins: [validationMixin, events, inputMixin],
  inheritAttrs: false,
  props: {
    name: {
      type: String
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    resize: {
      type: Boolean,
      default: false,
      required: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    maxHeight: {
      type: String,
      required: false,
      default: '200px'
    },
    minHeight: {
      type: String,
      required: false,
      default: '100px'
    },
    value: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    buttons: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: undefined
    },
    autosize: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var cv = this.value;
    return {
      focused: false,
      currentValue: cv,
      position: {},
      showButtonsWarning: false,
      desiredHeight: 0,
      inputWatch: null
    };
  },
  components: {
    validate: validate
  },
  created: function created() {
    var _this = this;

    this.$on('Va@inputOpsCancel', function (val) {
      _this.currentValue = val;
    });
    this.$on('Va@inputOpsConfirm', function () {});
    this.$on('Va@inputOpsBlur', function () {
      _this.focused = false;
    });
    this.$on('Va@pageScroll', function () {
      _this.setPosition();
    }); // document.addEventListener('keyup', this.keyup)
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.textarea.removeEventListener('input', this.resizeTextarea);
    window.removeEventListener('resize', this.setPosition, false);
    window.removeEventListener('scroll', this.setPosition, false); // document.removeEventListener('keyup', this.keyup)
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$refs.textarea.addEventListener('input', this.resizeTextarea);
    window.addEventListener('resize', this.setPosition, false);
    window.addEventListener('scroll', this.setPosition, false);

    if (this.buttons && this.loading === undefined) {
      this.showButtonsWarning = true;
    }

    if (this.autosize) {
      this.$nextTick(function () {
        _this2.$refs.textareaContainer.style.height = _this2.$refs.textareaContainer.scrollHeight + 'px';
      });
    }
  },
  watch: {
    loading: function loading(val) {
      this.broadcast('VaInputOps', 'Va@inputLoading', val);
    },
    value: function value(val) {
      var _this3 = this;

      this.currentValue = val;
      /**
       * Sometimes the Textarea will have its value updated
       * using v-model, which won't trigger an input event,
       * which means resizeTextarea won't get called. We
       * manually trigger an input event so that this happens
       * after a very short wait.
       */

      setTimeout(function () {
        _this3.$refs.textarea.dispatchEvent(new Event('input'));
      }, 20);
    },
    currentValue: function currentValue(val) {
      this.broadcast('VaInputOps', 'Va@inputCurrentValueUpdate', val);
    }
  },
  methods: {
    kd_tab: function kd_tab(e) {
      e.preventDefault();
      var textarea = this.$refs.textarea;
      var start = textarea.selectionStart;
      var end = textarea.selectionEnd;
      var target = e.target;
      var value = target.value;
      target.value = value.substring(0, start) + '\t' + value.substring(end);
      textarea.selectionStart = textarea.selectionEnd = start + 1;
    },
    update: function update(val) {
      var _this4 = this;

      this.$emit('input', val);
      this.$emit('change', val);

      if (this.buttons) {
        this.broadcast('VaInputOps', 'Va@inputUpdate', this.currentValue);
      }
      /**
       * If a bunch of text was pasted into the input, we should wait a short bit
       * before updating the position of the element, so that inputOps can be
       * adjusted to the correct location.
       */


      setTimeout(function () {
        _this4.position = _this4.getPosition();
      }, 20);
    },
    focus: function focus() {
      var _this5 = this;

      /**
       * This setTimeout exists because sometimes you'll want to call
       * this.$refs.input.focus() when the input is inside of something
       * like, say, a dropdown. We need to give the element time to be
       * added to the DOM before we send a focus event to it.
       *
       * This short timeout provides, what seems like, a fine amount of
       * time for this to happen without being noticable by the human eye.
       */
      setTimeout(function () {
        _this5.$refs.textarea.focus();

        _this5.$emit('focus', _this5.value);

        _this5.focused = true;

        if (_this5.buttons) {
          _this5.position = _this5.getPosition();

          _this5.broadcast('VaInputOps', 'Va@inputFocus', _this5.currentValue);
        }
      }, 20);
    },
    blur: function blur() {
      this.focused = false;
      this.$emit('blur', this.value);

      if (this.buttons) {
        this.broadcast('VaInputOps', 'Va@inputBlur', this.currentValue);
      }
    },
    enterPressed: function enterPressed() {
      this.opsConfirm();
    },
    setPosition: function setPosition() {
      this.position = this.getPosition();
    },
    getPosition: function getPosition() {
      var rect = this.$refs.textarea.getBoundingClientRect();
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        x: rect.x,
        y: rect.y
      };
    },
    opsConfirm: function opsConfirm() {
      this.$emit('confirm', this.value);
    },
    opsCancel: function opsCancel() {
      this.$emit('cancel');
    },
    resizeTextarea: function resizeTextarea(event) {
      if (this.autosize) {
        this.$refs.textareaContainer.style.height = 'auto';
        this.$refs.textareaContainer.style.height = event.target.scrollHeight + 4 + 'px';
        this.position = this.getPosition();
      }
    }
  },
  computed: {
    styleObj: function styleObj() {
      var resize = this.resize,
          actualWidth = this.actualWidth;
      var style = {};
      style['resize'] = resize ? 'both' : 'none';
      style['width'] = actualWidth;
      return style;
    },
    classObj: function classObj() {
      var classes = {};
      classes['va-form-control'] = true;
      classes['va-textarea'] = true;
      return classes;
    },
    styleObjContainer: function styleObjContainer() {
      var minHeight = this.minHeight,
          width = this.width;
      var style = {};
      style['width'] = width;
      style['min-height'] = minHeight;
      style['position'] = 'relative';
      return style;
    },
    classObjContainer: function classObjContainer() {
      var validStatus = this.validStatus;
      var classes = {};
      classes['va-has-error'] = validStatus === 'error';
      classes['va-has-success'] = validStatus === 'success';
      classes['va-has-warn'] = validStatus === 'warn';
      classes['va-textarea-con'] = true; // classes['inline'] = true

      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Textarea/VaTextarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var Textarea_VaTextareavue_type_script_lang_js_ = (VaTextareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Textarea/VaTextarea.vue?vue&type=style&index=0&lang=scss&
var VaTextareavue_type_style_index_0_lang_scss_ = __webpack_require__("a00e");

// CONCATENATED MODULE: ./src/Textarea/VaTextarea.vue






/* normalize component */

var VaTextarea_component = normalizeComponent(
  Textarea_VaTextareavue_type_script_lang_js_,
  VaTextareavue_type_template_id_893f9bae_render,
  VaTextareavue_type_template_id_893f9bae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTextarea = (VaTextarea_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadioGroup.vue?vue&type=template&id=bf1acd86&
var VaRadioGroupvue_type_template_id_bf1acd86_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default"),_c('validate',{attrs:{"name":_vm.name,"rules":_vm.rules,"custom-validate":_vm.customValidate,"current":_vm.value}})],2)}
var VaRadioGroupvue_type_template_id_bf1acd86_staticRenderFns = []


// CONCATENATED MODULE: ./src/Radio/VaRadioGroup.vue?vue&type=template&id=bf1acd86&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Radio/VaRadioGroup.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VaRadioGroupvue_type_script_lang_js_ = ({
  name: 'VaRadioGroup',
  mixins: [validationMixin, events],
  props: {
    value: {
      type: [String, Array]
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentValue: ''
    };
  },
  methods: {
    init: function init(val) {
      if (!utils_type.isUndefined(val)) {
        this.currentValue = val;
      } else {
        // first load
        var children = this.$children;
        var ret;
        children.forEach(function (item) {
          item.currentChecked ? ret = item.label : '';
        });
        this.currentValue = ret;
      }
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.broadcast('VaRadio', 'Va@radiogroupChange', val);
      this.broadcast('VaRadioBtn', 'Va@radiogroupChange', val);
      this.$emit('input', val);
      this.$emit('change', val);
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@radioChange', function (val) {
      _this.init(val);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.currentValue = this.value;
    this.$nextTick(function () {
      _this2.init();
    });
  },
  components: {
    validate: validate
  },
  computed: {
    classObj: function classObj() {
      var vertical = this.vertical;
      var classes = {}; // The -btn-group class is only necessary to give the proper border radius to buttons
      // in a radio group if radio buttons are used instead of regular radio elements.

      classes['va-btn-group'] = !vertical;
      classes['va-btn-group-vertical'] = vertical;
      classes['va-radio-group'] = true;
      classes['va-radio-group-vertical'] = vertical;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Radio/VaRadioGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var Radio_VaRadioGroupvue_type_script_lang_js_ = (VaRadioGroupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Radio/VaRadioGroup.vue





/* normalize component */

var VaRadioGroup_component = normalizeComponent(
  Radio_VaRadioGroupvue_type_script_lang_js_,
  VaRadioGroupvue_type_template_id_bf1acd86_render,
  VaRadioGroupvue_type_template_id_bf1acd86_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaRadioGroup = (VaRadioGroup_component.exports);
// CONCATENATED MODULE: ./src/Modal/VaModalMethod.js






var $body = document.querySelector('body');

var createNode = function createNode() {
  var $node = document.createElement('div');
  $body.appendChild($node);
  return $node;
};

var typeMap = {
  success: {
    name: 'check-circle',
    color: '#57D9A3'
  },
  info: {
    name: 'info-circle',
    color: '#4C9AFF'
  },
  warning: {
    name: 'exclamation-circle',
    color: '#F29D41'
  },
  danger: {
    name: 'exclamation-circle',
    color: '#CD4425'
  }
};
var buttonTypeMap = {
  success: {
    appearance: 'primary'
  },
  info: {
    appearance: 'primary'
  },
  warning: {
    appearance: 'warning'
  },
  danger: {
    appearance: 'danger'
  }
};

var VaModalMethod_confirm = function confirm(options) {
  var title = options.title,
      message = options.message,
      effect = options.effect,
      type = options.type,
      width = options.width,
      onConfirm = options.onConfirm,
      onHide = options.onHide,
      onShow = options.onShow,
      backdropClickable = options.backdropClickable;
  /* eslint-disable no-new */

  new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    el: createNode(),
    mixins: [localeMixin('VaModal')],
    mounted: function mounted() {
      this.$refs.modal.open();
    },
    computed: {
      iconType: function iconType() {
        return typeMap[type || 'info'];
      },
      buttonType: function buttonType() {
        return buttonTypeMap[type || 'primary'];
      }
    },
    methods: {
      handleShow: function handleShow() {
        onShow && onShow();
      },
      handleConfirm: function handleConfirm() {
        onConfirm && onConfirm();
        this.$refs.modal.close();
      },
      handleClose: function handleClose() {
        this.$refs.modal.close();
      },
      handleHide: function handleHide() {
        onHide && onHide();
      },
      destroy: function destroy() {
        this.$destroy();
      }
    },
    render: function render(createElement) {
      var iconElement = createElement(VaIcon, {
        props: {
          type: this.iconType.name,
          margin: '0 10px 0 0'
        },
        style: {
          color: this.iconType.color
        }
      }, []);
      var titleElement = '';

      if (title) {
        titleElement = createElement('div', {
          slot: 'title'
        }, [iconElement, title]);
      }

      var bodyElement = createElement('div', {
        slot: 'body',
        domProps: {
          innerHTML: message
        }
      });
      var confirmElement = createElement(VaButton, {
        slot: 'footer',
        props: {
          type: this.buttonType.appearance
        },
        on: {
          click: this.handleConfirm
        }
      }, [this.getL('confirm')]);
      var cancelElement = createElement(VaButton, {
        slot: 'footer',
        on: {
          click: this.handleClose
        }
      }, [this.getL('cancel')]);
      return createElement(Modal_VaModal, {
        ref: 'modal',
        props: {
          title: title,
          effect: effect || 'fade-up',
          width: width || '600px',
          backdropClickable: backdropClickable || false
        },
        on: {
          confirm: this.handleConfirm,
          hide: this.handleHide,
          show: this.handleShow,
          closed: this.destroy
        }
      }, [titleElement, bodyElement, confirmElement, cancelElement]);
    }
  });
};

var VaModalMethod_alert = function alert(options) {
  var title = options.title,
      message = options.message,
      effect = options.effect,
      type = options.type,
      width = options.width,
      onConfirm = options.onConfirm,
      onHide = options.onHide,
      onShow = options.onShow,
      backdropClickable = options.backdropClickable;
  /* eslint-disable no-new */

  new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    el: createNode(),
    mixins: [localeMixin('VaModal')],
    mounted: function mounted() {
      this.$refs.modal.open();
    },
    computed: {
      iconType: function iconType() {
        return typeMap[type || 'info'];
      },
      buttonType: function buttonType() {
        return buttonTypeMap[type || 'primary'];
      }
    },
    methods: {
      handleShow: function handleShow() {
        onShow && onShow();
      },
      handleConfirm: function handleConfirm() {
        onConfirm && onConfirm();
        this.$refs.modal.close();
      },
      handleClose: function handleClose() {
        this.$refs.modal.close();
      },
      handleHide: function handleHide() {
        onHide && onHide();
      },
      destroy: function destroy() {
        this.$destroy();
      }
    },
    render: function render(createElement) {
      var iconElement = createElement(VaIcon, {
        props: {
          type: this.iconType.name,
          margin: '0 10px 0 0'
        },
        style: {
          color: this.iconType.color
        }
      }, []);
      var titleElement = '';

      if (title) {
        titleElement = createElement('div', {
          slot: 'title'
        }, [iconElement, title]);
      }

      var bodyElement = createElement('div', {
        slot: 'body',
        domProps: {
          innerHTML: message
        }
      });
      var footerElement = createElement(VaButton, {
        slot: 'footer',
        props: {
          type: this.buttonType.appearance
        },
        on: {
          click: this.handleConfirm
        }
      }, [this.getL('confirm')]);
      return createElement(Modal_VaModal, {
        ref: 'modal',
        props: {
          title: title,
          effect: effect || 'fade-up',
          width: width || '600px',
          backdropClickable: backdropClickable || false
        },
        on: {
          confirm: this.handleConfirm,
          hide: this.handleHide,
          show: this.handleShow,
          closed: this.destroy
        }
      }, [titleElement, bodyElement, footerElement]);
    }
  });
};

/* harmony default export */ var VaModalMethod = ({
  alert: VaModalMethod_alert,
  confirm: VaModalMethod_confirm
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Toast/VaToast.vue?vue&type=template&id=9d6fcda8&
var VaToastvue_type_template_id_9d6fcda8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{ref:"dom",class:_vm.classObj,on:{"click":_vm.handleClick}},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})]):_vm._e()])}
var VaToastvue_type_template_id_9d6fcda8_staticRenderFns = []


// CONCATENATED MODULE: ./src/Toast/VaToast.vue?vue&type=template&id=9d6fcda8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Toast/VaToast.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
/* harmony default export */ var VaToastvue_type_script_lang_js_ = ({
  name: 'VaToast',
  props: {
    text: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'center',
      validator: function validator(v) {
        return ['bottom-right', 'top', 'top-right', 'top-left', 'bottom', 'bottom-left', 'center'].includes(v);
      }
    },
    type: {
      type: String,
      default: 'default',
      validator: function validator(v) {
        return ['default', 'success', 'primary', 'info', 'warning', 'danger'].includes(v);
      }
    },
    duration: {
      type: Number,
      default: 3000
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: {
    classObj: function classObj() {
      var placement = this.placement,
          type = this.type;
      var classes = {};
      classes['va-toast'] = true;
      classes['va-toast-' + type] = true;
      classes['va-toast-' + placement] = true;
      return classes;
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (this.closeOnClick) {
        this.show = false;
      }
    }
  },
  watch: {
    show: {
      handler: function handler(val) {
        var _this = this;

        this.setT = window.clearTimeout(this.setT);

        if (val) {
          this.$nextTick(function () {
            // recompute position
            if (_this.placement === 'top' || _this.placement === 'bottom') {
              _this.$refs.dom.style.marginLeft = -1 * _this.$refs.dom.offsetWidth / 2 + 'px';
            } else if (_this.placement === 'center') {
              _this.$refs.dom.style.marginLeft = -1 * _this.$refs.dom.offsetWidth / 2 + 'px';
              _this.$refs.dom.style.marginTop = -1 * _this.$refs.dom.offsetHeight / 2 + 'px';
            }
          });
        }
      },
      immediate: true
    }
  }
});
// CONCATENATED MODULE: ./src/Toast/VaToast.vue?vue&type=script&lang=js&
 /* harmony default export */ var Toast_VaToastvue_type_script_lang_js_ = (VaToastvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Toast/VaToast.vue?vue&type=style&index=0&lang=scss&
var VaToastvue_type_style_index_0_lang_scss_ = __webpack_require__("06f9");

// CONCATENATED MODULE: ./src/Toast/VaToast.vue






/* normalize component */

var VaToast_component = normalizeComponent(
  Toast_VaToastvue_type_script_lang_js_,
  VaToastvue_type_template_id_9d6fcda8_render,
  VaToastvue_type_template_id_9d6fcda8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaToast = (VaToast_component.exports);
// CONCATENATED MODULE: ./src/Toast/VaToastMethod.js





var VaToastMethod_VaToast = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend(VaToast);
/* harmony default export */ var VaToastMethod = (function (obj) {
  var domNode = document.createElement('div');
  document.body.appendChild(domNode);
  var options = {
    el: domNode,
    propsData: {}
  };
  var allowedProps = ['text', 'placement', 'type', 'duration', 'closeOnClick'];
  allowedProps.forEach(function (prop) {
    if (Object.keys(obj).includes(prop)) {
      options.propsData[prop] = obj[prop];
    }
  });
  var instance = new VaToastMethod_VaToast(options);
  instance.show = true;

  if (instance.duration > 0) {
    setTimeout(function () {
      instance.show = false;
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick(function () {
        instance.$destroy();
      });
    }, instance.duration);
  }
});
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js









function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupLevel.vue?vue&type=template&id=26cbee68&
var VaSidebarGroupLevelvue_type_template_id_26cbee68_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_c('div',{class:"va-sidebar-navigationlevel-parent"},[_c('div',{class:"va-sidebar-group-item"},[(_vm.st)?_c('va-sidebar-group-toggle',{attrs:{"open":_vm.isOpen},nativeOn:{"click":function($event){return _vm.onToggleClick($event)}}}):_vm._e(),_c('va-sidebar-group-item',{attrs:{"item":_vm.parentItem,"is-open":_vm.isOpen,"show-toggle":_vm.st},nativeOn:{"click":function($event){return _vm.onItemClick($event)}}})],1)]),_c('ul',{class:"va-sidebar-navigationlevel-children"},[_vm._t("default")],2)])}
var VaSidebarGroupLevelvue_type_template_id_26cbee68_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupLevel.vue?vue&type=template&id=26cbee68&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupLevel.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaSidebarGroupLevelvue_type_script_lang_js_ = ({
  name: 'VaSidebarGroupLevel',
  props: {
    parentItem: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      required: true
    },
    open: {
      type: Boolean,
      required: false,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    toggleType: {
      type: String,
      required: false,
      validator: function validator(v) {
        return ['arrow', 'circle'].includes(v);
      }
    }
  },
  data: function data() {
    var s = this.showToggle;
    return {
      st: s,
      isOpen: this.open
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@showToggleChange', function (val) {
      _this.st = val;
    });
  },
  computed: {
    classObj: function classObj() {
      var isOpen = this.isOpen,
          level = this.level;
      var classes = {};
      classes['va-sidebar-navigationlevel'] = true;
      classes['va-sidebar-navigationlevel-closed'] = !isOpen;
      classes['va-sidebar-navigationlevel-open'] = isOpen;
      classes['va-sidebar-navigationlevel-level-' + level] = true;
      return classes;
    }
  },
  methods: {
    onToggleClick: function onToggleClick() {
      this.isOpen = !this.isOpen;
    },
    onItemClick: function onItemClick() {
      if (this.isOpen === false) {
        this.isOpen = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupLevel.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarGroupLevelvue_type_script_lang_js_ = (VaSidebarGroupLevelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupLevel.vue





/* normalize component */

var VaSidebarGroupLevel_component = normalizeComponent(
  Sidebar_VaSidebarGroupLevelvue_type_script_lang_js_,
  VaSidebarGroupLevelvue_type_template_id_26cbee68_render,
  VaSidebarGroupLevelvue_type_template_id_26cbee68_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebarGroupLevel = (VaSidebarGroupLevel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupItem.vue?vue&type=template&id=f5163ea2&
var VaSidebarGroupItemvue_type_template_id_f5163ea2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({ref:"itemText",class:_vm.classObj},_vm.itemMethod),[(_vm.st && _vm.toggleType === 'circle')?_c('span',{class:"va-sidebar-group-item-text-icon"},[_c('va-icon',{attrs:{"type":"circle"}})],1):_vm._e(),_c('span',{class:"va-sidebar-group-item-text"},[(_vm.showIcon)?_c('span',{class:"va-sidebar-group-item-icon"},[(_vm.item.iconColor)?_c('va-icon',{attrs:{"type":_vm.item.icon,"color":_vm.item.iconColor,"size":_vm.item.iconSize,"icon-style":_vm.item.iconStyle}}):_c('va-icon',{attrs:{"type":_vm.item.icon,"size":_vm.item.iconSize,"icon-style":_vm.item.iconStyle}})],1):_vm._e(),(_vm.showLabel)?_c('span',{class:"va-sidebar-group-item-label",style:(_vm.styleObj)},[_vm._v(" "+_vm._s(_vm.item.name)+" "),(_vm.item.sub)?_c('span',{class:"va-sidebar-group-item-substring"},[_vm._v(_vm._s(_vm.item.sub))]):_vm._e()]):_vm._e(),(_vm.showRouterLink)?_c('router-link',{class:"va-sidebar-group-item-router-link",style:(_vm.styleObj),attrs:{"to":_vm.item.meta.target}},[_vm._v(" "+_vm._s(_vm.item.name)+" "),(_vm.item.sub)?_c('span',{class:"va-sidebar-group-item-substring"},[_vm._v(_vm._s(_vm.item.sub))]):_vm._e()]):_vm._e(),(_vm.showHyperLink)?_c('a',{class:"va-sidebar-group-item-link",style:(_vm.styleObj),attrs:{"href":_vm.item.meta.target}},[_vm._v(" "+_vm._s(_vm.item.name)+" "),(_vm.item.sub)?_c('span',{class:"va-sidebar-group-item-substring"},[_vm._v(_vm._s(_vm.item.sub))]):_vm._e()]):_vm._e(),(_vm.showExternalHyperLink)?_c('a',{class:"va-sidebar-group-item-external-link",style:(_vm.styleObj),attrs:{"href":_vm.item.meta.target,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.item.name)+" "),(_vm.item.sub)?_c('span',{class:"va-sidebar-group-item-substring"},[_vm._v(_vm._s(_vm.item.sub))]):_vm._e()]):_vm._e(),(_vm.item.lozenge)?_c('span',{staticStyle:{"display":"flex"}},[_c('va-lozenge',{attrs:{"bold":_vm.item.lozenge.bold,"uppercase":"","type":_vm.item.lozenge.type}},[_vm._v(_vm._s(_vm.item.lozenge.text))])],1):_vm._e()],1)])}
var VaSidebarGroupItemvue_type_template_id_f5163ea2_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupItem.vue?vue&type=template&id=f5163ea2&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupItem.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var stripTrailingSlash = function stripTrailingSlash(str) {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

/* harmony default export */ var VaSidebarGroupItemvue_type_script_lang_js_ = ({
  name: 'VaSidebarGroupItem',
  props: {
    item: {
      type: Object
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    toggleType: {
      type: String,
      required: false
    }
  },
  data: function data() {
    var s = this.showToggle;
    return {
      st: s,
      minified: false
    };
  },
  created: function created() {
    var _this = this;

    this.$on('Va@showToggleChange', function (val) {
      _this.st = val;
    });
  },
  computed: {
    itemHasMethod: function itemHasMethod() {
      return this.item.method !== undefined;
    },
    itemMethod: function itemMethod() {
      if (this.itemHasMethod) {
        return {
          click: this.item.method
        };
      }

      return false;
    },
    showIcon: function showIcon() {
      return this.item.icon !== undefined;
    },
    showLabel: function showLabel() {
      return this.item.route === undefined && this.item.element === undefined && this.item.external === undefined;
    },
    showLink: function showLink() {
      return this.item.route !== undefined || this.item.element !== undefined;
    },
    showHyperLink: function showHyperLink() {
      return this.showLink && this.$router === undefined;
    },
    showExternalHyperLink: function showExternalHyperLink() {
      return this.item.external !== undefined;
    },
    showRouterLink: function showRouterLink() {
      return this.showLink && this.$router !== undefined;
    },
    classObj: function classObj() {
      var minified = this.minified;
      var classes = {};
      classes['va-sidebar-group-item-text'] = true;
      classes['va-sidebar-group-item-minified'] = minified;
      return classes;
    },
    styleObj: function styleObj() {
      var showIcon = this.showIcon;
      var style = {};
      style['padding-left'] = showIcon ? '0px' : '0px';
      return style;
    }
  },
  methods: {
    setAsActiveIfActive: function setAsActiveIfActive() {
      var parentElement = this.$refs.itemText.parentElement;

      if (parentElement.classList) {
        if (parentElement.classList.contains('active')) {
          parentElement.classList.remove('active');
        }
      }

      if (this.item.route !== undefined) {
        if (this.$route !== undefined && this.$route.path !== undefined) {
          if (this.item.route === this.$route.path) {
            if (parentElement.classList) {
              parentElement.classList.add('active');
            }
          }
        } else {
          if (stripTrailingSlash(this.item.route) === stripTrailingSlash(window.location.pathname)) {
            if (parentElement.classList) {
              parentElement.classList.add('active');
            }
          }
        }
      }
    }
  },
  watch: {
    item: function item() {},
    $route: function $route() {
      this.setAsActiveIfActive();
    }
  },
  mounted: function mounted() {
    if (!this.$router) {
      window.addEventListener('hashchange', function () {// todo
      });
    }

    this.setAsActiveIfActive();
  }
});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarGroupItemvue_type_script_lang_js_ = (VaSidebarGroupItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupItem.vue





/* normalize component */

var VaSidebarGroupItem_component = normalizeComponent(
  Sidebar_VaSidebarGroupItemvue_type_script_lang_js_,
  VaSidebarGroupItemvue_type_template_id_f5163ea2_render,
  VaSidebarGroupItemvue_type_template_id_f5163ea2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebarGroupItem = (VaSidebarGroupItem_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.last-index-of.js
var es_array_last_index_of = __webpack_require__("baa5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./src/Sidebar/utils.js






/**
 * Original implementation by MisRob and released under the MIT license.
 * https://github.com/MisRob/vue-tree-navigation
 * Modified for use with vue-atlas
 *
 * Remove a domain and router's `/#` from URL.
 */
var getRelativeUrl = function getRelativeUrl(url, origin) {
  var relativeUrl = url.replace('/#/', '/');

  if (origin[origin.length - 1] === '/') {
    origin = origin.slice(0, -1);
  }

  relativeUrl = relativeUrl.replace(origin, '');
  return sanitizeRoute(relativeUrl);
};
/**
 * Remove an element appended to the end of a path.
 */

var removeElementFromPath = function removeElementFromPath(path) {
  var hashPos;

  while (hashPos !== -1) {
    hashPos = path.lastIndexOf('#');

    if (hashPos === -1) {
      return path;
    } // do not cut of router url


    if (hashPos === path.indexOf('#/')) {
      return path;
    }

    path = path.slice(0, hashPos);
  }
};
/**
 * First character should be #.
 */

var sanitizeElement = function sanitizeElement(element) {
  if (element === undefined || element === '') {
    return element;
  }

  if (element[0] !== '#') {
    element = '#' + element;
  }

  return element;
};
/**
 * First character should be backslash.
 * Last character shouldn't be backslash.
 */

var sanitizeRoute = function sanitizeRoute(route) {
  if (route === undefined) {
    return;
  }

  if (route[0] !== '/') {
    route = '/' + route;
  }

  if (route[route.length - 1] === '/') {
    route = route.slice(0, -1);
  }

  return route;
};
/**
 * Check if a parent URL starts with another URL.
 * Ignore elements.
 */

var startsWithUrl = function startsWithUrl(parentUrl, url) {
  if (!url.startsWith('/#')) {
    url = removeElementFromPath(url);
  }

  if (parentUrl.startsWith(url)) {
    return true;
  }

  return false;
};
// CONCATENATED MODULE: ./src/Sidebar/core.js



/**
 * Original implementation by MisRob and released under the MIT license.
 * https://github.com/MisRob/vue-tree-navigation
 * Modified for use with vue-atlas
 */



/**
 * Recursive function.
 * One call generates one level of the tree.
 */

var core_generateLevel = function generateLevel(createElement, items, level, defaultOpenLevel, showToggle) {
  var children = [];

  if (items !== undefined && items !== false) {
    items.forEach(function (item) {
      if (item.hasOwnProperty('children')) {
        var navLevel = createElement(VaSidebarGroupLevel, {
          props: {
            parentItem: item,
            level: level,
            open: core_renderLevelAsOpen(item, level, defaultOpenLevel),
            showToggle: showToggle
          }
        }, _toConsumableArray(generateLevel(createElement, item.children, level + 1, defaultOpenLevel, showToggle)));
        children.push(createElement('li', [navLevel]));
      } else {
        var navItem = createElement(VaSidebarGroupItem, {
          props: {
            item: item,
            showToggle: showToggle,
            toggleType: 'circle'
          }
        });
        children.push(createElement('li', {
          class: 'va-sidebar-group-item'
        }, [navItem]));
      }
    });
  }

  return children;
};
/**
 * Level should be opened in following cases
 * - level is less than or equal to default open level
 * - its URL is a part of an active URL
 * - it contains a child which URL is a part of an active URL
 */

var core_renderLevelAsOpen = function renderLevelAsOpen(parentItem, level, defaultOpenLevel) {
  if (defaultOpenLevel >= level) {
    return true;
  }

  var currentUrl = getRelativeUrl(window.location.href, window.location.origin);

  if (parentItem.meta.target !== '' && startsWithUrl(currentUrl, parentItem.meta.target) === true) {
    return true;
  }

  for (var i = 0; i < parentItem.children.length; i++) {
    var child = parentItem.children[i];

    if (child.meta.target !== '' && startsWithUrl(currentUrl, child.meta.target) === true) {
      return true;
    }
  }

  return false;
};
/**
 * Recursive function.
 * Insert metadata containing the navigation path and its type to each item.
 **/

var insertMetadataToItems = function insertMetadataToItems(items, parent) {
  if (items !== undefined && items !== false) {
    items.forEach(function (item) {
      item.meta = core_getItemMetadata(item, parent);

      if (item.hasOwnProperty('children')) {
        item.children = insertMetadataToItems(item.children, item);
      }
    });
    return items;
  }

  return false;
};
/**
 * Return item metadata object: { path: ..., target: ... }
 */

var core_getItemMetadata = function getItemMetadata(item, parent) {
  // const element = sanitizeElement(item.element)
  // const route = sanitizeRoute(item.route)
  var element = item.element;
  var route = item.route;
  var external = item.external;
  var icon = item.icon || false;
  var method = item.method || false;
  var iconColor = item.iconColor || false;
  var iconSize = item.iconSize || '1em';
  var iconStyle = item.iconStyle || 'solid'; // item is its own parent

  if (parent === undefined) {
    if (element === undefined && route === undefined && external === undefined) {
      return {
        path: '',
        target: ''
      };
    }

    if (external !== undefined) {
      return {
        path: '',
        target: external
      };
    }

    if (route !== undefined) {
      return {
        path: route,
        target: route
      };
    }

    if (element !== undefined) {
      return {
        path: '',
        target: '/' + element
      };
    }
  }

  var parentPath = sanitizeRoute(parent.meta.path);

  if (external !== undefined) {
    return {
      icon: icon,
      iconColor: iconColor,
      iconSize: iconSize,
      iconStyle: iconStyle,
      method: method,
      path: parentPath,
      target: external
    };
  }

  if (route !== undefined) {
    return {
      icon: icon,
      iconColor: iconColor,
      iconSize: iconSize,
      iconStyle: iconStyle,
      method: method,
      path: route,
      target: route
    };
  }

  if (element !== undefined) {
    return {
      icon: icon,
      iconColor: iconColor,
      iconSize: iconSize,
      iconStyle: iconStyle,
      method: method,
      path: parentPath,
      target: sanitizeRoute(parentPath + element)
    };
  }

  return {
    icon: icon,
    iconColor: iconColor,
    iconSize: iconSize,
    iconStyle: iconStyle,
    method: method,
    path: parentPath,
    target: ''
  };
};
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroup.js


/**
 * Original implementation by MisRob and released under the MIT license.
 * https://github.com/MisRob/vue-tree-navigation
 * Modified for use with vue-atlas
 */


var VaSidebarGroup = {
  mixins: [events],
  props: {
    items: {
      type: Array,
      required: false
    },
    defaultOpenLevel: {
      type: Number,
      default: 0
    },
    showToggle: {
      type: Boolean,
      default: false,
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    itemsWithMetadata: function itemsWithMetadata() {
      var self = this;

      if (self.items !== undefined) {
        return insertMetadataToItems(self.items);
      }

      return false;
    }
  },
  watch: {
    showToggle: function showToggle(val) {
      this.dispatch('VaApp', 'Va@configShowToggleChange', val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.dispatch('VaApp', 'Va@configShowToggleChange', _this.showToggle);
    }, 10);
  },
  render: function render(createElement) {
    var title = this.title;
    var self = this;
    var level = 1;
    var tree = createElement('ul', core_generateLevel(createElement, self.itemsWithMetadata, level, self.defaultOpenLevel, self.showToggle));
    var level0 = createElement('div', {
      class: ['va-sidebar-navigationlevel', 'va-sidebar-navigationlevel-level-0']
    }, [tree]);
    var treeNavigation = createElement('div', {
      class: 'va-sidebar-treenavigation'
    }, [level0]);
    var contentSlot = createElement('div', this.$slots.default);
    var headerItem = createElement('div', {
      class: 'va-sidebar-group-title'
    }, [createElement('span', title)]);
    var entireGroup = createElement('div', {}, [headerItem, contentSlot, treeNavigation]);
    return entireGroup;
  }
};
/* harmony default export */ var Sidebar_VaSidebarGroup = (VaSidebarGroup);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AnimQueue/VaAnimQueue.vue?vue&type=template&id=0e427c3e&
var VaAnimQueuevue_type_template_id_0e427c3e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tag === 'div')?_c('div',[_vm._t("default")],2):_vm._e(),(_vm.tag === 'ul')?_c('ul',[_vm._t("default")],2):_vm._e(),(_vm.tag === 'ol')?_c('ol',[_vm._t("default")],2):_vm._e(),(_vm.tag === 'form')?_c('form',[_vm._t("default")],2):_vm._e()])}
var VaAnimQueuevue_type_template_id_0e427c3e_staticRenderFns = []


// CONCATENATED MODULE: ./src/AnimQueue/VaAnimQueue.vue?vue&type=template&id=0e427c3e&

// CONCATENATED MODULE: ./src/AnimQueue/animTypes.js
/* harmony default export */ var animTypes = ({
  left: {
    opacity: [1, 0],
    translateX: [0, -30]
  },
  top: {
    opacity: [1, 0],
    translateY: [0, -30]
  },
  right: {
    opacity: [1, 0],
    translateX: [0, 30]
  },
  bottom: {
    opacity: [1, 0],
    translateY: [0, 30]
  },
  alpha: {
    opacity: [1, 0]
  },
  scale: {
    opacity: [1, 0],
    scale: [1, 0]
  },
  scaleBig: {
    opacity: [1, 0],
    scale: [1, 2]
  },
  scaleX: {
    opacity: [1, 0],
    scaleX: [1, 0]
  },
  scaleY: {
    opacity: [1, 0],
    scaleY: [1, 0]
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AnimQueue/VaAnimQueue.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BackEase = {
  easeInBack: [0.6, -0.28, 0.735, 0.045],
  easeOutBack: [0.175, 0.885, 0.32, 1.275],
  easeInOutBack: [0.68, -0.55, 0.265, 1.55]
};

function transformArguments(arg) {
  if (Array.isArray(arg) && arg.length === 2) {
    return arg;
  }

  return [arg, arg];
}

/* harmony default export */ var VaAnimQueuevue_type_script_lang_js_ = ({
  name: 'VaAnimQueue',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: false
    },
    tag: {
      type: String,
      default: 'div',
      validator: function validator(v) {
        return ['div', 'form', 'ul', 'ol'].includes(v);
      },
      required: false
    },
    interval: {
      type: [Number, Array],
      default: 100,
      required: false
    },
    duration: {
      type: [Number, Array, String],
      default: 500,
      required: false
    },
    delay: {
      type: [Number, Array, String],
      default: 0,
      required: false
    },
    type: {
      type: [String, Array],
      default: 'right',
      required: false
    },
    animConfig: {
      type: [String, Array],
      required: false
    },
    ease: {
      type: [String, Array],
      default: 'easeOutQuart',
      required: false
    },
    watchValue: {
      type: [String, Array],
      required: false
    },
    leaveReverse: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      animatingClassName: [],
      originChildren: [],
      children: [],
      childrenShow: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.animatingClassName = ['va-anim-queue-entering', 'va-anim-queue-leaving']; // this.$nextTick(() => {

    this.keysAnimating = [];

    var freeChild = this._getFreeKeysAndChild();

    this.keysAnimating = Object.keys(freeChild);
    this.children = freeChild;
    this.originChildren = freeChild;
    this.$on('VaAnimQueueHidden', function () {
      _this._hiddenVelocityNode();

      return true;
    });

    if (this.show) {
      this._animateEnter();
    } // })

  },
  beforeDestroy: function beforeDestroy() {
    if (this.originChildren && this.originChildren.length > 0) {
      this.originChildren.forEach(function (child) {
        external_velocity_animate_default()(child, 'stop');
      });
    }
  },
  computed: {
    usedSlot: function usedSlot() {
      switch (this.tag) {
        case 'div':
          return this.$slots.divslot;

        case 'ul':
          return this.$slots.ulslot;

        case 'ol':
          return this.$slots.olslot;

        case 'form':
          return this.$slots.formslot;

        default:
          return false;
      }
    }
  },
  isActHideAnimate: false,
  watch: {
    show: function show(value) {
      var _this2 = this;

      if (value) {
        this.isActHideAnimate = true;
        this.$nextTick(function () {
          _this2.$emit('VaAnimQueueHidden');

          setTimeout(function () {
            _this2._animateEnter();

            _this2.isActHideAnimate = false;
          }, 50);
        });
      } else {
        this._animateLeave(function () {
          if (!_this2.isActHideAnimate) {
            _this2.$emit('VaAnimQueueHidden');
          }
        });
      }
    },
    // watchValue (newValue, oldValue) {
    watchValue: function watchValue() {
      var _this3 = this;

      this.$nextTick(function () {
        var shouldEnterChild = [];
        var shouldLeaveChild = [];

        var newChild = _this3._getKeysChild(); // const nodeMap = {}


        for (var i = 0; i < _this3.children.length; i++) {
          var curChild = _this3.children[i];
          var hasRemove = true;

          for (var j = 0; j < newChild.length; j++) {
            if (curChild.key === newChild[j].key) {
              hasRemove = false;
            }
          }

          if (hasRemove) {
            shouldLeaveChild.push(curChild);
          }
        }

        for (var _i = 0; _i < newChild.length; _i++) {
          var _curChild = newChild[_i];
          var hasAdd = true;

          for (var _j = 0; _j < _this3.children.length; _j++) {
            if (_curChild.key === _this3.children[_j].key) {
              hasAdd = false;
            }
          }

          if (hasAdd) {
            shouldEnterChild.push(_curChild);
          }
        }

        shouldEnterChild.forEach(_this3._performEnter);
        shouldLeaveChild.forEach(_this3._performLeave);
        _this3.children = newChild;
      });
    }
  },
  methods: {
    _getKeysChild: function _getKeysChild() {
      var ret = [];
      var keyNodes = Array.prototype.slice.call(this.$el.querySelectorAll('[anim-key]'));
      keyNodes.forEach(function (child) {
        if (!child) {
          return;
        }

        child.setAttribute('__scope_key__', 1);
        var key = child.getAttribute('anim-key');

        if (!key) {
          return;
        }

        ret.push({
          key: key,
          el: child
        });
      });
      return ret;
    },
    _getFreeKeysAndChild: function _getFreeKeysAndChild() {
      var ret = [];
      var keyNodes = Array.prototype.slice.call(this.$el.querySelectorAll('[anim-key]:not([__scope_key__])'));
      keyNodes.forEach(function (child) {
        if (!child) {
          return;
        }

        child.setAttribute('__scope_key__', 1);
        var key = child.getAttribute('anim-key');

        if (!key) {
          return;
        }

        ret.push({
          key: key,
          el: child
        });
      });
      return ret;
    },
    _getVelocityConfig: function _getVelocityConfig(index) {
      if (this.animConfig) {
        return transformArguments(this.animConfig)[index];
      }

      return animTypes[transformArguments(this.type)[index]];
    },
    _getVelocityEnterConfig: function _getVelocityEnterConfig() {
      return this._getVelocityConfig(0);
    },
    _getVelocityLeaveConfig: function _getVelocityLeaveConfig() {
      var config = this._getVelocityConfig(1);

      var ret = {};
      Object.keys(config).forEach(function (key) {
        if (Array.isArray(config[key])) {
          ret[key] = Array.prototype.slice.call(config[key]).reverse();
        } else {
          ret[key] = config[key];
        }
      });
      return ret;
    },
    _getVelocityEasing: function _getVelocityEasing() {
      return transformArguments(this.ease).map(function (easeName) {
        if (typeof easeName === 'string') {
          return BackEase[easeName] || easeName;
        }
      });
    },
    _hiddenVelocityNode: function _hiddenVelocityNode() {
      this.children.forEach(function (item) {
        var node = item.el;

        if (!node) {
          return;
        }

        node.style.visibility = 'hidden';
        external_velocity_animate_default()(node, 'stop');
      });
    },
    _animateEnter: function _animateEnter() {
      this.children.forEach(this._performEnter);
    },
    _performEnter: function _performEnter(item, i) {
      var _this4 = this;

      var node = item.el;
      var key = item.key;

      if (!node) {
        return;
      }

      var interval = parseInt(transformArguments(this.interval)[0]);
      var delay = parseInt(transformArguments(this.delay)[0]);
      var duration = parseInt(transformArguments(this.duration)[0]);
      node.style.visibility = 'hidden';
      external_velocity_animate_default()(node, 'stop');
      external_velocity_animate_default()(node, this._getVelocityEnterConfig('enter'), {
        delay: interval * i * delay / 100,
        duration: duration,
        easing: this._getVelocityEasing()[0],
        visibility: 'visible',
        begin: function begin(elements) {
          _this4._enterBegin(key, elements);

          if (node.__vue__) {
            var _enterFn = node.__vue__._animateEnter;
            _enterFn && _enterFn();
            var children = node.__vue__.$children;
            children.forEach(function (item) {
              item._animateEnter && item._animateEnter();
            });
          }
        },
        complete: this._enterComplete.bind(this, key)
      });
    },
    _animateLeave: function _animateLeave(done) {
      var _this5 = this;

      this.children.forEach(function (item, i) {
        _this5._performLeave(item, i, done);
      });
    },
    _performLeave: function _performLeave(item, i, done) {
      var _this6 = this;

      var node = item.el;
      var key = item.key;

      if (!node) {
        return;
      }

      var interval = parseInt(transformArguments(this.interval)[1]);
      var delay = parseInt(transformArguments(this.delay)[1]);
      var duration = parseInt(transformArguments(this.duration)[1]);
      var order = this.leaveReverse ? this.children.length - i - 1 : i;
      external_velocity_animate_default()(node, 'stop');
      external_velocity_animate_default()(node, this._getVelocityLeaveConfig('leave'), {
        delay: interval * order + delay,
        duration: duration,
        easing: this._getVelocityEasing()[1],
        begin: this._leaveBegin.bind(this),
        complete: function complete(elements) {
          _this6._leaveComplete(key, elements);

          var len = _this6.children.length;

          if (i === len - 1) {
            done && done();
          }
        }
      });
    },
    _enterBegin: function _enterBegin(key, elements) {
      var self = this;

      if (this.keysAnimating.indexOf(key) >= 0) {
        this.keysAnimating.splice(this.keysAnimating.indexOf(key), 1);
      }

      elements.forEach(function (elem) {
        elem.className = elem.className.replace(self.animatingClassName[1], '').trim();
        elem.className += ' ' + self.animatingClassName[0];
      });
    },
    _enterComplete: function _enterComplete(key, elements) {
      var self = this;

      if (this.keysAnimating.indexOf(key) >= 0) {
        this.keysAnimating.splice(this.keysAnimating.indexOf(key), 1);
      }

      elements.forEach(function (elem) {
        elem.className = elem.className.replace(self.animatingClassName[0], '').trim();
      });
    },
    _leaveBegin: function _leaveBegin(elements) {
      var self = this;
      elements.forEach(function (elem) {
        elem.className = elem.className.replace(self.animatingClassName[0], '').trim();
        elem.className += ' ' + self.animatingClassName[1];
      });
    },
    _leaveComplete: function _leaveComplete(key, elements) {
      var self = this;

      if (this.keysAnimating.indexOf(key) < 0) {
        return;
      }

      this.keysAnimating.splice(this.keysAnimating.indexOf(key), 1);
      elements.forEach(function (elem) {
        elem.className = elem.className.replace(self.animatingClassName[1], '').trim();
      });
    }
  }
});
// CONCATENATED MODULE: ./src/AnimQueue/VaAnimQueue.vue?vue&type=script&lang=js&
 /* harmony default export */ var AnimQueue_VaAnimQueuevue_type_script_lang_js_ = (VaAnimQueuevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/AnimQueue/VaAnimQueue.vue





/* normalize component */

var VaAnimQueue_component = normalizeComponent(
  AnimQueue_VaAnimQueuevue_type_script_lang_js_,
  VaAnimQueuevue_type_template_id_0e427c3e_render,
  VaAnimQueuevue_type_template_id_0e427c3e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaAnimQueue = (VaAnimQueue_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Typeahead/VaTypeahead.vue?vue&type=template&id=fd64050c&
var VaTypeaheadvue_type_template_id_fd64050c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['va-dropdown-con'],style:(_vm.styleObj)},[_c('va-input',_vm._b({ref:"input",attrs:{"custom-validate":_vm.customValidate,"disabled":_vm.disabled,"icon":_vm.icon,"icon-style":_vm.iconStyle,"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"rules":_vm.rules,"clearable":_vm.clearable,"width":_vm.width,"no-v-model":""},on:{"blur":_vm.blur,"focus":_vm.focus},nativeOn:{"input":function($event){return _vm.update($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.down($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.hit($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onReset($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.up($event)}]},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},'va-input',_vm.$attrs,false)),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"},{name:"va-position",rawName:"v-va-position",value:(_vm.show),expression:"show"}],class:"va-dropdown-menu",style:({minWidth: _vm.actualWidth, maxHeight: _vm.dropdownHeight})},_vm._l((_vm.citems),function(item,index){return _c('li',{key:index,class:_vm.isActive(index)},[_c('a',{on:{"mousedown":function($event){$event.preventDefault();return _vm.hit(index)}}},[_c('div',{staticClass:"inline"},[_vm._t("item",[_vm._v(_vm._s(item))],{"item":item})],2)])])}),0)],1)}
var VaTypeaheadvue_type_template_id_fd64050c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Typeahead/VaTypeahead.vue?vue&type=template&id=fd64050c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Typeahead/VaTypeahead.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaTypeaheadvue_type_script_lang_js_ = ({
  name: 'VaTypeahead',
  mixins: [inputMixin],
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    data: {
      type: Array
    },
    context: {},
    icon: {
      type: String,
      required: false
    },
    iconStyle: {
      type: String,
      default: 'regular',
      required: false
    },
    limit: {
      type: Number,
      default: 10
    },
    matchCase: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 400
    },
    addFormat: {
      type: Function,
      default: function _default(item) {
        return item;
      }
    },
    onHit: {
      type: Function,
      default: function _default(item) {
        this.reset();
        this.query = this.addFormat(item);
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dropdownWidth: {
      type: String,
      default: '100%'
    },
    dropdownHeight: {
      type: String,
      default: '300px'
    },
    async: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array
    }
  },
  watch: {
    citems: function citems(val) {
      this.show = val && !!val.length;
    },
    value: function value(val) {
      this.query = val;
    },
    query: function query(val) {
      this.$emit('input', val);

      if (val.value === '') {
        this.items = [];
      }
    }
  },
  data: function data() {
    return {
      show: false,
      noResults: true,
      current: 0,
      query: this.value,
      timeoutID: 0
    };
  },
  computed: {
    styleObj: function styleObj() {
      var style = {};
      var actualWidth = this.actualWidth;
      actualWidth.slice(-1) === '%' ? style['width'] = actualWidth : style['min-width'] = actualWidth;
      return style;
    },
    citems: function citems() {
      return this.items.slice(0, this.limit);
    },
    primitiveData: function primitiveData() {
      var _this = this;

      if (this.data && this.query) {
        return this.data.filter(function (value) {
          value = _this.matchCase ? value : value.toLowerCase();
          return value.indexOf(_this.query) !== -1;
        }).slice(0, this.limit);
      }

      return false;
    }
  },
  methods: {
    focusInput: function focusInput() {
      this.$refs.input.focus();
    },
    focus: function focus() {
      this.$emit('focus');
    },
    blur: function blur() {
      this.show = false;
      this.$emit('blur');
    },
    update: function update() {
      clearTimeout(this.timeoutID);
      var self = this;
      if (this.readonly || this.disabled) return;
      this.timeoutID = setTimeout(function () {
        if (!self.query) {
          self.reset();
          return false;
        }

        if (self.async) {
          self.$emit('change', self.query);
        }
      }, this.debounce);
    },
    reset: function reset() {
      this.query = '';
      this.loading = false;
      this.show = false;
    },
    isActive: function isActive(index) {
      var classes = 'va-dropdown-active';
      return this.current === index ? classes : '';
    },
    hit: function hit(index) {
      if (this.citems && this.citems.length) {
        this.onHit(this.citems[index], this);
      }
    },
    up: function up() {
      if (this.current > 0) this.current--;
    },
    down: function down() {
      if (this.current < this.citems.length - 1) this.current++;
    }
  }
});
// CONCATENATED MODULE: ./src/Typeahead/VaTypeahead.vue?vue&type=script&lang=js&
 /* harmony default export */ var Typeahead_VaTypeaheadvue_type_script_lang_js_ = (VaTypeaheadvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Typeahead/VaTypeahead.vue





/* normalize component */

var VaTypeahead_component = normalizeComponent(
  Typeahead_VaTypeaheadvue_type_script_lang_js_,
  VaTypeaheadvue_type_template_id_fd64050c_render,
  VaTypeaheadvue_type_template_id_fd64050c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaTypeahead = (VaTypeahead_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Button/VaButtonGroup.vue?vue&type=template&id=18d9cd4c&
var VaButtonGroupvue_type_template_id_18d9cd4c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default")],2)}
var VaButtonGroupvue_type_template_id_18d9cd4c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Button/VaButtonGroup.vue?vue&type=template&id=18d9cd4c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Button/VaButtonGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var VaButtonGroupvue_type_script_lang_js_ = ({
  name: 'VaButtonGroup',
  props: {
    vertical: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    classObj: function classObj() {
      var vertical = this.vertical;
      var classes = {};
      classes['va-btn-group'] = true;
      classes['va-btn-group-vertical'] = vertical;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Button/VaButtonGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var Button_VaButtonGroupvue_type_script_lang_js_ = (VaButtonGroupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Button/VaButtonGroup.vue





/* normalize component */

var VaButtonGroup_component = normalizeComponent(
  Button_VaButtonGroupvue_type_script_lang_js_,
  VaButtonGroupvue_type_template_id_18d9cd4c_render,
  VaButtonGroupvue_type_template_id_18d9cd4c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaButtonGroup = (VaButtonGroup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Minibar/VaMinibarItem.vue?vue&type=template&id=2c82ccc6&
var VaMinibarItemvue_type_template_id_2c82ccc6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tooltip)?_c('va-tooltip',{attrs:{"content":_vm.tooltip,"placement":"right","trigger":"hover","effect":"tooltip-fade-right","arrow":""}},[_c('div',{class:_vm.classObj},[_vm._t("default")],2)]):_c('div',{class:_vm.classObj},[_vm._t("default")],2)],1)}
var VaMinibarItemvue_type_template_id_2c82ccc6_staticRenderFns = []


// CONCATENATED MODULE: ./src/Minibar/VaMinibarItem.vue?vue&type=template&id=2c82ccc6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Minibar/VaMinibarItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaMinibarItemvue_type_script_lang_js_ = ({
  name: 'VaMinibarItem',
  props: {
    brand: {
      type: Boolean,
      default: false,
      required: false
    },
    tooltip: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    classObj: function classObj() {
      var brand = this.brand;
      var classes = {};
      classes['va-minibar-item'] = true;
      classes['va-minibar-item-brand'] = brand;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Minibar/VaMinibarItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var Minibar_VaMinibarItemvue_type_script_lang_js_ = (VaMinibarItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Minibar/VaMinibarItem.vue





/* normalize component */

var VaMinibarItem_component = normalizeComponent(
  Minibar_VaMinibarItemvue_type_script_lang_js_,
  VaMinibarItemvue_type_template_id_2c82ccc6_render,
  VaMinibarItemvue_type_template_id_2c82ccc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaMinibarItem = (VaMinibarItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Timepicker/VaTimepicker.vue?vue&type=template&id=ef57e8dc&
var VaTimepickervue_type_template_id_ef57e8dc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-timepicker"},[(!_vm.isMobile)?_c('va-input',{attrs:{"width":_vm.width,"name":_vm.name,"rules":_vm.rules,"placeholder":_vm.placeholder,"custom-validate":_vm.customValidate,"disabled":_vm.disabled,"readonly":_vm.readonly,"clearable":true,"icon":"clock","icon-style":"regular"},on:{"clean":_vm.clean},nativeOn:{"click":function($event){return _vm.inputClick($event)}},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}):_vm._e(),(_vm.isMobile)?_c('va-input',{attrs:{"width":_vm.width,"name":_vm.name,"rules":_vm.rules,"placeholder":_vm.placeholder,"custom-validate":_vm.customValidate,"disabled":_vm.disabled,"readonly":_vm.readonly,"clearable":true,"type":"time"},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}):_vm._e(),_c('transition',{attrs:{"name":"fadeDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"},{name:"va-position",rawName:"v-va-position",value:(_vm.show),expression:"show"}],class:"va-timepicker-popup"},[(_vm.hour)?_c('div',{class:"va-timepicker-range-wrap",attrs:{"data-role":"hour"}},[_c('span',[_vm._v(_vm._s(_vm.getL('hour')))]),_c('va-range',{class:"va-timepicker-range",attrs:{"width":190,"min":_vm.hourRange[0],"max":_vm.hourRange[1]},model:{value:(_vm.time.hour),callback:function ($$v) {_vm.$set(_vm.time, "hour", $$v)},expression:"time.hour"}})],1):_vm._e(),(_vm.minute)?_c('div',{class:"va-timepicker-range-wrap",attrs:{"data-role":"minute"}},[_c('span',[_vm._v(_vm._s(_vm.getL('minute')))]),_c('va-range',{class:"va-timepicker-range",attrs:{"width":190,"min":_vm.minuteRange[0],"max":_vm.minuteRange[1]},model:{value:(_vm.time.minute),callback:function ($$v) {_vm.$set(_vm.time, "minute", $$v)},expression:"time.minute"}})],1):_vm._e(),(_vm.second)?_c('div',{class:"va-timepicker-range-wrap",attrs:{"data-role":"second"}},[_c('span',[_vm._v(_vm._s(_vm.getL('second')))]),_c('va-range',{class:"va-timepicker-range",attrs:{"width":190,"min":_vm.secondRange[0],"max":_vm.secondRange[1]},model:{value:(_vm.time.second),callback:function ($$v) {_vm.$set(_vm.time, "second", $$v)},expression:"time.second"}})],1):_vm._e()])])],1)}
var VaTimepickervue_type_template_id_ef57e8dc_staticRenderFns = []


// CONCATENATED MODULE: ./src/Timepicker/VaTimepicker.vue?vue&type=template&id=ef57e8dc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Timepicker/VaTimepicker.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VaTimepickervue_type_script_lang_js_ = ({
  name: 'VaTimepicker',
  mixins: [inputMixin, localeMixin('VaTimepicker'), events],
  props: {
    value: {
      type: String
    },
    format: {
      type: String,
      default: 'hh:mm:ss',
      required: false
    },
    hourRange: {
      type: Array,
      default: function _default() {
        return [0, 23];
      }
    },
    minuteRange: {
      type: Array,
      default: function _default() {
        return [0, 59];
      }
    },
    secondRange: {
      type: Array,
      default: function _default() {
        return [0, 59];
      }
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      isMobile: false,
      show: false,
      time: {
        hour: 0,
        minute: 0,
        second: 0
      },
      currentValue: this.value
    };
  },
  watch: {
    show: function show(val) {
      if (!val) this.$emit('hide', this.currentValue);
    },
    value: function value(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    time: {
      deep: true,
      handler: function handler() {
        var ret = '';
        this.time.hour > this.hourRange[1] ? this.time.hour = this.hourRange[1] : 0;
        this.time.minute > this.minuteRange[1] ? this.time.minute = this.minuteRange[1] : 0;
        this.time.second > this.secondRange[1] ? this.time.second = this.secondRange[1] : 0;
        this.time.hour < this.hourRange[0] ? this.time.hour = this.hourRange[0] : 0;
        this.time.minute < this.minuteRange[0] ? this.time.minute = this.minuteRange[0] : 0;
        this.time.second < this.secondRange[0] ? this.time.second = this.secondRange[0] : 0;

        if (this.hour) {
          ret += this.fix(this.time.hour, 2) + ':';
        }

        if (this.minute) {
          ret += this.fix(this.time.minute, 2) + ':';
        }

        if (this.second) {
          ret += this.fix(this.time.second, 2) + ':';
        }

        ret = ret.substr(0, ret.length - 1);
        this.currentValue = ret;
      }
    }
  },
  methods: {
    clean: function clean() {
      var _this = this;

      this.time = {
        hour: 0,
        minute: 0,
        second: 0
      };
      this.$nextTick(function () {
        _this.currentValue = '';
      });
    },
    close: function close() {
      this.show = false;
    },
    inputClick: function inputClick() {
      if (this.disabled) return;
      this.show = !this.show;
    },
    fix: function fix(num, length) {
      num = parseInt(num);
      num = isNaN(num) ? 0 : num;
      return ('' + num).length < length ? (new Array(length + 1).join('0') + num).slice(-length) : '' + num;
    },
    _format: function _format(str) {
      if (str) {
        var a = str.split(':');

        if (this.hour) {
          this.time.hour = parseInt(a[0] ? a[0] : 0);
        }

        if (this.minute) {
          this.time.minute = parseInt(a[1] ? a[1] : 0);
        }

        if (this.second) {
          this.time.second = parseInt(a[2] ? a[2] : 0);
        }
      }
    }
  },
  computed: {
    hour: function hour() {
      return this.format.indexOf('hh') > -1;
    },
    minute: function minute() {
      return this.format.indexOf('mm') > -1;
    },
    second: function second() {
      return this.format.indexOf('ss') > -1;
    }
  },
  created: function created() {
    var _this2 = this;

    this._format(this.currentValue);

    this.$on('Va@timepickerIsMobile', function (val) {
      _this2.isMobile = val;
    });
    /**
     * In case this component is instantiated after the App
     * has initially broadcasted isMobile, let's request it.
     */

    this.dispatch('VaApp', 'Va@requestIsMobile', true);
  },
  mounted: function mounted() {
    var _this3 = this;

    this._closeEvent = utils_EventListener.listen(window, 'click', function (e) {
      if (!_this3.$el.contains(e.target)) _this3.close();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._closeEvent) this._closeEvent.remove();
  }
});
// CONCATENATED MODULE: ./src/Timepicker/VaTimepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var Timepicker_VaTimepickervue_type_script_lang_js_ = (VaTimepickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Timepicker/VaTimepicker.vue?vue&type=style&index=0&lang=scss&
var VaTimepickervue_type_style_index_0_lang_scss_ = __webpack_require__("9268");

// CONCATENATED MODULE: ./src/Timepicker/VaTimepicker.vue






/* normalize component */

var VaTimepicker_component = normalizeComponent(
  Timepicker_VaTimepickervue_type_script_lang_js_,
  VaTimepickervue_type_template_id_ef57e8dc_render,
  VaTimepickervue_type_template_id_ef57e8dc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Timepicker_VaTimepicker = (VaTimepicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Datepicker/VaDatepicker.vue?vue&type=template&id=09397717&
var VaDatepickervue_type_template_id_09397717_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-datepicker",style:(_vm.styleObj)},[(!_vm.mobileDatepicker)?_c('va-input',_vm._b({attrs:{"name":_vm.name,"rules":_vm.rules,"placeholder":_vm.placeholder,"custom-validate":_vm.customValidate,"disabled":_vm.disabled,"readonly":_vm.readonly,"clearable":true,"size":_vm.size !== 'md' ? _vm.size : null,"icon":"calendar-alt","no-v-model":true},on:{"clean":_vm.clean},nativeOn:{"mousedown":function($event){return _vm.inputClick($event)}},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},'va-input',_vm.$attrs,false)):_c('va-input',_vm._b({attrs:{"name":_vm.name,"rules":_vm.rules,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"custom-validate":_vm.customValidate,"readonly":false,"clearable":false,"size":_vm.size !== 'md' ? _vm.size : null,"type":"date","no-v-model":true},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},'va-input',_vm.$attrs,false)),_c('transition',{attrs:{"name":"fadeDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayDayView),expression:"displayDayView"},{name:"va-position",rawName:"v-va-position",value:(_vm.displayDayView),expression:"displayDayView"}],class:"va-datepicker-popup"},[_c('div',{class:"va-datepicker-inner"},[_c('div',{class:"va-datepicker-body"},[_c('div',{class:"va-datepicker-ctrl"},[_c('va-button',{class:"va-month-btn va-datepicker-preBtn",attrs:{"tabindex":"0","type":"subtle"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextMonthClick(0)}},nativeOn:{"click":function($event){return _vm.preNextMonthClick(0)}}},[_c('va-icon',{attrs:{"type":"arrow-left","size":"10px"}})],1),_c('va-button',{attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.switchMonthView($event)}},nativeOn:{"click":function($event){return _vm.switchMonthView($event)}}},[_vm._v(_vm._s(_vm.stringifyDayHeader(_vm.currDate)))]),_c('va-button',{class:"va-month-btn va-datepicker-nextBtn",attrs:{"tabindex":"0","type":"subtle"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextMonthClick(1)}},nativeOn:{"click":function($event){return _vm.preNextMonthClick(1)}}},[_c('va-icon',{attrs:{"type":"arrow-right","size":"10px"}})],1)],1),_c('div',{class:"va-datepicker-weekRange"},_vm._l((_vm.weekRange),function(w,index){return _c('span',{key:index},[_vm._v(_vm._s(w))])}),0),_c('div',{class:"va-datepicker-dateRange"},_vm._l((_vm.dateRange),function(d,index){return _c('span',{key:index,class:d.sclass,attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.daySelect(d.date, d.text, d.sclass)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.daySelect(d.date, d.text, d.sclass)}}},[_vm._v(_vm._s(d.text))])}),0)])])])]),_c('transition',{attrs:{"name":"fadeDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayMonthView),expression:"displayMonthView"},{name:"va-position",rawName:"v-va-position",value:(_vm.displayMonthView),expression:"displayMonthView"}],class:"va-datepicker-popup"},[_c('div',{class:"va-datepicker-inner"},[_c('div',{class:"va-datepicker-body"},[_c('div',{class:"va-datepicker-ctrl"},[_c('va-button',{class:"va-month-btn va-datepicker-preBtn",attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextYearClick(0)}},nativeOn:{"click":function($event){return _vm.preNextYearClick(0)}}},[_c('va-icon',{attrs:{"type":"arrow-left","size":"10px"}})],1),_c('va-button',{attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.switchDecadeView($event)}},nativeOn:{"click":function($event){return _vm.switchDecadeView($event)}}},[_vm._v(_vm._s(_vm.stringifyYearHeader(_vm.currDate)))]),_c('va-button',{class:"va-month-btn va-datepicker-nextBtn",attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextYearClick(1)}},nativeOn:{"click":function($event){return _vm.preNextYearClick(1)}}},[_c('va-icon',{attrs:{"type":"arrow-right","size":"10px"}})],1)],1),_c('div',{class:"va-datepicker-monthRange"},[_vm._l((_vm.monthNames),function(m,index){return [_c('va-button',{key:index,class:_vm.monthClassObj(m),on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.monthSelect(index)},"click":function($event){return _vm.monthSelect(index)}}},[_vm._v(" "+_vm._s(m)+" ")])]})],2)])])])]),_c('transition',{attrs:{"name":"fadeDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayYearView),expression:"displayYearView"},{name:"va-position",rawName:"v-va-position",value:(_vm.displayYearView),expression:"displayYearView"}],class:"va-datepicker-popup"},[_c('div',{class:"va-datepicker-inner"},[_c('div',{class:"va-datepicker-body"},[_c('div',{class:"va-datepicker-ctrl"},[_c('va-button',{class:"va-month-btn va-datepicker-preBtn",attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextDecadeClick(0)}},nativeOn:{"click":function($event){return _vm.preNextDecadeClick(0)}}},[_c('va-icon',{attrs:{"type":"arrow-left","size":"10px"}})],1),_c('va-button',{class:"va-month-btn va-datepicker-nextBtn",attrs:{"type":"subtle","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.preNextDecadeClick(1)}},nativeOn:{"click":function($event){return _vm.preNextDecadeClick(1)}}},[_c('va-icon',{attrs:{"type":"arrow-right","size":"10px"}})],1),_c('va-button',{attrs:{"type":"subtle"}},[_vm._v(_vm._s(_vm.stringifyDecadeHeader(_vm.currDate)))])],1),_c('div',{class:"va-datepicker-monthRange va-datepicker-decadeRange"},[_vm._l((_vm.decadeRange),function(decade,index){return [_c('va-button',{key:index,class:_vm.yearClassObj(decade),on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.yearSelect(decade.text)},"click":function($event){$event.stopPropagation();return _vm.yearSelect(decade.text)}}},[_vm._v(" "+_vm._s(decade.text)+" ")])]})],2)])])])])],1)}
var VaDatepickervue_type_template_id_09397717_staticRenderFns = []


// CONCATENATED MODULE: ./src/Datepicker/VaDatepicker.vue?vue&type=template&id=09397717&

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__("c32d");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// CONCATENATED MODULE: ./src/utils/format.js



/* harmony default export */ var utils_format = ({
  dateParse: function dateParse(str, format) {
    if (typeof str !== 'string') {
      return str;
    }

    return external_moment_default()(str, format).toString();
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Datepicker/VaDatepicker.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var VaDatepickervue_type_script_lang_js_ = ({
  name: 'VaDatepicker',
  inheritAttrs: false,
  mixins: [inputMixin, localeMixin('VaDatepicker'), events],
  props: {
    value: {},
    size: {
      type: String,
      default: 'md'
    },
    format: {
      type: String,
      default: 'MM-dd-yyyy',
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    autoclose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var currentValue = this.value;

    if (typeof currentValue === 'undefined') {
      this.$emit('input', null);
      currentValue = null;
    }

    return {
      isMobile: false,
      currentValue: currentValue,
      currMonth: 0,
      currYear: 0,
      today: '',
      weekRange: [this.getL('sunday'), this.getL('monday'), this.getL('tuesday'), this.getL('wednesday'), this.getL('thursday'), this.getL('friday'), this.getL('saturday')],
      dateRange: [],
      decadeRange: [],
      currDate: new Date(),
      displayDayView: false,
      displayMonthView: false,
      displayYearView: false,
      monthNames: [this.getL('january'), this.getL('february'), this.getL('march'), this.getL('april'), this.getL('may'), this.getL('june'), this.getL('july'), this.getL('august'), this.getL('september'), this.getL('october'), this.getL('november'), this.getL('december')]
    };
  },
  watch: {
    currDate: function currDate(val) {
      if (val instanceof Date) {
        this.currentValue = this.stringify(val);
      }

      this.getDateRange();
    },
    value: function value(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.currentValue = val || null;
    },
    currentValue: function currentValue(val) {
      if (this.inner) {
        this.inner = false;
        return;
      }

      this.inner = true;
      this.$emit('input', val);
      this.$emit('change', this.currentValue);
    }
  },
  methods: {
    keyup: function keyup(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
    clean: function clean() {
      this.currDate = new Date();
      this.currYear = this.currDate.getFullYear();
      this.currMonth = this.currDate.getMonth();
      this.currentValue = this.stringify(new Date());
      this.$emit('input', null);
    },
    monthClassObj: function monthClassObj(m) {
      var currentValue = this.currentValue,
          monthNames = this.monthNames,
          parse = this.parse,
          currDate = this.currDate;
      var classes = {};
      classes['va-datepicker-dateRange-item-active'] = currentValue && parse(currentValue) && monthNames[parse(currentValue).getMonth()] === m && currDate.getFullYear() === parse(currentValue).getFullYear();
      return classes;
    },
    yearClassObj: function yearClassObj(decade) {
      var currentValue = this.currentValue,
          parse = this.parse;
      var classes = {};
      classes['va-datepicker-dateRange-item-active'] = currentValue && parse(currentValue) && parse(currentValue).getFullYear() === decade.text;
      return classes;
    },
    close: function close() {
      this.displayDayView = this.displayMonthView = this.displayYearView = false;
    },
    inputClick: function inputClick() {
      if (this.disabled) return;

      if (this.displayMonthView || this.displayYearView) {
        this.displayDayView = false;
      } else {
        this.displayDayView = !this.displayDayView;
      }
    },
    preNextDecadeClick: function preNextDecadeClick(flag) {
      var year = this.currDate.getFullYear();
      var months = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 10, months, date);
      } else {
        this.currDate = new Date(year + 10, months, date);
      }
    },
    preNextMonthClick: function preNextMonthClick(flag) {
      var year = this.currDate.getFullYear();
      var month = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        var preMonth = this.getYearMonth(year, month - 1);
        this.currDate = new Date(preMonth.year, preMonth.month, date);
        this.currMonth = preMonth.month;
        this.currYear = preMonth.year;
      } else {
        var nextMonth = this.getYearMonth(year, month + 1);
        this.currDate = new Date(nextMonth.year, nextMonth.month, date);
        this.currMonth = nextMonth.month;
        this.currYear = nextMonth.year;
      }
    },
    preNextYearClick: function preNextYearClick(flag) {
      var year = this.currDate.getFullYear();
      var months = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 1, months, date);
        this.currYear = year - 1;
      } else {
        this.currDate = new Date(year + 1, months, date);
        this.currYear = year + 1;
      }
    },
    yearSelect: function yearSelect(year) {
      this.currYear = year;
      this.displayYearView = false;
      this.displayMonthView = true;
      this.currDate = new Date(year, this.currDate.getMonth(), this.currDate.getDate());
    },
    daySelect: function daySelect(date, dayNumber, classes) {
      if (classes.indexOf('va-datepicker-item-disabled') > -1) {
        return false;
      } else {
        this.currYear = date.getFullYear();
        this.currMonth = date.getMonth();
        this.currDate = new Date(this.currYear, this.currMonth, dayNumber);
        this.currentValue = this.stringify(this.currDate);

        if (this.autoclose) {
          this.close();
        }
      }
    },
    switchMonthView: function switchMonthView() {
      this.displayDayView = false;
      this.displayMonthView = true;
    },
    switchDecadeView: function switchDecadeView() {
      this.displayMonthView = false;
      this.displayYearView = true;
    },
    monthSelect: function monthSelect(index) {
      this.currMonth = index;
      this.displayMonthView = false;
      this.displayDayView = true;
      this.currDate = new Date(this.currDate.getFullYear(), index, this.currDate.getDate());
    },
    getYearMonth: function getYearMonth(year, month) {
      if (month > 11) {
        year++;
        month = 0;
      } else if (month < 0) {
        year--;
        month = 11;
      }

      return {
        year: year,
        month: month
      };
    },
    stringifyDecadeHeader: function stringifyDecadeHeader(date) {
      var yearStr = date.getFullYear().toString();
      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0;
      var lastYearOfDecade = parseInt(firstYearOfDecade, 10) + 10;
      return firstYearOfDecade + '-' + lastYearOfDecade;
    },
    stringifyDayHeader: function stringifyDayHeader(date) {
      return this.monthNames[date.getMonth()] + ' ' + date.getFullYear();
    },
    stringifyYearHeader: function stringifyYearHeader(date) {
      return date.getFullYear();
    },
    parseMonth: function parseMonth(date) {
      return this.monthNames[date.getMonth()];
    },
    stringify: function stringify(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.format;
      if (isNaN(date.getFullYear())) return '';
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return format.replace(/yyyy/g, year).replace(/MMMM/g, month).replace(/MMM/g, month).replace(/MM/g, ('0' + month).slice(-2)).replace(/dd/g, ('0' + day).slice(-2)) // .replace(/yy/g, year)
      .replace(/M(?!a)/g, month).replace(/d/g, day);
    },
    parse: function parse(str) {
      var date = new Date(utils_format.dateParse(str, 'MM-DD-YYYY')); // const date = new Date(format.dateParse(str, this.format))

      return isNaN(date.getFullYear()) ? null : date;
    },
    getDayCount: function getDayCount(year, month) {
      var dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (month === 1) {
        if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) {
          return 29;
        }

        return 28;
      }

      return dict[month];
    },
    getDateRange: function getDateRange() {
      this.dateRange = [];
      this.decadeRange = [];
      var time = {
        year: this.currDate.getFullYear(),
        month: this.currDate.getMonth(),
        day: this.currDate.getDate()
      };
      var todayDate = new Date();
      var today = {
        year: todayDate.getFullYear(),
        month: todayDate.getMonth(),
        day: todayDate.getDate()
      };
      var yearStr = time.year.toString();
      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0 - 1;

      for (var i = 0; i < 12; i++) {
        this.decadeRange.push({
          text: firstYearOfDecade + i
        });
      }

      var currMonthFirstDay = new Date(time.year, time.month, 1);
      var firstDayWeek = currMonthFirstDay.getDay() + 1;

      if (firstDayWeek === 0) {
        firstDayWeek = 7;
      }

      var dayCount = this.getDayCount(time.year, time.month);

      if (firstDayWeek > 1) {
        var preMonth = this.getYearMonth(time.year, time.month - 1);
        var prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month);

        for (var _i = 1; _i < firstDayWeek; _i++) {
          var dayText = prevMonthDayCount - firstDayWeek + _i + 1;
          this.dateRange.push({
            text: dayText,
            date: new Date(preMonth.year, preMonth.month, dayText),
            sclass: 'va-datepicker-item-gray'
          });
        }
      }

      for (var _i2 = 1; _i2 <= dayCount; _i2++) {
        var date = new Date(time.year, time.month, _i2);
        var sclass = '';

        if (_i2 === today.day && time.month === today.month) {
          sclass = 'va-datepicker-dateRange-item-today';
        }

        if (_i2 === time.day) {
          if (this.currentValue) {
            var valueDate = this.parse(this.currentValue);

            if (valueDate) {
              if (valueDate.getFullYear() === time.year && valueDate.getMonth() === time.month) {
                sclass = 'va-datepicker-dateRange-item-active';
              }
            }
          }
        }

        this.dateRange.push({
          text: _i2,
          date: date,
          sclass: sclass
        });
      }

      if (this.dateRange.length < 42) {
        var nextMonthNeed = 42 - this.dateRange.length;
        var nextMonth = this.getYearMonth(time.year, time.month + 1);

        for (var _i3 = 1; _i3 <= nextMonthNeed; _i3++) {
          this.dateRange.push({
            text: _i3,
            date: new Date(nextMonth.year, nextMonth.month, _i3),
            sclass: 'va-datepicker-item-gray'
          });
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    this.today = this.stringify(new Date());
    this.$on('Va@datepickerIsMobile', function (val) {
      _this.isMobile = val;
    });
    /**
     * In case this component is instantiated after the App
     * has initially broadcasted isMobile, let's request it.
     */

    this.dispatch('VaApp', 'Va@requestIsMobile', true);
    document.addEventListener('keyup', this.keyup);
  },
  computed: {
    isDateSupported: function isDateSupported() {
      var input = document.createElement('input');
      var value = 'a';
      input.setAttribute('type', 'date');
      input.setAttribute('value', value);
      return input.value !== value;
    },
    mobileDatepicker: function mobileDatepicker() {
      if (!this.isMobile || !this.isDateSupported) {
        return false;
      }

      return true;
    },
    styleObj: function styleObj() {
      var style = {};
      var actualWidth = this.actualWidth;
      actualWidth.slice(-1) === '%' ? style['width'] = actualWidth : style['min-width'] = actualWidth;
      return style;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.currentValue === null || this.currentValue === '') {
      this.getDateRange();
    } else {
      this.currDate = this.parse(this.currentValue);
    }

    this._closeEvent = utils_EventListener.listen(window, 'click', function (e) {
      if (!_this2.$el.contains(e.target)) _this2.close();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._closeEvent) this._closeEvent.remove();
    document.removeEventListener('keyup', this.keyup);
  }
});
// CONCATENATED MODULE: ./src/Datepicker/VaDatepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var Datepicker_VaDatepickervue_type_script_lang_js_ = (VaDatepickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Datepicker/VaDatepicker.vue?vue&type=style&index=0&lang=scss&
var VaDatepickervue_type_style_index_0_lang_scss_ = __webpack_require__("3dfb");

// CONCATENATED MODULE: ./src/Datepicker/VaDatepicker.vue






/* normalize component */

var VaDatepicker_component = normalizeComponent(
  Datepicker_VaDatepickervue_type_script_lang_js_,
  VaDatepickervue_type_template_id_09397717_render,
  VaDatepickervue_type_template_id_09397717_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Datepicker_VaDatepicker = (VaDatepicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/PageHeader/VaPageHeader.vue?vue&type=template&id=10427914&
var VaPageHeadervue_type_template_id_10427914_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-page-header"},[(_vm.hasBreadcrumb)?_c('div',{class:"va-page-header-breadcrumb-wrapper"},[_c('div',{class:"va-page-header-breadcrumb-container"},[_vm._t("breadcrumb")],2)]):_vm._e(),_c('div',{class:"va-page-header-title-wrapper"},[_c('div',{class:"va-page-header-title-container"},[_c('h1',[_vm._t("title")],2),(_vm.hasSubtitle)?_c('h2',[_vm._t("subtitle")],2):_vm._e()]),(_vm.hasActions)?_c('div',{class:"va-page-header-actions-wrapper"},[_vm._t("actions")],2):_vm._e()]),(_vm.hasBottom)?_c('div',{class:"va-page-header-bottom-wrapper"},[_vm._t("bottom")],2):_vm._e()])}
var VaPageHeadervue_type_template_id_10427914_staticRenderFns = []


// CONCATENATED MODULE: ./src/PageHeader/VaPageHeader.vue?vue&type=template&id=10427914&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/PageHeader/VaPageHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaPageHeadervue_type_script_lang_js_ = ({
  name: 'VaPageHeader',
  computed: {
    hasActions: function hasActions() {
      return !!this.$slots['actions'];
    },
    hasBottom: function hasBottom() {
      return !!this.$slots['bottom'];
    },
    hasBreadcrumb: function hasBreadcrumb() {
      return !!this.$slots['breadcrumb'];
    },
    hasSubtitle: function hasSubtitle() {
      return !!this.$slots['subtitle'];
    }
  }
});
// CONCATENATED MODULE: ./src/PageHeader/VaPageHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var PageHeader_VaPageHeadervue_type_script_lang_js_ = (VaPageHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/PageHeader/VaPageHeader.vue?vue&type=style&index=0&lang=scss&
var VaPageHeadervue_type_style_index_0_lang_scss_ = __webpack_require__("c3ec");

// CONCATENATED MODULE: ./src/PageHeader/VaPageHeader.vue






/* normalize component */

var VaPageHeader_component = normalizeComponent(
  PageHeader_VaPageHeadervue_type_script_lang_js_,
  VaPageHeadervue_type_template_id_10427914_render,
  VaPageHeadervue_type_template_id_10427914_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPageHeader = (VaPageHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Breadcrumb/VaBreadcrumb.vue?vue&type=template&id=8bba7048&
var VaBreadcrumbvue_type_template_id_8bba7048_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-breadcrumb"},[_vm._t("default")],2)}
var VaBreadcrumbvue_type_template_id_8bba7048_staticRenderFns = []


// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumb.vue?vue&type=template&id=8bba7048&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Breadcrumb/VaBreadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var VaBreadcrumbvue_type_script_lang_js_ = ({
  name: 'VaBreadcrumb',
  props: {
    separator: {
      type: String,
      default: '/',
      required: false
    },
    separatorIcon: {
      type: String,
      default: '',
      required: false
    }
  },
  provide: function provide() {
    return {
      VaBreadcrumbParent: this
    };
  }
});
// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var Breadcrumb_VaBreadcrumbvue_type_script_lang_js_ = (VaBreadcrumbvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Breadcrumb/VaBreadcrumb.vue?vue&type=style&index=0&lang=scss&
var VaBreadcrumbvue_type_style_index_0_lang_scss_ = __webpack_require__("be2a");

// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumb.vue






/* normalize component */

var VaBreadcrumb_component = normalizeComponent(
  Breadcrumb_VaBreadcrumbvue_type_script_lang_js_,
  VaBreadcrumbvue_type_template_id_8bba7048_render,
  VaBreadcrumbvue_type_template_id_8bba7048_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaBreadcrumb = (VaBreadcrumb_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckboxBtn.vue?vue&type=template&id=59a2bea0&
var VaCheckboxBtnvue_type_template_id_59a2bea0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-button',{class:_vm.classObj,attrs:{"size":_vm.size,"disabled":_vm.disabled,"type":_vm.currentChecked ? 'primary' : 'default'},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._t("default")],2)}
var VaCheckboxBtnvue_type_template_id_59a2bea0_staticRenderFns = []


// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxBtn.vue?vue&type=template&id=59a2bea0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckboxBtn.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaCheckboxBtnvue_type_script_lang_js_ = ({
  name: 'VaCheckboxBtn',
  mixins: [events],
  props: {
    value: {
      type: String
    },
    label: {
      type: [String, Number]
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-checked-btn'] = true;
      return classes;
    }
  },
  watch: {
    value: function value(val) {
      this.currentChecked = val;
    },
    checked: function checked(val) {
      this.currentChecked = val;
    },
    currentChecked: function currentChecked(val) {
      this.$emit('input', val);
    }
  },
  data: function data() {
    var checked = this.checked;

    if (checked !== undefined) {
      this.$emit('input', checked);
    } else {
      checked = !!this.value;
    }

    return {
      currentChecked: checked
    };
  },
  methods: {
    handleClick: function handleClick() {
      this.currentChecked = !this.currentChecked;
      this.dispatch('VaCheckboxGroup', 'Va@checkboxChange', this);
      this.$emit('change', this.currentChecked);
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@checkboxgroupChange', function (val) {
      _this.currentChecked = val.indexOf(_this.label) > -1;
    });
  }
});
// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var Checkbox_VaCheckboxBtnvue_type_script_lang_js_ = (VaCheckboxBtnvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxBtn.vue





/* normalize component */

var VaCheckboxBtn_component = normalizeComponent(
  Checkbox_VaCheckboxBtnvue_type_script_lang_js_,
  VaCheckboxBtnvue_type_template_id_59a2bea0_render,
  VaCheckboxBtnvue_type_template_id_59a2bea0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCheckboxBtn = (VaCheckboxBtn_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Pagination/VaPagination.vue?vue&type=template&id=08a3f306&
var VaPaginationvue_type_template_id_08a3f306_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_c('ul',[_c('va-pagination-item',{attrs:{"disabled":_vm.onFirstPage,"index":_vm.currentValue - 1}},[_c('va-icon',{attrs:{"type":"angle-left"}})],1),(!_vm.startEllipsis)?_c('div',{staticStyle:{"width":"70px"}}):_vm._e(),(_vm.startEllipsis)?_c('va-pagination-item',{attrs:{"index":1}},[_vm._v("1")]):_vm._e(),(_vm.startEllipsis)?_c('va-pagination-item',{attrs:{"index":2,"disabled":true}},[_c('va-icon',{attrs:{"type":"ellipsis-h","size":"10px"}})],1):_vm._e(),_vm._l((_vm.pages),function(page,index){return _c('va-pagination-item',{key:index,attrs:{"active":page === _vm.currentValue,"index":page}},[_vm._v(_vm._s(page))])}),(!_vm.endEllipsis && _vm.pageCount - 1 >= _vm.end)?[_c('va-pagination-item',[_vm._v(_vm._s(_vm.pageCount))])]:_vm._e(),(_vm.endEllipsis)?_c('va-pagination-item',{attrs:{"index":_vm.pageCount - 1,"disabled":true}},[_c('va-icon',{attrs:{"type":"ellipsis-h","size":"10px"}})],1):_vm._e(),(_vm.endEllipsis)?_c('va-pagination-item',{attrs:{"index":_vm.pageCount}},[_vm._v(_vm._s(_vm.pageCount))]):_vm._e(),(!_vm.endEllipsis)?_c('div',{staticStyle:{"width":"35px"}}):_vm._e(),(_vm.pageCount - _vm.end === 0)?_c('div',{staticStyle:{"width":"35px"}}):_vm._e(),_c('va-pagination-item',{attrs:{"disabled":_vm.onLastPage,"index":_vm.currentValue + 1}},[_c('va-icon',{attrs:{"type":"angle-right"}})],1)],2)])}
var VaPaginationvue_type_template_id_08a3f306_staticRenderFns = []


// CONCATENATED MODULE: ./src/Pagination/VaPagination.vue?vue&type=template&id=08a3f306&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Pagination/VaPagination.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaPaginationvue_type_script_lang_js_ = ({
  name: 'VaPagination',
  props: {
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: Number,
      default: 1
    },
    total: {
      type: Number
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  data: function data() {
    return {
      onFirstPage: false,
      onLastPage: false,
      startEllipsis: false,
      endEllipsis: false,
      pageCount: 0,
      start: 0,
      end: 0,
      pages: [],
      currentValue: this.value > 1 ? this.value : 1
    };
  },
  methods: {
    getPage: function getPage() {
      return Math.max(this.max, this.pageCount);
    },
    countPage: function countPage(end) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pages = [];
      var min = Math.min(end, this.pageCount);

      for (var i = start; i < min; i++) {
        pages.push(i + 1);
      }

      this.pages = pages;
    },
    checkStartOrEnd: function checkStartOrEnd(index) {
      this.onFirstPage = false;
      this.onLastPage = false;
      this.startEllipsis = false;
      this.endEllipsis = false;

      if (index === 1) {
        this.onFirstPage = true;
      }

      if (index === this.pageCount) {
        this.onLastPage = true;
      } // let s = this.currentValue - Math.floor(this.max / 2)


      var e = this.currentValue + Math.floor(this.max / 2);

      if (this.max < this.pageCount && !this.onLastPage && e < this.pageCount - 1) {
        this.endEllipsis = true;
      }

      if (this.max < this.pageCount && !this.onFirstPage && this.currentValue >= this.max) {
        this.startEllipsis = true;
      }
    },
    changePage: function changePage(index) {
      var max = this.max;
      var middle = Math.ceil(max / 2);

      if (index <= 1) {
        index = 1;
      } else if (index >= this.getPage()) {
        index = this.getPage();
      }

      this.start = index - middle;
      this.end = Math.min(index + max - middle, this.pageCount);

      if (index < max) {
        this.end = max;
      }

      if (this.end - this.start <= max) {
        this.start = this.end - max;
      }

      if (this.start <= 0 || index < max) {
        this.start = 0;
      }

      this.currentValue = index;
      this.countPage(this.end, this.start);
      this.checkStartOrEnd(index);
      this.$emit('change', {
        pageNumber: this.currentValue,
        perPage: this.perPage
      });
    },
    initCount: function initCount(total, value) {
      this.pageCount = Math.ceil(total / this.perPage);
      this.countPage(this.max);
      this.checkStartOrEnd(value);
      this.changePage(value);
    }
  },
  computed: {
    classObj: function classObj() {
      var classes = {};
      classes['va-pagination'] = true;
      return classes;
    }
  },
  mounted: function mounted() {
    this.initCount(this.total, this.currentValue);
  },
  watch: {
    total: function total(val) {
      this.initCount(val, this.currentValue);
    },
    value: function value(val) {
      this.initCount(this.total, val);
    },
    perPage: function perPage() {
      this.initCount(this.total, this.currentValue);
    },
    max: function max() {
      this.initCount(this.total, this.currentValue);
    }
  }
});
// CONCATENATED MODULE: ./src/Pagination/VaPagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var Pagination_VaPaginationvue_type_script_lang_js_ = (VaPaginationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Pagination/VaPagination.vue?vue&type=style&index=0&lang=scss&
var VaPaginationvue_type_style_index_0_lang_scss_ = __webpack_require__("5793");

// CONCATENATED MODULE: ./src/Pagination/VaPagination.vue






/* normalize component */

var VaPagination_component = normalizeComponent(
  Pagination_VaPaginationvue_type_script_lang_js_,
  VaPaginationvue_type_template_id_08a3f306_render,
  VaPaginationvue_type_template_id_08a3f306_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPagination = (VaPagination_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ColorPicker/VaColorPicker.vue?vue&type=template&id=d8937d52&
var VaColorPickervue_type_template_id_d8937d52_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-dropdown',[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('va-button',{ref:"colorpicker",nativeOn:{"click":function($event){$event.preventDefault();return _vm.toggleColorPicker($event)}}},[_c('div',{class:"va-color-picker-button-inner"},[_c('div',{style:(_vm.buttonStyleObj)})])])],1),_c('va-color-picker-popup',{ref:"colorpickerpopup",attrs:{"color":_vm.color,"show":_vm.show,"hide-alpha":_vm.hideAlpha},on:{"change":_vm.onChange}})],1)}
var VaColorPickervue_type_template_id_d8937d52_staticRenderFns = []


// CONCATENATED MODULE: ./src/ColorPicker/VaColorPicker.vue?vue&type=template&id=d8937d52&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ColorPicker/VaColorPicker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaColorPickervue_type_script_lang_js_ = ({
  name: 'VaColorPicker',
  props: {
    color: {
      type: String,
      default: '#ff6900',
      required: false
    },
    hideAlpha: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var c = this.color;
    return {
      col: c,
      colors: {},
      show: false,
      rgba: '',
      rgb: ''
    };
  },
  methods: {
    toggleColorPicker: function toggleColorPicker() {
      this.$refs.colorpickerpopup.doShow();
    },
    onChange: function onChange(e) {
      this.colors = e;
      this.col = 'rgba(' + e.rgba.r + ', ' + e.rgba.g + ', ' + e.rgba.b + ', ' + e.rgba.a + ')';
      this.rgba = 'rgba(' + e.rgba.r + ', ' + e.rgba.g + ', ' + e.rgba.b + ', ' + e.rgba.a + ')';
      this.rgb = 'rgb(' + e.rgba.r + ', ' + e.rgba.g + ', ' + e.rgba.b + ')';
      this.$emit('change', e);
    }
  },
  computed: {
    buttonStyleObj: function buttonStyleObj() {
      var style = {};
      style['width'] = '15px';
      style['height'] = '100%';
      style['border-radius'] = '50%';
      style['box-shadow'] = this.rgb + ' 0px 0px 0px 1px';
      style['background'] = this.rgba;
      return style;
    },
    classObj: function classObj() {
      var classes = {};
      classes['va-color-picker'] = true;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/ColorPicker/VaColorPicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var ColorPicker_VaColorPickervue_type_script_lang_js_ = (VaColorPickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/ColorPicker/VaColorPicker.vue?vue&type=style&index=0&lang=scss&
var VaColorPickervue_type_style_index_0_lang_scss_ = __webpack_require__("9ace");

// CONCATENATED MODULE: ./src/ColorPicker/VaColorPicker.vue






/* normalize component */

var VaColorPicker_component = normalizeComponent(
  ColorPicker_VaColorPickervue_type_script_lang_js_,
  VaColorPickervue_type_template_id_d8937d52_render,
  VaColorPickervue_type_template_id_d8937d52_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaColorPicker = (VaColorPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarHeader.vue?vue&type=template&id=9370731a&
var VaSidebarHeadervue_type_template_id_9370731a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-sidebar-header"},[_vm._t("default")],2)}
var VaSidebarHeadervue_type_template_id_9370731a_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebarHeader.vue?vue&type=template&id=9370731a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var VaSidebarHeadervue_type_script_lang_js_ = ({
  name: 'VaSidebarHeader'
});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarHeadervue_type_script_lang_js_ = (VaSidebarHeadervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarHeader.vue





/* normalize component */

var VaSidebarHeader_component = normalizeComponent(
  Sidebar_VaSidebarHeadervue_type_script_lang_js_,
  VaSidebarHeadervue_type_template_id_9370731a_render,
  VaSidebarHeadervue_type_template_id_9370731a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebarHeader = (VaSidebarHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholder.vue?vue&type=template&id=c9da90b6&
var VaPlaceholdervue_type_template_id_c9da90b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default")],2)}
var VaPlaceholdervue_type_template_id_c9da90b6_staticRenderFns = []


// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholder.vue?vue&type=template&id=c9da90b6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholder.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var VaPlaceholdervue_type_script_lang_js_ = ({
  name: 'VaPlaceholder',
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classObj: function classObj() {
      var rounded = this.rounded,
          centered = this.centered,
          animated = this.animated;
      var classes = {};
      classes['va-placeholder'] = true;
      classes['va-placeholder-rounded'] = rounded;
      classes['va-placeholder-centered'] = centered;
      classes['va-placeholder-animated'] = animated;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholder.vue?vue&type=script&lang=js&
 /* harmony default export */ var Placeholder_VaPlaceholdervue_type_script_lang_js_ = (VaPlaceholdervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Placeholder/VaPlaceholder.vue?vue&type=style&index=0&lang=scss&
var VaPlaceholdervue_type_style_index_0_lang_scss_ = __webpack_require__("f334");

// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholder.vue






/* normalize component */

var VaPlaceholder_component = normalizeComponent(
  Placeholder_VaPlaceholdervue_type_script_lang_js_,
  VaPlaceholdervue_type_template_id_c9da90b6_render,
  VaPlaceholdervue_type_template_id_c9da90b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPlaceholder = (VaPlaceholder_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckboxGroup.vue?vue&type=template&id=31389243&
var VaCheckboxGroupvue_type_template_id_31389243_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_vm._t("default"),_c('validate',{attrs:{"name":_vm.name,"rules":_vm.rules,"custom-validate":_vm.customValidate,"current":_vm.currentValue}})],2)}
var VaCheckboxGroupvue_type_template_id_31389243_staticRenderFns = []


// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxGroup.vue?vue&type=template&id=31389243&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Checkbox/VaCheckboxGroup.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VaCheckboxGroupvue_type_script_lang_js_ = ({
  name: 'VaCheckboxGroup',
  mixins: [validationMixin, events],
  props: {
    value: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    vertical: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'checkbox'
    }
  },
  data: function data() {
    return {
      currentValue: []
    };
  },
  methods: {
    init: function init() {
      var children = this.$children;
      var ret = [];
      children.forEach(function (item) {
        item.currentChecked ? ret.push(item.label) : '';
      });
      this.currentValue = ret;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      var value = val || this.value;
      this.broadcast('VaCheckbox', 'Va@checkboxgroupChange', value);
      this.broadcast('VaCheckboxBtn', 'Va@checkboxgroupChange', value);
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },
  created: function created() {
    var _this = this;

    this.$on('Va@checkboxChange', function () {
      _this.init();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.currentValue = this.value;
    this.$nextTick(function () {
      _this2.init();
    });
  },
  components: {
    validate: validate
  },
  computed: {
    classObj: function classObj() {
      var vertical = this.vertical;
      var classes = {};
      classes['va-btn-group'] = !vertical;
      classes['va-btn-group-vertical'] = vertical;
      classes['va-checkbox-group'] = true;
      classes['va-checkbox-group-vertical'] = vertical;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var Checkbox_VaCheckboxGroupvue_type_script_lang_js_ = (VaCheckboxGroupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Checkbox/VaCheckboxGroup.vue





/* normalize component */

var VaCheckboxGroup_component = normalizeComponent(
  Checkbox_VaCheckboxGroupvue_type_script_lang_js_,
  VaCheckboxGroupvue_type_template_id_31389243_render,
  VaCheckboxGroupvue_type_template_id_31389243_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaCheckboxGroup = (VaCheckboxGroup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Notification/VaNotification.vue?vue&type=template&id=4700b519&
var VaNotificationvue_type_template_id_4700b519_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alive)?_c('div',{ref:"notification",class:_vm.classObj,style:(_vm.styleObj)},[_c('div',{class:"va-notification-dialog",style:({'width': _vm.width })},[_c('div',{class:"va-notification-content"},[_c('div',{class:("va-notification-content-inner-" + _vm.type)},[_c('div',{class:("va-notification-content-inner-" + _vm.type + "-left")},[_c('va-icon',{attrs:{"type":_vm.notificationIconType}})],1),_c('div',{class:("va-notification-content-inner-" + _vm.type + "-right")},[_c('div',{class:("va-notification-content-inner-" + _vm.type + "-right-close")},[_c('va-button',{attrs:{"type":"subtle","size":"sm"},on:{"click":_vm.close}},[_c('va-icon',{attrs:{"size":"14px","type":"times"}})],1)],1),_c('div',{class:("va-notification-content-inner-" + _vm.type + "-right-title")},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:("va-notification-content-inner-" + _vm.type + "-right-message"),domProps:{"innerHTML":_vm._s(_vm.message)}})])])])])]):_vm._e()}
var VaNotificationvue_type_template_id_4700b519_staticRenderFns = []


// CONCATENATED MODULE: ./src/Notification/VaNotification.vue?vue&type=template&id=4700b519&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Notification/VaNotification.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaNotificationvue_type_script_lang_js_ = ({
  name: 'VaNotification',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    message: {
      type: String,
      default: '',
      required: false
    },
    show: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: String,
      default: '440px',
      required: false
    },
    effect: {
      type: String,
      default: 'fade-right',
      required: false
    },
    type: {
      type: String,
      default: 'default',
      required: false
    },
    duration: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data: function data() {
    var show = this.show;
    return {
      isShow: show,
      alive: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.duration) {
      setTimeout(function () {
        _this.close();
      }, this.duration);
    }
  },
  watch: {
    isShow: function isShow(val) {
      var _this2 = this;

      /**
       * Stackable logic
       */
      if (val) {
        var x = document.getElementsByClassName('va-notification-in');
        this.numberOfParentModals = x.length;
        var distanceToMove = 5;

        if (this.numberOfParentModals > 0) {
          for (var i = 0; i < this.numberOfParentModals; i++) {
            var currentMarginTop = x[i].style['top'];

            if (currentMarginTop && currentMarginTop !== '0px') {
              var m = Math.abs(currentMarginTop.slice(0, -2));
              var dist = parseInt(m + distanceToMove);
              x[i].style['top'] = '-' + dist + 'px';
              x[i].style['right'] = '-' + dist + 'px';
            } else {
              x[i].style['top'] = distanceToMove * -1 + 'px';
              x[i].style['right'] = distanceToMove * -1 + 'px';
            }
          }
        }
      } else {
        var _x = document.getElementsByClassName('va-notification-in');

        this.numberOfParentModals = _x.length;
        var _distanceToMove = 5;

        if (this.numberOfParentModals > 0) {
          for (var _i = 0; _i < this.numberOfParentModals; _i++) {
            var _currentMarginTop = _x[_i].style['top'];

            if (_currentMarginTop && _currentMarginTop !== '0px') {
              var _m = Math.abs(_currentMarginTop.slice(0, -2));

              var _dist = parseInt(_m - _distanceToMove);

              _x[_i].style['top'] = '-' + _dist + 'px';
              _x[_i].style['right'] = '-' + _dist + 'px';
            }
          }
        }
      }
      /**
       * Classes
       */


      var el = this.$el;
      var body = document.body;

      if (val) {
        this.$emit('show', {
          type: 'show'
        });
        el.querySelector('.' + 'va-notification');
        el.style.display = 'block'; // timeout required for opacity transition

        setTimeout(function () {
          utils_element.addClass(el, 'va-notification-in');
        }, 20);
        utils_element.addClass(body, 'va-notification-open');
      } else {
        this.$emit('hide', {
          type: 'hide'
        });
        utils_element.removeClass(el, 'va-notification-in');
        utils_element.addClass(el, 'va-notification-out');
        setTimeout(function () {
          el.style.display = 'none';
          utils_element.removeClass(body, 'va-notification-open');
          utils_element.removeClass(el, 'va-notification-out');

          _this2.$emit('closed', {
            type: 'closed'
          });
        }, 300);
      }
    }
  },
  methods: {
    close: function close() {
      var _this3 = this;

      this.isShow = false;
      setTimeout(function () {
        _this3.alive = false;
      }, 500);
    },
    open: function open() {
      this.isShow = true;
    },
    confirm: function confirm() {
      this.$emit('confirm', {
        type: 'confirm'
      });
    }
  },
  computed: {
    classObj: function classObj() {
      var effect = this.effect,
          type = this.type;
      var classes = {};
      classes['va-notification'] = true;
      classes['va-notification-' + type] = true;
      classes['va-notification-' + effect] = true;
      return classes;
    },
    styleObj: function styleObj() {
      return {};
    },
    notificationIconType: function notificationIconType() {
      var type = this.type;

      switch (type) {
        case 'default':
          return 'home';

        case 'warning':
          return 'exclamation-triangle';

        case 'danger':
          return 'exclamation-triangle';

        case 'success':
          return 'thumbs-up';

        case 'info':
          return 'info-circle';
      }

      return 'info-circle';
    }
  }
});
// CONCATENATED MODULE: ./src/Notification/VaNotification.vue?vue&type=script&lang=js&
 /* harmony default export */ var Notification_VaNotificationvue_type_script_lang_js_ = (VaNotificationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Notification/VaNotification.vue?vue&type=style&index=0&lang=scss&
var VaNotificationvue_type_style_index_0_lang_scss_ = __webpack_require__("5c87");

// CONCATENATED MODULE: ./src/Notification/VaNotification.vue






/* normalize component */

var VaNotification_component = normalizeComponent(
  Notification_VaNotificationvue_type_script_lang_js_,
  VaNotificationvue_type_template_id_4700b519_render,
  VaNotificationvue_type_template_id_4700b519_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaNotification = (VaNotification_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Breadcrumb/VaBreadcrumbItem.vue?vue&type=template&id=235016c2&
var VaBreadcrumbItemvue_type_template_id_235016c2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:"va-breadcrumb-item"},[_c('span',{ref:"link",class:['va-breadcrumb-item-inner', _vm.to || _vm.href ? 'va-breadcrumb-link' : '']},[_vm._t("default")],2),(_vm.separatorIcon)?_c('va-icon',{class:"va-breadcrumb-item-icon",attrs:{"type":_vm.separatorIcon}}):_c('span',{class:"va-breadcrumb-item-separator"},[_vm._v(_vm._s(_vm.separator))])],1)}
var VaBreadcrumbItemvue_type_template_id_235016c2_staticRenderFns = []


// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumbItem.vue?vue&type=template&id=235016c2&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("9911");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Breadcrumb/VaBreadcrumbItem.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaBreadcrumbItemvue_type_script_lang_js_ = ({
  name: 'VaBreadcrumbItem',
  props: {
    to: {},
    href: {
      type: String,
      required: false
    },
    replace: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      separator: '',
      separatorIcon: ''
    };
  },
  inject: ['VaBreadcrumbParent'],
  mounted: function mounted() {
    var _this = this;

    this.separator = this.VaBreadcrumbParent.separator;
    this.separatorIcon = this.VaBreadcrumbParent.separatorIcon;
    var link = this.$refs.link;
    link.addEventListener('click', function (e) {
      _this.$emit('click', e);

      if (_this.href) {
        window.location.href = _this.href;
        return;
      }

      var to = _this.to,
          $router = _this.$router;
      if (!to || !$router) return;
      _this.replace ? $router.replace(to) : $router.push(to);
    });
  }
});
// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumbItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var Breadcrumb_VaBreadcrumbItemvue_type_script_lang_js_ = (VaBreadcrumbItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Breadcrumb/VaBreadcrumbItem.vue





/* normalize component */

var VaBreadcrumbItem_component = normalizeComponent(
  Breadcrumb_VaBreadcrumbItemvue_type_script_lang_js_,
  VaBreadcrumbItemvue_type_template_id_235016c2_render,
  VaBreadcrumbItemvue_type_template_id_235016c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaBreadcrumbItem = (VaBreadcrumbItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Pagination/VaPaginationItem.vue?vue&type=template&id=d8be538c&
var VaPaginationItemvue_type_template_id_d8be538c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classObj},[_c('va-button',{ref:"button",attrs:{"active":_vm.active,"disabled":_vm.disabled,"type":"subtle"},nativeOn:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)],1)}
var VaPaginationItemvue_type_template_id_d8be538c_staticRenderFns = []


// CONCATENATED MODULE: ./src/Pagination/VaPaginationItem.vue?vue&type=template&id=d8be538c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Pagination/VaPaginationItem.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaPaginationItemvue_type_script_lang_js_ = ({
  name: 'VaPaginationItem',
  props: {
    index: {
      type: Number
    },
    active: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$parent.changePage(this.index);
        this.$refs.button.focused = false;
      }
    }
  },
  computed: {
    classObj: function classObj() {
      var disabled = this.disabled;
      var classes = {};
      classes['va-pagination-item-disabled'] = disabled;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Pagination/VaPaginationItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var Pagination_VaPaginationItemvue_type_script_lang_js_ = (VaPaginationItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Pagination/VaPaginationItem.vue





/* normalize component */

var VaPaginationItem_component = normalizeComponent(
  Pagination_VaPaginationItemvue_type_script_lang_js_,
  VaPaginationItemvue_type_template_id_d8be538c_render,
  VaPaginationItemvue_type_template_id_d8be538c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPaginationItem = (VaPaginationItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupTitle.vue?vue&type=template&id=7f1dabda&
var VaSidebarGroupTitlevue_type_template_id_7f1dabda_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-sidebar-group-title"},[_vm._t("default")],2)}
var VaSidebarGroupTitlevue_type_template_id_7f1dabda_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupTitle.vue?vue&type=template&id=7f1dabda&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupTitle.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var VaSidebarGroupTitlevue_type_script_lang_js_ = ({
  name: 'VaSidebarGroupTitle'
});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupTitle.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarGroupTitlevue_type_script_lang_js_ = (VaSidebarGroupTitlevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupTitle.vue





/* normalize component */

var VaSidebarGroupTitle_component = normalizeComponent(
  Sidebar_VaSidebarGroupTitlevue_type_script_lang_js_,
  VaSidebarGroupTitlevue_type_template_id_7f1dabda_render,
  VaSidebarGroupTitlevue_type_template_id_7f1dabda_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebarGroupTitle = (VaSidebarGroupTitle_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderText.vue?vue&type=template&id=31d72eee&
var VaPlaceholderTextvue_type_template_id_31d72eee_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-placeholder-text"},_vm._l((_vm.lines),function(line){return _c('div',{key:line,class:"va-placeholder-text-line"})}),0)}
var VaPlaceholderTextvue_type_template_id_31d72eee_staticRenderFns = []


// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderText.vue?vue&type=template&id=31d72eee&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderText.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaPlaceholderTextvue_type_script_lang_js_ = ({
  name: 'VaPlaceholderText',
  props: {
    lines: {
      type: Number,
      default: 4
    }
  }
});
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderText.vue?vue&type=script&lang=js&
 /* harmony default export */ var Placeholder_VaPlaceholderTextvue_type_script_lang_js_ = (VaPlaceholderTextvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderText.vue





/* normalize component */

var VaPlaceholderText_component = normalizeComponent(
  Placeholder_VaPlaceholderTextvue_type_script_lang_js_,
  VaPlaceholderTextvue_type_template_id_31d72eee_render,
  VaPlaceholderTextvue_type_template_id_31d72eee_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPlaceholderText = (VaPlaceholderText_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderImage.vue?vue&type=template&id=3d53fc9a&
var VaPlaceholderImagevue_type_template_id_3d53fc9a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-placeholder-image"})}
var VaPlaceholderImagevue_type_template_id_3d53fc9a_staticRenderFns = []


// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderImage.vue?vue&type=template&id=3d53fc9a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderImage.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var VaPlaceholderImagevue_type_script_lang_js_ = ({
  name: 'VaPlaceholderImage'
});
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderImage.vue?vue&type=script&lang=js&
 /* harmony default export */ var Placeholder_VaPlaceholderImagevue_type_script_lang_js_ = (VaPlaceholderImagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderImage.vue





/* normalize component */

var VaPlaceholderImage_component = normalizeComponent(
  Placeholder_VaPlaceholderImagevue_type_script_lang_js_,
  VaPlaceholderImagevue_type_template_id_3d53fc9a_render,
  VaPlaceholderImagevue_type_template_id_3d53fc9a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPlaceholderImage = (VaPlaceholderImage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ColorPicker/VaColorPickerPopup.vue?vue&type=template&id=4cc131c4&
var VaColorPickerPopupvue_type_template_id_4cc131c4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeDown"}},[_c('div',{ref:"popup",class:"va-color-picker-popup"},[_c('div',{class:"va-color-picker-upper"},[_c('div',{ref:"gradient",class:"va-color-picker-gradient",style:(_vm.gradientStyleObj),on:{"mousedown":_vm.gradientOnMousedown,"touchstart":_vm.gradientOnMousedown}},[_c('div',{class:"va-color-picker-gradient-white"}),_c('div',{class:"va-color-picker-gradient-black"}),_c('div',{class:"va-color-picker-border"}),_c('div',{ref:"gradientCursor",class:"va-color-picker-gradient-cursor"})]),_c('div',{ref:"hue",class:"va-color-picker-hue-track",on:{"mousedown":_vm.hueSliderOnMousedown,"touchstart":_vm.hueSliderOnMousedown}},[_c('div',{class:"va-color-picker-border"}),_c('div',{ref:"hueCursor",class:"va-color-picker-hue-cursor"})]),(!_vm.hideAlpha)?_c('div',{ref:"alpha",class:"va-color-picker-alpha-track",on:{"mousedown":_vm.alphaSliderOnMousedown,"touchstart":_vm.alphaSliderOnMousedown}},[(!_vm.hideAlpha)?_c('div',{class:"va-color-picker-alpha-track-color",style:(_vm.alphaStyleObj)}):_vm._e(),_c('div',{class:"va-color-picker-border"}),(!_vm.hideAlpha)?_c('div',{ref:"alphaCursor",class:"va-color-picker-alpha-cursor"}):_vm._e()]):_vm._e()]),_c('div',{class:"va-color-picker-lower"},[_c('va-input',{attrs:{"size":"xs","width":"68px"},on:{"change":_vm.hexChange},model:{value:(_vm.hex),callback:function ($$v) {_vm.hex=$$v},expression:"hex"}}),_c('va-input',{attrs:{"size":"xs","width":"38px"},on:{"change":_vm.rChange},model:{value:(_vm.rgb.r),callback:function ($$v) {_vm.$set(_vm.rgb, "r", $$v)},expression:"rgb.r"}}),_c('va-input',{attrs:{"size":"xs","width":"38px"},on:{"change":_vm.gChange},model:{value:(_vm.rgb.g),callback:function ($$v) {_vm.$set(_vm.rgb, "g", $$v)},expression:"rgb.g"}}),_c('va-input',{attrs:{"size":"xs","width":"38px"},on:{"change":_vm.bChange},model:{value:(_vm.rgb.b),callback:function ($$v) {_vm.$set(_vm.rgb, "b", $$v)},expression:"rgb.b"}}),(!_vm.hideAlpha)?_c('va-input',{attrs:{"size":"xs","width":"40px"},on:{"change":_vm.aChange},model:{value:(_vm.alpha),callback:function ($$v) {_vm.alpha=$$v},expression:"alpha"}}):_vm._e()],1),_c('div',{class:"va-color-picker-lower",staticStyle:{"margin":"0","color":"#999"}},[_c('span',{staticStyle:{"text-align":"center","width":"68px","font-size":"10px"}},[_vm._v("HEX")]),_c('span',{staticStyle:{"text-align":"center","width":"38px","font-size":"10px"}},[_vm._v("R")]),_c('span',{staticStyle:{"text-align":"center","width":"38px","font-size":"10px"}},[_vm._v("G")]),_c('span',{staticStyle:{"text-align":"center","width":"38px","font-size":"10px"}},[_vm._v("B")]),(!_vm.hideAlpha)?_c('span',{staticStyle:{"text-align":"center","width":"38px","font-size":"10px"}},[_vm._v("A")]):_vm._e()])])])}
var VaColorPickerPopupvue_type_template_id_4cc131c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/ColorPicker/VaColorPickerPopup.vue?vue&type=template&id=4cc131c4&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// CONCATENATED MODULE: ./src/ColorPicker/conversions.js









/**
 * the hue value H runs from 0 to 360 degrees. the saturation
 * S is the degree of strength or purity and is from 0 to 1.
 * purity is how much white is added to the color, so S=1 makes
 * the purest color (no white). brightness B ranges from 0 to 1,
 * where 0 is black.
 */
var rgbToHsb = function rgbToHsb(rgb) {
  var hsb = {
    h: 0,
    s: 0,
    b: 0
  };
  var min = Math.min(rgb.r, rgb.g, rgb.b);
  var max = Math.max(rgb.r, rgb.g, rgb.b);
  var delta = max - min;
  hsb.b = max;
  hsb.s = max !== 0 ? 255 * delta / max : 0;

  if (hsb.s !== 0) {
    if (rgb.r === max) {
      hsb.h = (rgb.g - rgb.b) / delta; // between yellow and magenta
    } else if (rgb.g === max) {
      hsb.h = 2 + (rgb.b - rgb.r) / delta; // between cyan and yellow
    } else {
      hsb.h = 4 + (rgb.r - rgb.g) / delta; // between magenta and cyan
    }
  } else {
    hsb.h = -1;
  }

  if (max === min) {
    hsb.h = 0;
  }

  hsb.h *= 60; // degrees

  if (hsb.h < 0) {
    hsb.h += 360;
  }

  hsb.s *= 100 / 255;
  hsb.b *= 100 / 255; // return {h:Math.round(hsb.h), s:Math.round(hsb.s), b:Math.round(hsb.b)}

  return hsb;
};
var hsbToRgb = function hsbToRgb(hsb) {
  var rgb = {};
  var h = hsb.h;
  var s = hsb.s * 255 / 100;
  var b = hsb.b * 255 / 100;

  if (s === 0) {
    rgb.r = rgb.g = rgb.b = b;
  } else {
    var p = b;
    var q = (255 - s) * b / 255;
    var t = (p - q) * (h % 60) / 60;
    if (h === 360) h = 0;

    if (h < 60) {
      rgb.r = p;
      rgb.b = q;
      rgb.g = q + t;
    } else if (h < 120) {
      rgb.g = p;
      rgb.b = q;
      rgb.r = p - t;
    } else if (h < 180) {
      rgb.g = p;
      rgb.r = q;
      rgb.b = q + t;
    } else if (h < 240) {
      rgb.b = p;
      rgb.r = q;
      rgb.g = p - t;
    } else if (h < 300) {
      rgb.b = p;
      rgb.g = q;
      rgb.r = q + t;
    } else if (h < 360) {
      rgb.r = p;
      rgb.g = q;
      rgb.b = p - t;
    } else {
      rgb.r = 0;
      rgb.g = 0;
      rgb.b = 0;
    }
  }

  return {
    r: Math.round(rgb.r),
    g: Math.round(rgb.g),
    b: Math.round(rgb.b)
  };
};
var hexToHsb = function hexToHsb(h) {
  var hex = h.indexOf('#') > -1 ? h.substring(1) : h;

  if (hex.length === 3) {
    var num = hex.split('');
    hex = num[0] + num[0] + num[1] + num[1] + num[2] + num[2];
  }

  hex = parseInt(hex, 16);
  var rgb = {
    r: hex >> 16,
    g: (hex & 0x00FF00) >> 8,
    b: hex & 0x0000FF
  };
  return rgbToHsb(rgb);
};
var hsbToHex = function hsbToHex(hsb) {
  var rgb = hsbToRgb(hsb);
  var hex = [rgb.r.toString(16), rgb.g.toString(16), rgb.b.toString(16)];

  for (var i = 0; i < hex.length; i++) {
    if (hex[i].length === 1) {
      hex[i] = '0' + hex[i];
    }
  }

  return '#' + hex.join('');
};
var rgbStringToObject = function rgbStringToObject(rgb) {
  var r = /[0-9]{1,3}/g;
  var re = rgb.match(r) || [];
  return {
    r: re[0],
    g: re[1],
    b: re[2]
  };
}; // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb/5623914#5623914

var rgbToHex = function rgbToHex(rgb) {
  return '#' + ((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).slice(1);
}; // export const rgbToHex = (rgb) => {
//   let hsb = rgbToHsb(rgb)
//   return hsbToHex(hsb)
// }
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ColorPicker/VaColorPickerPopup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VaColorPickerPopupvue_type_script_lang_js_ = ({
  name: 'VaColorPickerPopup',
  props: {
    color: {
      type: String
    },
    hideAlpha: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      gradientPosition: {},
      hueSliderPosition: {},
      alphaSliderPosition: {},
      cursorOffsetLeft: 5,
      cursorOffsetTop: 5,
      alpha: 1,
      hsb: {
        h: 0,
        s: 0,
        b: 0
      },
      rgb: {
        r: 255,
        g: 255,
        b: 255
      },
      hex: '',
      x: 0,
      y: 0
    };
  },
  mounted: function mounted() {
    this.hex = this.color;
    this.hsb = hexToHsb(this.hex);
    this.rgb = hsbToRgb(this.hsb);
    this.emitColors();
  },
  computed: {
    gradientStyleObj: function gradientStyleObj() {
      var hsb = this.hsb,
          alpha = this.alpha;
      var style = {};
      style['background'] = 'hsl(' + hsb.h + ', 100%, 50%, ' + alpha + ')';
      return style;
    },
    alphaStyleObj: function alphaStyleObj() {
      var hsb = this.hsb;
      var style = {};
      style['background'] = 'linear-gradient(180deg, hsl(' + hsb.h + ', 100%, 50%, 0), hsl(' + hsb.h + ', 100%, 50%, 1))';
      return style;
    }
  },
  methods: {
    doShow: function doShow() {
      var _this = this;

      setTimeout(function () {
        _this.hsb = hexToHsb(_this.hex);

        _this.updateControls();
      }, 50);
    },
    emitColors: function emitColors() {
      var colorsToEmit = {
        rgb: this.rgb,
        rgba: {
          r: this.rgb.r,
          g: this.rgb.g,
          b: this.rgb.b,
          a: this.alpha
        },
        hex: this.hex,
        hsb: this.hsb
      };
      this.$emit('change', colorsToEmit);
    },
    rChange: function rChange(e) {
      var rgb = {
        r: e,
        g: this.rgb.g,
        b: this.rgb.b
      };
      this.hsb = rgbToHsb(rgb);
      this.hex = hsbToHex(rgbToHsb(rgb));
      this.updateControls();
    },
    gChange: function gChange(e) {
      var rgb = {
        r: this.rgb.r,
        g: e,
        b: this.rgb.b
      };
      this.hsb = rgbToHsb(rgb);
      this.hex = hsbToHex(rgbToHsb(rgb));
      this.updateControls();
    },
    bChange: function bChange(e) {
      var rgb = {
        r: this.rgb.r,
        g: this.rgb.g,
        b: e
      };
      this.hsb = rgbToHsb(rgb);
      this.hex = hsbToHex(rgbToHsb(rgb));
      this.updateControls();
    },
    aChange: function aChange() {
      this.updateControls();
    },
    hexChange: function hexChange(e) {
      this.hsb = hexToHsb(e);
      this.rgb = hsbToRgb(this.hsb);
      this.updateControls();
    },
    prevent: function prevent(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }

      if (e.preventDefault) {
        e.preventDefault();
      }

      e.cancelBubble = true;
      e.returnValue = false;
    },
    getElementRect: function getElementRect(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        x: rect.x,
        y: rect.y
      };
    },
    selectGradientColor: function selectGradientColor() {
      this.hsb.s = this.x / this.gradientPosition.width * 100;
      this.hsb.b = 100 - this.y / this.gradientPosition.height * 100;
      this.rgb = hsbToRgb(this.hsb);
      this.hex = rgbToHex(this.rgb);
      this.emitColors();
    },
    makeGradientSelection: function makeGradientSelection(e) {
      /**
       * the offset for where the cursor appears in
       * relation to the system cursor.
       */
      var cursorOffsetArrowLeft = 1;
      var cursorOffsetArrowTop = 2;
      /**
       * absolute x and y position of the system cursor
       * in relation to the gradient
       */

      var arrowx = '';
      var arrowy = '';

      if (e.clientX && e.clientY) {
        arrowx = e.clientX - this.gradientPosition.left - cursorOffsetArrowLeft;
        arrowy = e.clientY - this.gradientPosition.top - cursorOffsetArrowTop;
      } else if (e.changedTouches !== undefined) {
        arrowx = e.changedTouches[0].clientX - this.gradientPosition.left - cursorOffsetArrowLeft;
        arrowy = e.changedTouches[0].clientY - this.gradientPosition.top - cursorOffsetArrowTop;
      }
      /**
       * absolute x and y position of the system cursor
       * in relation to the gradient, clamped within gradient bounds
       */


      var x = arrowx - this.cursorOffsetLeft;
      var y = arrowy - this.cursorOffsetTop;
      /**
       * clamp
       */

      if (x < 0 - this.cursorOffsetLeft) x = 0 - this.cursorOffsetLeft;

      if (x > this.gradientPosition.width - this.cursorOffsetLeft) {
        x = this.gradientPosition.width - this.cursorOffsetLeft;
      }

      if (y < 0 - this.cursorOffsetTop) y = 0 - this.cursorOffsetTop;

      if (y > this.gradientPosition.height - this.cursorOffsetTop) {
        y = this.gradientPosition.height - this.cursorOffsetTop;
      }
      /**
       * place the cursor, taking note that x and y are still affected
       * by cursorOffsetLeft and cursorOffsetTop.. we need to adjust before
       * actually figuring out the color
       */


      this.$refs.gradientCursor.style.top = y + 'px';
      this.$refs.gradientCursor.style.left = x + 'px';
      x += this.cursorOffsetLeft;
      y += this.cursorOffsetTop;
      this.x = x;
      this.y = y;
      this.selectGradientColor();
    },
    gradientOnMousedown: function gradientOnMousedown(e) {
      this.prevent(e);
      this.gradientPosition = this.getElementRect(this.$refs.gradient);
      this.makeGradientSelection(e); // set hooks

      window.addEventListener('mousemove', this.gradientOnMousemove, false);
      window.addEventListener('mouseup', this.gradientOnMouseup, false);
      window.addEventListener('touchmove', this.gradientOnMousemove, false);
      window.addEventListener('touchend', this.gradientOnMouseup, false);
    },
    gradientOnMousemove: function gradientOnMousemove(e) {
      this.makeGradientSelection(e);
    },
    gradientOnMouseup: function gradientOnMouseup() {
      // remove hooks
      window.removeEventListener('mouseup', this.gradientOnMouseup, false);
      window.removeEventListener('mousemove', this.gradientOnMousemove, false);
      window.removeEventListener('touchend', this.gradientOnMouseup, false);
      window.removeEventListener('touchmove', this.gradientOnMousemove, false);
    },
    updateControls: function updateControls() {
      this.setHueSliderPositionFromHsb();
      if (!this.hideAlpha) this.setAlphaSliderPositionFromAlpha();
      this.setGradientCursorPositionFromHsb();
      this.emitColors();
    },
    makeHueSelection: function makeHueSelection(e) {
      var cursorOffsetArrowTop = 2;
      /**
       * absolute y position of the system cursor
       * in relation to the hue track
       */

      var arrowy = '';

      if (e.clientY) {
        arrowy = e.clientY - this.hueSliderPosition.top - cursorOffsetArrowTop;
      } else if (e.changedTouches !== undefined) {
        arrowy = e.changedTouches[0].clientY - this.hueSliderPosition.top - cursorOffsetArrowTop;
      }
      /**
       * absolute y position of the system cursor
       * in relation to the hue track, clamped within the track
       */


      var y = arrowy - this.cursorOffsetTop;
      /**
       * clamp
       */

      if (y < 0 - this.cursorOffsetTop) y = 0 - this.cursorOffsetTop;

      if (y > this.hueSliderPosition.height - this.cursorOffsetTop) {
        y = this.hueSliderPosition.height - this.cursorOffsetTop;
      }
      /**
       * place the cursor, taking note that y is still affected
       * by cursorOffsetTop.. we need to adjust before
       * actually figuring out the color
       */


      this.$refs.hueCursor.style.top = y + 'px';
      y += this.cursorOffsetTop;
      this.hsb.h = y / this.hueSliderPosition.height * 360;
      this.selectGradientColor();
    },
    setAlphaSliderPositionFromAlpha: function setAlphaSliderPositionFromAlpha() {
      this.alphaSliderPosition = this.getElementRect(this.$refs.alpha);
      this.$refs.alphaCursor.style.top = this.alpha * this.alphaSliderPosition.height - this.cursorOffsetTop + 'px';
    },
    setHueSliderPositionFromHsb: function setHueSliderPositionFromHsb() {
      this.$refs.hueCursor.style.top = this.hsb.h / 2 + 'px';
    },
    setGradientCursorPositionFromHsb: function setGradientCursorPositionFromHsb() {
      this.gradientPosition = this.getElementRect(this.$refs.gradient);
      /**
       * find where it needs to be in the x
       */

      var left = this.hsb.s * this.gradientPosition.width / 100 - this.cursorOffsetLeft;
      this.x = left;
      this.$refs.gradientCursor.style.left = left + 'px';
      this.x += this.cursorOffsetLeft;
      /**
       * find where it needs to be in the y
       */

      var top = this.hsb.b - 100;

      if (top < 0) {
        top *= -1;
      }

      top = top * this.gradientPosition.height / 100 - this.cursorOffsetTop;
      this.y = top;
      this.$refs.gradientCursor.style.top = top + 'px';
      this.y += this.cursorOffsetTop;
    },
    hueSliderOnMousedown: function hueSliderOnMousedown(e) {
      this.prevent(e);
      this.hueSliderPosition = this.getElementRect(this.$refs.hue);
      this.makeHueSelection(e); // set hooks

      window.addEventListener('mousemove', this.hueSliderOnMousemove, false);
      window.addEventListener('mouseup', this.hueSliderOnMouseup, false);
      window.addEventListener('touchmove', this.hueSliderOnMousemove, false);
      window.addEventListener('touchend', this.hueSliderOnMouseup, false);
    },
    hueSliderOnMousemove: function hueSliderOnMousemove(e) {
      this.makeHueSelection(e);
    },
    hueSliderOnMouseup: function hueSliderOnMouseup() {
      // remove hooks
      window.removeEventListener('mouseup', this.hueSliderOnMouseup, false);
      window.removeEventListener('mousemove', this.hueSliderOnMousemove, false);
      window.removeEventListener('touchend', this.hueSliderOnMouseup, false);
      window.removeEventListener('touchmove', this.hueSliderOnMousemove, false);
    },
    makeAlphaSelection: function makeAlphaSelection(e) {
      var cursorOffsetArrowTop = 2;
      /**
       * absolute y position of the system cursor
       * in relation to the alpha track
       */

      var arrowy = '';

      if (e.clientY) {
        arrowy = e.clientY - this.alphaSliderPosition.top - cursorOffsetArrowTop;
      } else if (e.changedTouches !== undefined) {
        arrowy = e.changedTouches[0].clientY - this.alphaSliderPosition.top - cursorOffsetArrowTop;
      }
      /**
       * absolute y position of the system cursor
       * in relation to the alpha track, clamped within the track
       */


      var y = arrowy - this.cursorOffsetTop;
      /**
       * clamp
       */

      if (y < 0 - this.cursorOffsetTop) y = 0 - this.cursorOffsetTop;

      if (y > this.alphaSliderPosition.height - this.cursorOffsetTop) {
        y = this.alphaSliderPosition.height - this.cursorOffsetTop;
      }
      /**
       * place the cursor, taking note that x and y are still affected
       * by cursorOffsetLeft and cursorOffsetTop.. we need to adjust before
       * actually figuring out the color
       */


      this.$refs.alphaCursor.style.top = y + 'px';
      y += this.cursorOffsetTop;
      this.alpha = y / this.alphaSliderPosition.height * 100 / 100;
      this.selectGradientColor();
    },
    alphaSliderOnMousedown: function alphaSliderOnMousedown(e) {
      this.prevent(e);
      this.alphaSliderPosition = this.getElementRect(this.$refs.alpha);
      this.makeAlphaSelection(e); // set hooks

      window.addEventListener('mousemove', this.alphaSliderOnMousemove, false);
      window.addEventListener('mouseup', this.alphaSliderOnMouseup, false);
      window.addEventListener('touchmove', this.alphaSliderOnMousemove, false);
      window.addEventListener('touchend', this.alphaSliderOnMouseup, false);
    },
    alphaSliderOnMousemove: function alphaSliderOnMousemove(e) {
      this.makeAlphaSelection(e);
    },
    alphaSliderOnMouseup: function alphaSliderOnMouseup() {
      // remove hooks
      window.removeEventListener('mouseup', this.alphaSliderOnMouseup, false);
      window.removeEventListener('mousemove', this.alphaSliderOnMousemove, false);
      window.removeEventListener('touchend', this.alphaSliderOnMouseup, false);
      window.removeEventListener('touchmove', this.alphaSliderOnMousemove, false);
    }
  }
});
// CONCATENATED MODULE: ./src/ColorPicker/VaColorPickerPopup.vue?vue&type=script&lang=js&
 /* harmony default export */ var ColorPicker_VaColorPickerPopupvue_type_script_lang_js_ = (VaColorPickerPopupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/ColorPicker/VaColorPickerPopup.vue





/* normalize component */

var VaColorPickerPopup_component = normalizeComponent(
  ColorPicker_VaColorPickerPopupvue_type_script_lang_js_,
  VaColorPickerPopupvue_type_template_id_4cc131c4_render,
  VaColorPickerPopupvue_type_template_id_4cc131c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaColorPickerPopup = (VaColorPickerPopup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupToggle.vue?vue&type=template&id=7dee556e&
var VaSidebarGroupTogglevue_type_template_id_7dee556e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classObj},[_c('span',{class:_vm.iconObj},[(!_vm.open)?_c('va-icon',{attrs:{"type":"angle-right","size":"12px","margin":"0 6px 0 0"}}):_c('va-icon',{attrs:{"type":"angle-down","size":"12px","margin":"0 4.5px 0 0"}})],1)])}
var VaSidebarGroupTogglevue_type_template_id_7dee556e_staticRenderFns = []


// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupToggle.vue?vue&type=template&id=7dee556e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Sidebar/VaSidebarGroupToggle.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaSidebarGroupTogglevue_type_script_lang_js_ = ({
  name: 'VaSidebarGroupToggle',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classObj: function classObj() {
      var open = this.open;
      var classes = {};
      classes['va-sidebar-group-item-toggle'] = true;
      classes['va-sidebar-group-item-toggle-closed'] = !open;
      return classes;
    },
    iconObj: function iconObj() {
      var open = this.open;
      var classes = {};
      classes['va-sidebar-group-item-toggle-icon'] = true;
      classes['va-sidebar-group-item-toggle-icon-closed'] = !open;
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupToggle.vue?vue&type=script&lang=js&
 /* harmony default export */ var Sidebar_VaSidebarGroupTogglevue_type_script_lang_js_ = (VaSidebarGroupTogglevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Sidebar/VaSidebarGroupToggle.vue





/* normalize component */

var VaSidebarGroupToggle_component = normalizeComponent(
  Sidebar_VaSidebarGroupTogglevue_type_script_lang_js_,
  VaSidebarGroupTogglevue_type_template_id_7dee556e_render,
  VaSidebarGroupTogglevue_type_template_id_7dee556e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaSidebarGroupToggle = (VaSidebarGroupToggle_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ProgressTracker/VaProgressTracker.vue?vue&type=template&id=145a0662&
var VaProgressTrackervue_type_template_id_145a0662_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.round)?_c('ul',{class:"va-steps-round-con"},[_vm._l((_vm.labels),function(label,index){return [_c('li',{key:index,class:[_vm.getClassFromIndex(index)]},[_c('div',{class:"va-steps-wrap"},[_c('div',{class:"va-steps-round"})]),_c('label',[_vm._v(_vm._s(label))])])]})],2):_c('div',{class:"va-steps clearfix"},[_vm._l((_vm.labels),function(label,index){return [_c('div',{key:index,class:"va-steps-wrap"},[_c('div',{class:_vm.getClassFromIndex(index)},[_c('label',[_c('span',{class:"va-steps-round"}),_c('span',[_vm._v(_vm._s(label))])]),(index < _vm.labels.length - 1)?[_c('i',{class:"va-steps-triangle-right-bg"}),_c('i',{class:"va-steps-triangle-right"})]:_vm._e()],2)])]})],2)}
var VaProgressTrackervue_type_template_id_145a0662_staticRenderFns = []


// CONCATENATED MODULE: ./src/ProgressTracker/VaProgressTracker.vue?vue&type=template&id=145a0662&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/ProgressTracker/VaProgressTracker.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaProgressTrackervue_type_script_lang_js_ = ({
  name: 'VaProgressTracker',
  props: {
    labels: {
      type: Array,
      required: true
    },
    current: {
      type: Number,
      default: 1
    },
    round: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getClassFromIndex: function getClassFromIndex(index) {
      var ret = '';

      if (index === this.current - 1) {
        ret = 'current';
      } else if (index < this.current - 1) {
        ret = 'finished';
      } else {
        ret = 'todo';
      }

      return 'va-steps-' + ret;
    }
  }
});
// CONCATENATED MODULE: ./src/ProgressTracker/VaProgressTracker.vue?vue&type=script&lang=js&
 /* harmony default export */ var ProgressTracker_VaProgressTrackervue_type_script_lang_js_ = (VaProgressTrackervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/ProgressTracker/VaProgressTracker.vue?vue&type=style&index=0&lang=scss&
var VaProgressTrackervue_type_style_index_0_lang_scss_ = __webpack_require__("7704");

// CONCATENATED MODULE: ./src/ProgressTracker/VaProgressTracker.vue






/* normalize component */

var VaProgressTracker_component = normalizeComponent(
  ProgressTracker_VaProgressTrackervue_type_script_lang_js_,
  VaProgressTrackervue_type_template_id_145a0662_render,
  VaProgressTrackervue_type_template_id_145a0662_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaProgressTracker = (VaProgressTracker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderHeading.vue?vue&type=template&id=14b4a7cb&
var VaPlaceholderHeadingvue_type_template_id_14b4a7cb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"va-placeholder-heading"},[(_vm.image)?_c('div',{class:"va-placeholder-heading-image"}):_vm._e(),_c('div',{class:"va-placeholder-heading-content"},[_c('div',{class:"va-placeholder-heading-content-title"}),_c('div',{class:"va-placeholder-heading-content-subtitle"})])])}
var VaPlaceholderHeadingvue_type_template_id_14b4a7cb_staticRenderFns = []


// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderHeading.vue?vue&type=template&id=14b4a7cb&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Placeholder/VaPlaceholderHeading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaPlaceholderHeadingvue_type_script_lang_js_ = ({
  name: 'VaPlaceholderHeading',
  props: {
    image: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderHeading.vue?vue&type=script&lang=js&
 /* harmony default export */ var Placeholder_VaPlaceholderHeadingvue_type_script_lang_js_ = (VaPlaceholderHeadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/Placeholder/VaPlaceholderHeading.vue





/* normalize component */

var VaPlaceholderHeading_component = normalizeComponent(
  Placeholder_VaPlaceholderHeadingvue_type_script_lang_js_,
  VaPlaceholderHeadingvue_type_template_id_14b4a7cb_render,
  VaPlaceholderHeadingvue_type_template_id_14b4a7cb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VaPlaceholderHeading = (VaPlaceholderHeading_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"118cfc54-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/FilePicker/VaFilePicker.vue?vue&type=template&id=e6af6a5e&scoped=true&
var VaFilePickervue_type_template_id_e6af6a5e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"va-file-picker_wrapper"},[_c('div',{staticClass:"va-file-picker_input"},[_c('input',_vm._b({ref:"input",attrs:{"multiple":_vm.multiple,"type":"file"},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_c('div',{staticClass:"va-file-picker_trigger"},[_c('va-button',{staticClass:"va-file-picker_trigger-button",attrs:{"icon-after":"upload"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)]),(_vm.multiple && this.value)?_c('div',{staticClass:"va-file-picker_list"},_vm._l((_vm.value),function(file,index){return _c('div',{key:file.name,staticClass:"va-file-picker_list-item"},[_c('span',[_vm._v(_vm._s(file.name))]),_c('va-toggle-icon',{attrs:{"type":_vm.getMIMEIcon(file.type),"type-active":"times"},on:{"click":function($event){return _vm.onRemove(index)}}})],1)}),0):_vm._e()])}
var VaFilePickervue_type_template_id_e6af6a5e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/FilePicker/VaFilePicker.vue?vue&type=template&id=e6af6a5e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/FilePicker/VaFilePicker.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VaFilePickervue_type_script_lang_js_ = ({
  name: 'VaFilePicker',
  inheritAttrs: false,
  props: {
    preview: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    label: function label() {
      return this.multiple || !this.value ? 'Upload' : this.value.name;
    }
  },
  data: function data() {
    return {
      value: null
    };
  },
  methods: {
    getMIMEIcon: function getMIMEIcon(type) {
      switch (true) {
        case type.startsWith('image/'):
          return 'image';

        case type.startsWith('video/'):
          return 'video';

        case type.startsWith('audio/'):
          return 'file-audio';

        default:
          return 'file';
      }
    },
    onClick: function onClick() {
      this.$refs.input.click();
    },
    onChange: function onChange(evt) {
      this.value = this.multiple ? Array.from(evt.target.files).concat(this.value || []) : evt.target.files[0];
      this.$emit('input', this.value);
      this.$emit('change', this.value);
    },
    onRemove: function onRemove(index) {
      this.$emit('remove', this.value[index]);
      this.value.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./src/FilePicker/VaFilePicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var FilePicker_VaFilePickervue_type_script_lang_js_ = (VaFilePickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/FilePicker/VaFilePicker.vue?vue&type=style&index=0&id=e6af6a5e&scoped=true&lang=scss&
var VaFilePickervue_type_style_index_0_id_e6af6a5e_scoped_true_lang_scss_ = __webpack_require__("777d");

// CONCATENATED MODULE: ./src/FilePicker/VaFilePicker.vue






/* normalize component */

var VaFilePicker_component = normalizeComponent(
  FilePicker_VaFilePickervue_type_script_lang_js_,
  VaFilePickervue_type_template_id_e6af6a5e_scoped_true_render,
  VaFilePickervue_type_template_id_e6af6a5e_scoped_true_staticRenderFns,
  false,
  null,
  "e6af6a5e",
  null
  
)

/* harmony default export */ var VaFilePicker = (VaFilePicker_component.exports);
// CONCATENATED MODULE: ./src/Notification/VaNotificationMethod.js



var VaNotificationMethod_createNode = function createNode() {
  var $body = document.querySelector('body');
  var $node = document.createElement('div');
  $body.appendChild($node);
  return $node;
};

var VaNotificationMethod_open = function open(options) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  var title = options.title,
      message = options.message,
      effect = options.effect,
      width = options.width,
      duration = options.duration,
      onShow = options.onShow,
      onHide = options.onHide,
      onConfirm = options.onConfirm;
  /* eslint-disable no-new */

  new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    el: VaNotificationMethod_createNode(),
    data: function data() {
      return {
        show: false,
        pc: 'va'
      };
    },
    mounted: function mounted() {
      this.$refs.notification.open();
    },
    methods: {
      handleShow: function handleShow() {
        onShow && onShow();
      },
      handleConfirm: function handleConfirm() {
        onConfirm && onConfirm();
        this.$refs.notification.close();
      },
      handleHide: function handleHide() {
        onHide && onHide();
      },
      handleClose: function handleClose() {
        this.$refs.notification.close();
      },
      destroy: function destroy() {
        this.$destroy();
      }
    },
    render: function render(createElement) {
      return createElement(VaNotification, {
        ref: 'notification',
        props: {
          title: title,
          message: message,
          type: type || 'default',
          effect: effect || 'fade-right',
          width: width || '400px',
          duration: duration
        },
        on: {
          hide: this.handleHide,
          confirm: this.handleConfirm,
          show: this.handleShow,
          closed: this.destroy
        }
      }, []);
    }
  });
};

var info = function info(options) {
  VaNotificationMethod_open(options, 'info');
};

var success = function success(options) {
  VaNotificationMethod_open(options, 'success');
};

var warning = function warning(options) {
  VaNotificationMethod_open(options, 'warning');
};

var danger = function danger(options) {
  VaNotificationMethod_open(options, 'danger');
};

/* harmony default export */ var VaNotificationMethod = ({
  info: info,
  success: success,
  warning: warning,
  danger: danger
});
// CONCATENATED MODULE: ./src/components.js











































































var Components = {
  VaRow: VaRow,
  VaApp: VaApp,
  VaTab: VaTab,
  VaPage: VaPage,
  VaTabs: VaTabs,
  VaIcon: VaIcon,
  VaToggleIcon: VaToggleIcon,
  VaForm: VaForm,
  VaCard: VaCard,
  VaAffix: VaAffix,
  VaBadge: VaBadge,
  VaAlert: VaAlert,
  VaInput: VaInput,
  VaModal: Modal_VaModal,
  VaTable: VaTable,
  VaRange: VaRange,
  VaRadio: VaRadio,
  VaAside: VaAside,
  VaButton: VaButton,
  VaSelect: Select_VaSelect,
  VaOption: VaOption,
  VaToggle: VaToggle,
  VaMobile: VaMobile,
  VaColumn: VaColumn,
  VaTopbar: VaTopbar,
  VaSidebar: VaSidebar,
  VaDesktop: VaDesktop,
  VaTooltip: VaTooltip,
  VaMinibar: VaMinibar,
  VaLozenge: VaLozenge,
  VaLoading: VaLoading,
  VaInputOps: VaInputOps,
  VaRadioBtn: VaRadioBtn,
  VaCheckbox: VaCheckbox,
  VaDropdown: VaDropdown,
  VaFormItem: VaFormItem,
  VaTextarea: VaTextarea,
  VaTypeahead: VaTypeahead,
  VaCollapse: VaCollapse,
  VaCollapsePanel: VaCollapsePanel,
  VaAnimQueue: VaAnimQueue,
  VaAppConfig: VaAppConfig,
  VaContainer: VaContainer,
  VaTimepicker: Timepicker_VaTimepicker,
  VaFilePicker: VaFilePicker,
  VaRadioGroup: VaRadioGroup,
  VaDatepicker: Datepicker_VaDatepicker,
  VaPagination: VaPagination,
  VaBreadcrumb: VaBreadcrumb,
  VaPageHeader: VaPageHeader,
  VaMinibarItem: VaMinibarItem,
  VaPlaceholder: VaPlaceholder,
  VaButtonGroup: VaButtonGroup,
  VaCheckboxBtn: VaCheckboxBtn,
  VaNotification: VaNotification,
  VaColorPicker: VaColorPicker,
  VaSidebarGroup: Sidebar_VaSidebarGroup,
  VaCheckboxGroup: VaCheckboxGroup,
  VaSidebarHeader: VaSidebarHeader,
  VaBreadcrumbItem: VaBreadcrumbItem,
  VaPaginationItem: VaPaginationItem,
  VaProgressTracker: VaProgressTracker,
  VaPlaceholderText: VaPlaceholderText,
  VaColorPickerPopup: VaColorPickerPopup,
  VaSidebarGroupItem: VaSidebarGroupItem,
  VaPlaceholderImage: VaPlaceholderImage,
  VaSidebarGroupTitle: VaSidebarGroupTitle,
  VaSidebarGroupLevel: VaSidebarGroupLevel,
  VaPlaceholderHeading: VaPlaceholderHeading,
  VaCollapseTransition: VaCollapseTransition,
  VaSidebarGroupToggle: VaSidebarGroupToggle
};

var components_install = function install(Vue, locale) {
  for (var i in Components) {
    Vue.component(i, Components[i]);
  }

  Vue.directive('VaPosition', src_relocate);
  Vue.prototype.VaToast = VaToastMethod;
  Vue.prototype.VaModal = VaModalMethod;
  Vue.prototype.notification = VaNotificationMethod;
  Vue.prototype.VaLocale = locale || 'en';
  window.VaLocale = locale || 'en';
};

if (typeof window !== 'undefined' && window.Vue) {
  components_install(window.Vue);
}

Components.install = components_install;
/* harmony default export */ var components = (Components);
// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ var src = (components);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=vue-atlas.common.js.map